export const locale = {
    lang: 'fa',
    data: {
        HELLO: 'سلام',
        MG_ACCOUNTS: {
            BANK_ACCOUNTS: "حساب‌های بانکی",
            ALL: "همه",
            ACTIVE: "فعال",
            DIACTIVE: "غیرفعال",
            BANK_NAME: "نام بانک",
            CARD_NUM: "شماره کارت",
            NEW_CARD_NUM: "شماره کارت جدید",
            IBAN_NUMBER: "شماره شبا",
            CURRENCY_TYPE: "نوع ارز",
            STATUS: "وضعیت",
            ACTIVITY: "وضعیت",
            ADD_BANK_ACCOUNT: 'افزودن حساب بانکی',
            NO_BANK_ACC: 'حساب بانکی موجود نیست',
            NEW_BANK_WARNING: "زمان انتظار برای تایید اطلاعات حساب بانکی حداقل ۱ ساعت و حداکثر ۱ روز کاری می باشد.",
            ACTIVE_DIALOG_TITLE: 'آیا از غیر فعال‌سازی اطمینان دارید؟',
            ACTIVE_DIALOG_TEXT: 'در صورت غیر فعال کردن حساب امکان استفاده از حساب در بخش درخواست های شارژ و برداشت وجود نخواهد داشت.',
            BANK_ACCOUNT_NOT_REGISTERED: "حساب بانکی ثبت نشده است.",
            CANT_EDIT_IBAN: 'امکان ویرایش شماره شبا وجود ندارد',
            ADD_BANK: {
                ADD_BANK_ACCOUNT: 'افزودن حساب بانکی',
                CARD_NUMBER: 'شماره کارت',
                IR: 'IR',
                IBAN: 'شبا',
                APPROVED_BANKS: 'بانک‌های مورد تایید',
                EDIT: 'ویرایش',
            },
            EDIT_BANK: {
                EDIT_BANK_ACCOUNT: 'ویرایش حساب بانکی'
            },
            ALERT: {
                BANK_ACCOUN_OWNER_NAME: 'حساب بانکی باید به نام “{{fullname}}” باشد',
                CARD_NUMBER_BANK_INVALID: 'حساب های {{bankName}} مورد تایید نمی باشد  لطفا شماره کارت دیگری ثبت نمایید'
            }
        },
        MG_GENERAL: {
            CANCEL: 'انصراف',
            SAVE: 'ذخیره',
            VIEW_ALL: 'مشاهد همه',
            VIEW_LESS: 'مشاهده کمتر',
            VERIFY_PERSONAL_DATA_TITLE: 'اطلاعات شخصی شما تایید نشده است',
            VERIFY_PERSONAL_DATA_LINK: 'تایید اطلاعات',
            ACCEPT: 'تایید',
            LANGUAGE: 'زبان',
            CONTINUE: 'ادامه',
            SUCCESSFUL_OPERATION: 'عملیات موفق',
            DELETE: 'حذف کردن',
            DISPLAY_ORDER_FILTER: 'فیلتر ترتیب نمایش',
            DETAILS: 'مشخصات',
            NEXT: 'بعدی',
            PREV: 'قبلی',
            FILTER: 'فیلتر',
            SELECT_DATES: 'انتخاب تاریخ ها',
            ORDER: 'ترتیب',
            WITHDRAWALS: 'برداشتی‌ها',
            RECEIPTS: 'دریافتی‌ها',
            APPLY: 'تایید',
            FILTERS_AND_SORTS: 'فیلتر‌ها و ترتیب‌ها',
            COPY: 'کپی',
            FINISH: 'اتمام'
        },
        NAV: {
            LOCAL_WITHDRAWAL: 'پرداخت محلی',
            E_MONEY_WITHDRAWAL: 'پرداخت پول الکترونیک',
            CRYPTO_WITHDRAWAL: 'پرداخت پول رمزارز',
            LOCAL_SEND: 'پرداخت محلی',
            TC_WALLET_SEND: 'پرداخت از کیف پول',
            EXCHANGE_LOCAL_PAYMENT: 'تبدیل کیف پول TC',
            BUY_LIST: 'لیست خریدها',
            BUY_VOUCHER: 'خرید ووچر',
            DASHBOARD: 'داشبورد',
            DEPOSIT: 'شارژ',
            WALLETS: 'کیف پول',
            WITHDRAW: 'برداشت',
            WITHDRAWAL: 'برداشت',
            BANK_ACCOUNTS: 'حساب های بانکی',
            SEND: 'ارسال',
            MY_ACCOUNTS: 'حسابهای من',
            E_MONEY_ACCOUNTS: 'حساب های پول الکترونیک',
            CRYPTOCURRENCY_ACCOUNTS: 'حساب های رمزارز',
            TC_ACCOUNTS: 'حسابهای TC',
            TRANSACTIONS: 'تراکنش ها',
            VOUCHER: 'ووچر ',
            POINT: 'امتیاز',
            WITHDRAW_LIST: 'لیست برداشت ها',
            FRIENDS: 'دوستان',
            SUPPORTS: 'پشتیبانی',
            TICKETS: 'تیکت ها',
            FAQ: 'پرسش های متداول',
            PROFILE: 'پروفایل',
            SETTING: 'تنظیمات',
            NEW_REQUEST: 'درخواست جدید',
            MY_WALLETS: 'کیف پول های من',
            EXCHANGE: 'تبدیل',
            SUPPORT: 'پشتیبانی',
            RECIEVE: 'دریافت',
            RECIEVEـTC_WALLET: 'دریافت از کیف پول TC',
            LOCAL_RECIEVE: 'دریافت محلی',
            TC_WALLET: 'کیف پول Tc',
            DEPOSIT_MONEY_CURRENCY: 'پرداخت محلی',
            DEPOSIT_CRYPTO: 'پرداخت رمزارز',
            DEPOSIT_ELECTRONIC_MONEY: 'پرداخت پول الکترونیک',
            DIGITAL_CURRENCY_PAYMENT: 'پرداخت ارز دیجیتال',
            DIGITAL_CURRENCY_PAYMENT_WITHDRAWAL: 'پرداخت ارز دیجیتال',
            ANNOUNCEMENT: 'اطلاعیه ها',
            PAYMENT_GATEWAY: "درگاه پرداخت",
            MY_REQUEST_HISTORY: 'درخواست های من',
            CLIENT_REQUEST_HISTORY: 'درخواست های کاربر',
            SETTLEMENT_REQUEST_HISTORY: 'درخواست های تسویه حساب',
            P2P: 'P2P',
            P2P_MY_ORDERS: 'سفارش‌های من',
            P2P_NEW_AD: 'ساخت آگهی فروش',
            P2P_AD_LISTINGS: 'خرید از P2P',
            AFFILIATE_SUP: 'درآمدزایی',
            AFFILIATE_PROGRAM_SUP: 'برنامه همکاری',
            AFFILIATE_REQUEST: 'ارسال درخواست همکاری',
            AFFILIATE_MY_PROGRAM: 'برنامه افیلیت من',
            AFFILIATE_VIEW_TRANSACTIONS: 'تاریخچه برنامه من',
            AFFILIATE_MY_INTRODUCTION_PROGRAM_SUP: 'ارسال درخواست همکاری',
            AFFILIATE_ENTER_CODE: 'کد معرف',
            AFFILIATE_CASHBACK: 'تاریخچه کش بک',
            BANK_TRANSFER_PAYMENT: 'پرداخت حواله بانکی',
            TRANSACTIONS_LIST: 'لیست تراکنش‌ها',
            SOCIAL_MEDIA: 'رسانه‌ها'
        },
        DASHBOARD: {
            CURRENCY: 'ارز',
            EXCHANGE_RATE: {
                EXCHANGE_RATE: 'نرخ تبدیل',
                FIAT_EXCHANGE_RATE: 'نرخ تبدیل فیات',
                CRYPTO_EXCHANGE_RATE: 'نرخ تبدیل رمزارز',
                BOTH_EXCHANGE_RATE: 'نرخ تبدیل فیات به رمزارز',
                SELL: 'فروش',
                BUY: 'خرید'
            },
            POINTS: {
                WITHDRAW: 'برداشت',
                TRANSACTIONS: 'تراکنش ها',
                MY_POINTS: 'امتیازهای من',
            },
            TRANSFORM: {
                THE_ONLY_TRANSFER_OPPORTUNITY: 'فرصت باقیمانده جهت انتقال تمدید شد!!!',
                CLICK: 'کلیک کنید !',
                MORE_DETAILS: 'جزییات بیشتر',
                TRANSFER: 'انتقال',
                DAY: 'روز',
                MINUTE: 'دقیقه',
                SECOND: 'ثانیه',
                HOURS: 'ساعت',
                CRYPTO_REVELUTION: 'تحول رمزارزها در TopChange!',
                TRANSFER_TO_GC_P_ONE: 'اﻧﺘﻘﺎل ﮐﯿﻒ ﭘﻮل ﻫﺎی رﻣﺰارز شما از TopChange',
                TRANSFER_TO_GC_P_TWO: ' ﺑﻪ ﺑﺴﺘﺮی ﺟﺪﯾﺪ و ﺗﺨﺼﺼﯽ ﺑﻪ ﻧﺎم GreenChange',
                NEW_ENVIROMENT: 'محیط جدیدی برای مبادلات اتوماتیک رمز ارزها'
            },
            ACTIVE_REQUESTS: {
                ACTIVE_REQUESTS: 'درخواست های فعال',
                TRACKING_NUMBER: 'شماره پیگیری',
                AMOUNT_AND_TYPE: 'نوع و مبلغ',
                CHANGE_STATUS_DATE: 'زمان تغییر وضعیت',
                STATUS: 'وضعیت',
                MESSAGE: 'پیام',
                INFO: 'برای اطلاع از آخرین وضعیت درخواست‌ها بر روی دکمه بروزرسانی کلیک کنید'
            },
            DOWNLOAD_APP: {
                TITLE: 'دانلود اپلیکیشن',
                DOWNLOAD: 'دانلود مستقیم'
            },
            WALLET: 'کیف پول',
            SHOW_ALL: 'نمایش همه',
        },
        BREAD_CRUMB: {
            NOTIFICATION: 'اعلان ها',
            LOCAL_WITHDRAWALS_LIST: 'لیست برداشت های محلی',
            E_MONEY_WITHDRAWALS_LIST: 'لیست برداشت های پول الکترونیک',
            LOCAL_SEND_LIST: 'لیست پرداخت های محلی',
            TC_WALLET_SEND_LIST: 'لیست پرداخت ها از کیف پول',
            LOCAL_RECEIVE_LIST: 'لیست دریافت های محلی',
            EXCHANGE_LOCAL_LIST: 'لیست تبدیل های کیف پول TC',
            ANOUNNCEMENT: 'اطلاعیه ها',
            MONEY_CURRENCY: 'روش های پرداخت محلی',
            DASHBOARD: 'داشبورد',
            DEPOSIT: 'شارژ کیف پول',
            WITHDRAWAL: 'برداشت از کیف پول',
            WITHDRAWAL_BANK: 'برداشت - حواله بانکی',
            SEND: 'ارسال',
            TRANSFER: 'انتقال',
            BANK: 'بانک',
            CASH: 'نقدی',
            CREDIT: 'شرکت ها',
            ONLINE: 'آنلاین',
            HISTORY: 'لیست درخواست ها',
            ELECTRONIC_MONEY: 'پول های الکترونیک',
            NOTIFICATIONS: 'اطلاعیه ها',
            P2P: 'P2P',
            MY_AFFILIATE_PROGRAM: 'برنامه افیلیت من',
            MY_AFFILIATE_HISTORY: 'تاریخچه برنامه من',
            SELL_SUCCESSFUL: 'فروش موفقت آمیز',
            BUY_SUCCESSFUL: 'خرید موفقت آمیز',
            MY_ORDERS: 'سفارش‌های من',
            ADVERTISE: 'آگهی های من',
            REGISTER_NEW_AD: 'ثبت آگهی جدید',
            SELL: 'فروش ارز',
            FRIENDS: 'دوستان',
            ACCOUNTS: 'حساب ها',
            PROFILE: 'پروفایل',
            SUPPORT: 'پشتیبانی',
            WALLETS: 'کیف پول ها',
            WALLET_TC: 'کیف پول TC',
            MY_WALLETS: 'کیف پول های من',
            EXCHANGE: 'تبدیل',
            POINT: 'امتیاز',
            ADD_WALLET: 'ایجاد کیف پول',
            EDIT_WALLET: 'ویرایش کیف پول',
            SETTING: 'تنظیمات',
            FAQ: 'پرسش های متداول',
            TICKETS: 'تیکت ها',
            ADD_TICKET: 'تیکت جدید',
            CATEGORY: 'دسته بندی',
            MY_ACCOUNTS: 'حساب های من',
            ADD_BANK_ACCOUNT: 'افزودن حساب جدید',
            ADD_Service_ACCOUNT: 'افزودن حساب پول الکترونیک جدید',
            EDIT_ACCOUNT: 'ویرایش',
            TC_ACCOUNTS: 'حساب های TC',
            ADD_SERVICE_ACCOUNT: 'افزودن حساب جدید',
            TRANSACTIONS: 'تراکنش ها',
            VOUCHER: 'ووچر',
            NEW: 'جدید',
            DETAIL: 'جزئیات',
            MONEY_CURRENCY_LIST: 'لیست درخواست های پرداخت محلی',
            ELECTRONIC_MONEY_LIST: 'لیست درخواست های پول الکترونیک',
            CRYPTO_LIST: 'لیست درخواست های رمزارز',
            DIGITAL_CURRENCY: 'ارز دیجیتال',
            CRYPTO_WITHDRAWAL_LIST: 'لیست برداشت های رمزارز',
            REQUEST_DETAIL: 'جزئیات درخواست',
            NEW_REQUEST: 'درخواست جدید',
            TC_WALLET_LIST: 'لیست درخواست های کیف پول',
            RECEIVE_TC_WALLET_LIST: 'لیست دریافتی ها از کیف پول TC',
            RECEIVE_OTHER_WAYS_LIST: 'لیست دریافتی ها از روش های دیگر',
            RECEIVE_DETAIL: 'جزئیات دریافت',
            POINT_LIST: 'لیست امتیاز ها',
            TRANSACTIONS_LIST: 'لیست تراکنش‌ها',
            BUY: 'خرید',
            LIST: 'لیست',
            ADD_ACCOUNT: 'افزودن حساب',
            EXCHANGE_SERVICE_LIST: 'لیست تبدیل های سرویس',
            TRANSFER_INFO: 'آموزش انتقال',
            MY_REQUEST_HISTORY: 'درخواست های من',
            CLIENT_REQUEST_HISTORY: 'درخواست های مشتری',
            SETTLEMENT_REQUEST_HISTORY: 'درخواست های تسویه حساب',
            SEND_AFFLIATE_REQUEST: "ارسال درخواست همکاری",
            INVITEE: 'برنامه معرفی من',
            IDENTIFICATION_CODE: 'کد معرف',
            AFFILIATE_PROGRAM: 'برنامه افیلیت',
            INVITEE_HISTORY: 'تاریخچه کش بک',
            PAYMENT_GATEWAY: "درگاه پرداخت",
            AFFILIATE: 'برنامه درآمدزایی',
            AFFILIATE_REQUEST: 'ارسال درخواست  همکاری',
            INVITEE_ENTER_CODE: 'کد معرف',
            INVITEE_INDEX: 'کد دعوت',
            CRYPTO: 'ارز دیجیتال',
            MY_ADS: 'آگهی‌های من',
            AUTHENTICATION: 'احراز هویت',
            CHANGE_MOBILE_NUMBER: 'تغییر شماره موبایل',
            TWO_FACTOR_AUTHENTICATION: 'احراز هویت دو مرحله‌ای',
            DIRECT_DEPOSIT_TITLE: 'حواله بانکی',
            BANK_TRANSFER_PAYMENT: 'پرداخت حواله بانکی',
            TRANSACTION_DETAIL: 'جزئیات تراکنش',
            CHAT_WITH_SELLER: 'چت با فروشنده',
            CHAT_WITH_BUYER: 'چت با خریدار',
            DEPOSIT_OFFLINE: 'واریز آفلاین',
            CARD_OFFLINE_DEPOSIT: 'واریز کارت به کارت آفلاین',
            SOCIAL_MEDIA: 'رسانه‌های اجتماعی',
        },
        QUICK_ACCESS: {
            DEPOSIT: 'شارژ',
            DEPOSIT_NEW: 'شارژ جدید',
            DEPOSIT_LOCAL_PAYMENT_LIST: 'لیست درخواست های پرداخت محلی',
            DEPOSIT_E_MONEY_LIST: 'لیست درخواست های پول الکترونیک',
            WITHDRAWAL: 'برداشت',
            WITHDRAWAL_NEW: 'برداشت جدید',
            WITHDRAWAL_LOCAL_PAYMENT_LIST: 'لیست برداشت های محلی',
            WITHDRAWAL_E_MONEY_LIST: 'لیست برداشت های پول الکترونیک',
            SEND: 'ارسال',
            SEND_NEW: 'ارسال جدید',
            SEND_TC_WALLET_LIST: 'لیست ارسال ها از کیف پول',
            SEND_TC_WALLET: 'ارسال از کیف پول',
            SEND_LOCAL_PAYMENT_LIST: 'لیست ارسال های محلی',
            RECIEVE: 'دریافت',
            RECIEVE_TC_WALLET_LIST: 'لیست دریافتی ها از کیف پول',
            RECIEVE_LOCAL_LIST: 'لیست دریافت های محلی',
            EXCHANGE: 'تبادل',
            EXCHANGE_NEW_LOCAL_PAYMENT: 'تبادل محلی جدید',
            EXCHANGE_NEW_E_MONEY: 'تبادل پول الکترونیک جدید',
            EXCHANGE_LOCAL_PAYMENT_LIST: 'لیست تبادل های محلی',
            VOUCHER: 'ووچر',
            VOUCHER_LIST: 'لیست درخواست ها',
            BUY: 'خرید',
            LIST: 'لیست',
            POINT: 'امتیاز',
            WITHDRAWAL_POINT_LIST: 'لیست برداشت های امتیاز',
            WITHDRAWAL_POINT: 'برداشت امتیاز',
            WITHDRAWAL_POINT_TRANSACTIONS: 'تراکنش های امتیاز',
            WALLET_TRANSACTIONS: 'تراکنش های کیف پول',
            TRANSACTIONS: 'تراکنش ها',
            WALLET: 'کیف پول',
            MY_WALLETS: 'کیف پول های من',
            ACCOUNTS: 'حساب ها',
            MY_ACCOUNTS: 'حساب های من',
            NEW_WALLET: 'کیف پول جدید',
            NEW_E_MONEY_ACCOUNT: 'حساب پول الکترونیکی جدید',
            NEW_BANK_ACCOUNT: 'حساب بانکی جدید',
            TC_ACCOUNTS: 'حساب های TC',
            FRIENDS: 'دوستان',
            MY_FRIENDS: 'دوستان من',
            SUPPORT: 'پشتیبانی',
            TICKETS: 'تیکت',
            NEW_TICKET: 'تیکت جدید',
            FAQ: 'پرسش های متداول',
            SETTING: 'تنظیمات',
            PROFILE: 'پروفایل',
            NEW_LOCAL_PAYMENT: 'درخواست محلی جدید',
            NEW_E_MONEY: 'درخواست پول الکترونیک جدید',
            NEW: 'جدید',
            LOCAL_PAYMENT_LIST: 'لیست درخواست های محلی',
            E_MONEY_LIST: 'لیست درخواست های پول الکترونیک',
            EXCHANGE_NEW: 'تبادل جدید',
            BUY_VOUCHER: 'خرید ووچر',
            CHANGE: 'تغییر',
            CHANGE_WITH: 'تغییر "{{title}}" با ...',
            ALERT: {
                SAVE_CHANGE_SUCCESSFULLY: 'ذخیره ی تغییرات با موفقیت انجام شد'
            }
        },
        ANNOUNCEMENT: {
            ARCHIVE: 'آرشیو',
            ACTIVE_ANNOUNCEMENTS: 'اطلاعیه های فعال',
            MORE: 'بیشتر',
            VIDEO: {
                TITLE: 'تتر به تاپ‌چنج بازگشت!',
                SUBTITLE: 'تغییرات کوچک نتایج بزرگ',
                TEXT: 'پازل خدمات مالی ما کامل شد.',
                TEXT1: 'از امروز با سرعت و امنیت بیشتری تراکنش انجام دهید.',
                TEXT2: '3- کارمزد صفر',
                TEXT3: '4- انتقال سریع‌تر به حساب بانکی',
                TEXT4: '5- امنیت بالای معاملات',
                TEXT31: 'صفحه ی راهنمای برداشت',
                TEXT32: 'ما مراجعه کنید'
            },
            ALERT: {
                NO_CONTENT: 'محتوایی برای نمایش وجود ندارد'
            }
        },
        PISHING: {
            PISHING: 'فیشینگ',
            IS_AN_OPERATION_OF_DECEPTION: 'یک عملیات جعل و فریب است!',
            PISHING_TEXT: 'مطابق قوانین و مقررات، مسئولیت همه تراکنش‌ها و مبادلاتی که از طریق حساب و کارت بانکی شهروندان انجام می‌شود، به عهده دارنده صاحب حساب است و هیچ ادعایی مبنی بر اجاره دادن حساب برای مراجع قانونی، مالیاتی، انتظامی و قضائی قابل قبول نیست. در صورتی که فردی حساب و کد ملی خود را به فرد دیگری اجاره ‌دهد و به نحو فوق وجوهی که منشا آن ها از اعمال مجرمانه بوده را در حساب خود نگهداری ‌کند یا موجب نقل ‌و انتقال آن ‌شود، علاوه بر معاونت در جرم اصلی و تحمل مجازات مقرر برای آن جرم، به جرم پولشویی نیز، محکوم می‌شود.'
        },
        EVENT: {
            TITLE1: ' تحول رمزارزها در TopChange!',
            DESCRIPTION1: ' انتقال کیف پول های رمزارز به بستری جدید و تخصصی به نام GreenChange',
            DESCRIPTION2: ' محیطی جدید برای مبادلات اتوماتیک رمزارزها',
            TITLE2: 'GreenChange',
            BTN: 'جهت کسب اطلاعات بیشتر کلیک کنید!',
            IMG: 'assets/media/images/events/PopUp-Transfer-fa.png'
        },
        AUTH: {
            REQUIRED: 'اجباری',
            NO_ACCOUNT: 'حساب کاربری ندارید؟',
            FORGOT_PASSWORD: 'کلمه عبور خود را فراموش کرده ام',
            TC_TERMS: 'قوانین TC',
            LOGOUT: 'خروج',
            RESEND_CODE: 'ارسال مجدد کد',
            WE_SENT_ACTIVATION_CODE_TO_PHONE: 'کد تایید برای شماره تلفن همراه شما ارسال شد',
            ERROR_500: 'خطایی رخ داده است؛ لطفا بعد از چند لحظه صفحه را مجددا بارگزاری کرده و دوباره امتحان کنید.',
            ERROR_404: 'درخواست یافت نشد .',
            ERROR_400: 'درخواست نامعتبر است .',
            ACCESS_DENIED: 'شما به این صفحه دسترسی ندارید',
            CONNECTION_ERROR: 'اتصال به اینترنت وجود ندارد.',
            INVALID_CAPTCHA: 'کپچا نامعتبر می باشد',
            CONFIRM_MOBILE: 'تائید شماره تلفن همراه',
            CONFIRM_PERSONAL: 'احراز هویت اطلاعات فردی',
            CONFIRM_PICTURE: 'احراز هویت عکس',
            CONFIRM_ADDRESS: 'تائید آدرس',
            ERROR_UNKNOWN: "در پردازش درخواست خطایی رخ داد. لطفاً دوباره تلاش کنید.",
            LOGIN: {
                TITLE: 'ورود',
                SUBMIT: 'ورود'
            },
            TWO_FACTOR: {
                TITLE: 'تائیدیه امنیتی',
                CODE: 'کد تایید دو مرحله ای',
                DESCRIPTION1: 'لطفا کد تایید دو مرحله ای خود را وارد نمایید.',
                DESCRIPTION2: '',
                HINT: 'لطفا کد {{value}} - رقمی Authenticator را وارد کنید',
                SUBMIT: 'ارسال',
                VALIDATION_CODE: 'لطفاً کد احراز هویت را وارد کنید'
            },
            RECOVER: {
                TITLE: 'بازیابی کلمه عبور',
                DESC1: 'اگر کلمه عبور خود را فراموش کرده اید',
                DESC2: 'از طریق ایمیل یا پیامک آن را بازیابی کنید.',
                PASS_NOT_SAME: 'تکرار کلمه عبور باید با کلمه عبور برابر باشد',
                CONFIRM_PASS: 'تکرار کلمه عبور',
                BY_EMAIL: {
                    CODE_SENT: 'کد تایید به ایمیل شما ارسال شد.',
                    HINT: 'لطفا کد تایید ارسال شده به ایمیل خود را وارد نمایید',
                    SPAM_HINT: "اگر کد را در صندوق ورودی خود دریافت نکردید، لطفاً پوشه اسپم خود را بررسی کنید.",
                },
                BY_SMS: {
                    CODE_SENT: 'کد تایید به شماره تلفن همراه شما پیامک شد',
                    HINT: 'لطفا کد پیامک شده را وارد نمایید',
                },
                EMAIL: 'ایمیل',
                SMS: 'پیامک',
                SUCCESS: {
                    TITLE: 'تغییر کلمه عبور با موفقیت انجام شد',
                    DESC: 'شما هم اکنون می توانید به حساب کاربری خود وارد شوید',
                    GO_TO_LOGIN: 'برگشت به صفحه ورود'
                }

            },
            REGISTER: {
                TITLE: 'ثبت نام',
                LOGIN: 'ورود',
                YOUR_EMAIL: 'ایمیل شما',
                SUBMIT_EMAIL: 'ثبت',
                SUBMIT_CONFIRM_EMAIL: 'تایید',
                SUBMIT_FORM: 'ایجاد حساب',
                CODE: 'کد تایید',
                ALREADY_HAVE_ACCOUNT: 'حساب کاربری دارم؟',
                ENTER_EMAIL: 'لطفا ایمیل خود را وارد نمایید',
                SENT_EMAIL_TEXT: 'یک ایمیل حاوی کد {{value}} رقمی برای شما ارسال گردید',
                SENT_SMS_TEXT: 'یک پیامک حاوی کد {{value}} رقمی برای شما ارسال گردید',
                PLEASE_COMPLETE_YOUR_FORM: 'لطفا فرم زیر را کامل نمایید',
                DESC: 'توضیحات',
                SUCCESS: {
                    TITLE: 'ثبت نام با موفقیت انجام شد',
                    DESC: 'هم اکنون می توانید وارد حساب کاربری خود شوید',
                    GO_TO_LOGIN: 'ورود به حساب کاربری'
                }
            },
            INPUT: {
                EMAIL: 'ایمیل',
                PHONE: 'شماره تلفن همراه',
                FIRSTNAME: 'نام',
                LASTNAME: 'نام خانوادگی',
                COUNTRY: 'کشور',
                I_ACCEPT: 'پذیرفتن',
                TC_TERM: 'قوانین TC',
                FULLNAME: 'نام کامل',
                PASSWORD: 'کلمه عبور',
                USERNAME: 'نام کاربری',
                NEW_PASSWORD: 'کلمه عبور جدید',
                GENDER: 'جنسیت',
                NEW_CONFIRM_PASS: 'تایید کلمه عبور جدید',
            },
            VALIDATION: {
                INVALID_EMAIL: 'ایمیل وارد شده نامعتبر است',
                PASSWORD: {
                    COUNT_CHARACTER: '‏8-32 کاراکتر',
                    UPPERCASE_LETTER: 'حداقل یک حرف بزرگ [A-Z]',
                    HAS_NUMBER: 'حداقل یک عدد [0-9]'
                }
            }
        },
        NEW_AUTH: {
            WELOCOME: 'به تاپ‌چنج خوش آمدید',
            ENTER_EMAIL: 'لطفا ایمیل خود را وارد کنید.',
            ENTER_VALID_EMAIL: 'لطفا ایمیل را به درستی  وارد کنید!',
            CONTINUE: 'ادامه',
            CONFIRM_CODE: 'تایید کد',
            ENTER_CODE_SENT: 'لطفاً کد ارسال‌شده به {{value}} را وارد کنید.',
            CHECK_SPAM: '(پوشه Spam رو هم چک کنید)',
            CONFIRM: 'تایید',
            VERIFY: 'تایید',
            INCORRECT_CODE: 'کد وارد‌شده اشتباه است.',
            RESEND: 'ارسال مجدد',
            REGISTER: 'ثبت نام',
            REGISTRATION: 'ثبت‌نام',
            SET_PASSWORD: 'لطفاً رمز عبوری امن برای حساب خود تعیین کنید.',
            PASSWORD: 'رمز عبور',
            REPEAT_PASSWORD: 'تکرار رمز عبور',
            MORE_THAN_8: 'بیشتر از ۸ حرف',
            NUMBERS: 'عدد یا علائم',
            UPPERCASE: 'حرف بزرگ',
            REFERRAL_CODE: 'کد معرف ',
            OPTIONAL: '(اختیاری)',
            PASSWORDS_NOT_MATCH: 'رمز‌های عبور همخوانی ندارند.',
            TERMS: ' <span>من</span><span class=\"role-text\">قوانین و مقررات</span><span>را خوانده‌ام و با آن موافقم.</span>',
            LOGIN: 'ورود',
            ENTER_EMAIL_PASSWORD: 'لطفا ایمیل و رمز عبور خود را وارد کنید.',
            FORGET_PASSWORD: 'فراموشی رمز',
            AUTHENTICATOR_CODE: 'کد تایید دو مرحله ای',
            ENTER_AUTHENTICATOR_CODE: 'کد تأیید ارسال‌شده به اپلیکیشن احراز هویت خود را وارد کنید.',
            DONT_ACCESS_CODE: 'به کد دسترسی ندارید؟',
            REMOVE_TWO_FACTOR: 'لطفا برای حذف کد دو عاملی با پشتیبانی تماس بگیرید.',
            ONLINE_SUPPORT: 'پشتیبانی آنلاین',
            SEND_CODE: 'ارسال کد',
            SEND_CODE_AGAIN: 'ارسال کد مجدد',
            TC_TERMS: 'قوانین و مقررات TC',
            VALIDATION: {
                MIN_LENGTH: '{{name}} باید {{value}} رقم باشد',
                MAX_LENGTH: '{{name}} باید {{value}} رقم باشد',
            },
            FORGET_PASSWORD_PAGE: {
                TITLE: 'فراموشی رمز عبور',
                SUBTITLE: 'لطفا برای بازیابی رمز عبور٬ ایمیل خود را وارد کنید.',
                ENTER_CODE_SENT: 'لطفاً کد ارسال‌شده به <span>{{value}}</span> را وارد کنید.',
                VALIDATION: {
                    EMAIL_FORMAT: 'لطفا ایمیل را به درستی  وارد کنید!',
                },
                RESET_PASSWORD: {
                    TITLE: 'رمز عبور جدید',
                    SUBTITLE: 'لطفاً رمز عبور جدید حساب خود را تعیین کنید.',
                    CHANGE_PASSWORD: 'تغییر رمز'
                },
                ALERT: {
                    SUCCESS_CHANGE_PASS_TITLE: 'رمز عبور شما با موفقیت تغییر یافت!',
                    SUCCESS_CHANGE_PASS_DESCRIPTION: 'برای ورود به حساب کاربری، لطفاً دوباره وارد شوید.',
                }
            },
            ALERT_TERMS: {
                TITLE: "توجه",
                DESC: "لطفاً شرایط استفاده از سایت را با دقت بخوانید. با دسترسی به این سایت و هر صفحه از آن، شما موافقت می کنید که مطابق با شرایط استفاده زیر عمل کنید. اگر با شرایط استفاده زیر موافق نیستید ، به این سایت یا صفحات آن دسترسی نداشته باشید."
            },
            TERMS_RULES: {
                VISITOR_RESPONSIBILITY: {
                    TITLE: "مسئولیت بازدید کنندگان",
                    DESC: "اطلاعات مربوط به این وب سایت و خدمات ارائه شده در اینجا برای توزیع و یا استفاده توسط هر شخص در هر کشور یا حوزه قضایی در نظر گرفته نشده است که در آن توزیع یا استفاده، خلاف قانون یا مقررات محلی باشد. هیچکدام از خدمات TopChange برای اشخاص ساکن در هر کشوری که ارائه چنین خدماتی مغایر قانون یا مقررات محلی باشد، در دسترس نیست. این مسئولیت بازدید کنندگان این وب سایت است که شرایط را رعایت کرده و از هرگونه قوانین و مقررات محلی که در آن مشروط هستند پیروی کنند. هیچ چیز در وب سایت TopChange نباید به عنوان وکالت برای خرید یا پیشنهادی برای فروش هر محصول یا خدمات به هر شخص دیگری در هر حوزه قضایی در نظر گرفته شود که در آن چنین پیشنهاد، دادخواست، خرید یا فروش طبق قوانین این صلاحیت غیرقانونی باشد."
                },
                SCOPE_OF_SERVICES: {
                    TITLE: "حوزه ی خدمات",
                    DESC: "این وب سایت توسط نام اختصاری TopChange اداره میشود. TopChange نه اپراتور پول الکترونیکی است و نه ارائه دهنده خدمات پرداخت. TopChange برای بازدیدکنندگان این وب سایت خدمات اطلاعاتی را برای تسهیل در خرید یا فروش پول الکترونیکی و کوپن الکترونیکی محبوب ترین شرکتهای پرداخت جهانی و ارائه پیش پرداخت کالا و خدمات خریداری شده توسط بازدید کنندگان از طریق اینترنت فراهم می کند."
                },
                REGISTER: {
                    TITLE: "ثبت نام",
                    DESC: "برای ثبت نام در وب سایت TC، بازدید کنندگان باید اطلاعات شخصی زیر را ارائه دهند: نام و نام خانوادگی واقعی؛ پست الکترونیک؛ شماره تلفن؛ آدرس محل اقامت؛ تاریخ تولد؛ کارت شناسایی شخصی (یا گذرنامه ملی یا گذرنامه مسافرت خارجی یا گواهینامه رانندگی)؛ عکس سلفی با کارت شناسایی شخصی. TC اطلاعات شخصی را با استفاده از هر روش موجود تأیید می کند. کیف پول TC بازدید کننده تا زمان تأیید تمام اطلاعات از عملکرد محدودی برخوردار است."
                },
                EXCLUSION_OF_WARRANTIES: {
                    TITLE: "محرومیت از ضمانت نامه ها",
                    DESC: "TC هیچگونه ضمانت صریح و ضمنی راجع به وب سایت TC ایجاد نمی کند. وب سایت TC «همانطور که هست» و «قابل استفاده است» در دسترس بازدید کنندگان قرار می گیرد و TC تضمین نمی کند که هرگونه نقص یا عدم دقت در آن اصلاح شود. TC تضمین نمی کند که وب سایت TC نیازهای شما را برآورده سازد، یا بدون وقفه، به موقع، ایمن و بدون خطا باشد."
                },
                DISCLAIMER: {
                    TITLE: "سلب مسئولیت و محدود کردن مسئولیت",
                    DESC: "در محدوده ی حداکثر مجاز در قانون، TC هیچ گونه مسئولیتی در قبال خسارت های پیش آمده، حادثه ای، ویژه، مستقیم یا غیرمستقیم ندارد. به استثنای آنچه در قانون مقرر شده است، TC هیچ مسئولیتی در قبال ضرر و زیان ناشی از علتی که TC در آن کنترل مستقیم ندارد نخواهد داشت. این شامل خرابی تجهیزات، دسترسی غیرمجاز، ویروس ها، سرقت، خطاهای اپراتور، آتش سوزی، جنگ، بیماری همه گیر، شورش، اقدام تروریستی و اقدام دولت می باشد."
                },
                INDEMNIFICATION: {
                    TITLE: "جبران خسارت",
                    DESC: "به عنوان شرط استفاده شما از وب سایت TC، شما موافقت می کنید که TC و ارائه دهندگان محتوای شخص ثالث آن را از هرگونه ادعا، ضرر، مسئولیت و هزینه (از جمله اما محدود به وکیل) ناشی از استفاده شما از وب سایت TC یا نقض این شرایط استفاده، بی ضرر نگه دارید."
                },
                CONFIDENTIALITY: {
                    TITLE: "محرمانه بودن",
                    DESC: "این وظیفه شماست که شماره کیف و رمزهای عبور TC را محرمانه نگه دارید. شما تأیید و موافقت می کنید که هرگونه دستورالعمل یا ارتباطی که از طریق وب سایت TC منتقل شود در معرض خطر شماست. شما تأیید و موافقت می کنید که TC حق دارد برای شناسایی شما به شماره کیف پول TC یا رمز عبور شما اعتماد کند و موافقت می کنید که این اطلاعات را به کسی که مجاز نیست افشا نمی کنید."
                },
                TERMINATION: {
                    TITLE: "خاتمه",
                    DESC: "TC این حق را برای خود محفوظ می دارد که استفاده شما از این وب سایت را در هر زمان و به هر دلیل، با یا بدون دلیل و بدون اطلاع قبلی خاتمه دهد."
                },
                SEVERABILITY: {
                    TITLE: "قابلیت جداسازی",
                    DESC: "اگر به هر دلیلی هر مفاد این شرایط استفاده نامعتبر یا غیرقابل اجرا تلقی شود، آن مقررات تا حداکثر مجاز اجرا می شود، و سایر مقررات به طور کامل و لازم باقی می مانند."
                }
            }
        },
        SETTING: {
            AUTHENTICATOR: "Authenticator",
            PAYMENT_GATEWAY: 'درگاه پرداخت',
            QUICK_ACCESS: 'دسترسی سریع',
            TITLE: 'تنظیمات',
            REQUEST_SECURITY_SETTING: 'امنیت',
            DEFAULT_LANGUAGE: 'زبان پیشفرض',
            TIME_ZONE: 'زمان محلی',
            LOCAL: 'محلی',
            GENERAL_TEXT: 'عمومی',
            SETTING_GENERAL: 'عمومی',
            REQUEST_SECURITY: 'امنیت',
            SETTING_REQUEST_SECURITY: 'امنیت',
            NOTIFY_SYSTEM: 'اعلان های سیستم',
            NOTIFY_SYSTEM_SETTING: 'اعلان های سیستم',
            WALLET_CHANGE: 'تغییر در کیف پول',
            POINT_CHANGE: 'تغییر امتیاز',
            SMS_CREDIT_CHANGE: 'تغییر اعتبار پنل پیامکی',
            EMAIL: 'ایمیل',
            SMS: 'پیامک',
            DASHBOARD: 'داشبورد',
            FRIEND: 'دوستان',
            POINT: 'برداشت امتیاز',
            INTERNAL_TRANSFER: 'انتقال داخلی',
            SERVICE: 'پول الکترونیک',
            EXCHANGE: 'تبدیل',
            VOUCHER: 'ووچر',
            POINT_WITHDRAWAL: 'برداشت امتیاز',
            LOGIN: 'ورود',
            REQUEST_PAYMENT: 'پرداخت ها',
            SEND: 'ارسال',
            RECEIVE: 'دریافت',
            REQUEST_MESSAGE: 'پیام درخواست ها',
            VERIFY_BANK_ACCOUNT: 'تایید حساب بانکی',
            SECURITY_SETTING: 'تنظیمات امنیتی',
            TICKET: 'تیکت',
            VERIFY_INFORMATION: 'تایید اطلاعات',
            PAYMENTS: 'پرداخت ها',
            VERIFY_INFO: 'تایید اطلاعات',
            FRIENDS: 'دوستان',
            MESSAGE: 'پیام ها',
            MY_CHANGES: 'تغییرات من',
            AUTO_CHANGES: 'تغییرات سیستم',
            DISABLED: 'غیر فعال',
            BETWEEN_MY_WALLETS: 'انتقال بین کیف پول ها',
            EXPERT_OR_FRIENDS_CHANGES: 'تغییرات دوستان یا مدیرسایت',
            SEND_CONFIRMATION_CODE: 'ارسال کد تایید',
            POSSIBLE_TO_HAVE_SECURITY_CODE: 'برای ذخیره تغییرات باید کد تایید ارسال شده به ایمیل و گوشی خود را وارد کنید.',
            REQUESTS: 'درخواست ها',
            VERIFIED: 'تایید ها',
            EXPERT_MESSAGES: 'پیام های پشتیبان',
            DISPLAY_LANGUAGE: "زبان نمایشی",
            DISPLAY_LANGUAGE_DESCRIPTION: "وب سایت با زبان انتخاب شده نمایش داده میشود.",
            NOTIFICATION_LANGUAGE: "زبان اعلان ها",
            NOTIFICATION_LANGUAGE_DESCRIPTION: "اعلانات با زبان انتخاب شده نمایش داده میشود.",
            TIME_ZONE_DESCRIPTION: "زمان محلی با زبان انتخاب شده نمایش داده میشود.",
            GENERAL: {},
            SECURITY: "امنیت",
            PLEASE_CONFIGURE_AUTHENTICATOR: "لطفا ابتدا احراز هویت دومرحله ای را فعال نمایید",
            ANTI_PHISHING_DES: 'از حساب خود دربرابر اقدامات فیشینگ محافظت کنید و اطمینان حاصل کنید که ایمیل های اطلاع رسانی شما فقط از Topchange دریافت شده است.',
            OFF: 'غیرفعال',
            ON: 'فعال',
            ENABLE: "فعالسازی",
            CHANGE: "تغییر",
            REMOVE: "حذف",
            ADVANCED_SECURITY: 'تنظیمات امنیتی پیشرفته',
            ANTI_PHISHING_CODE: 'کد ضد فیشینگ',
            NOTIFICATION: {},
            USER_QUICK_ACCESS: {},
            P2P: 'P2P',
            TWO_FACTOR_AUTHENTICATION: {
                TWO_FACTOR_AUTHENTICATION: "احراز هویت دو مرحله ای ",
                AUTHENTICATION: "احراز هویت",
                PROTECT_YOUR_ACCOUNT_AND_TRANSACTION: "حفاظت از حساب کاربری شما زمانیکه وارد سایت میشوید و ثبت درخواست انجام می دهید",
                HAVING_TROUBLE: "مشکلی دارید؟",
                ENABLE: "فعالسازی",
                CHANGE: "تغییر",
                REMOVE: "حذف",
                ENABLE_GOOGLE_AUTHENTICATOR: 'فعال سازی احراز هویت دو مرحله ای',
                CHANGE_GOOGLE_AUTHENTICATOR: 'تغییر احراز هویت دو مرحله ای',
                DOWNLOAD_APP: 'دانلود اپلیکیشن',
                DOWNLOAD_APP_DESC: 'از یک برنامه کاربردی در تلفن خود برای دریافت کد تایید دو مرحله ای استفاده کنید. توصیه می کنیم از برنامه هایی مانند: Google Authenticator ، One Password ، Authy ، LastPass Authenticator یا Microsoft Authenticator استفاده کنید. می توانید Google Authenticator را از لینک های مربوطه زیر دانلود کنید:',
                SCAN_QR_CODE: 'اسکن کد QR',
                SCAN_QR_CODE_DESC: 'کد QR کد را در اپلیکیشن Authenticator اسکن نمایید',
                SCAN_QR_CODE_CHANGE_DESC: 'کیف پول خود را که می خواهید شارژ کنید انتخاب کنید',
                SCAN_QR_CODE_DESC_MANUAL: 'اگر قادر به اسکن  کد QR نیستید ، لطفاً این کد را به صورت دستی در برنامه وارد کنید.',
                BACKUP_KEY: 'کلید پشتیبان',
                BACKUP_NEW_KEY: 'کلید پشتیبان جدید',
                BACKUP_KEY_DESC: 'کلید پشتیبان را در جایی امن ذخیره نمایید',
                BACKUP_KEY_DESC_MANUAL: 'این کلید به شما امکان می دهد در صورت از دست دادن تلفن ، احراز هویت خود را بازیابی کنید. در غیر این صورت ، بازنشانی Authenticator App حداقل 7 روز به طول می انجامد.',
                ENABLE_DESC: 'با تایید حساب خود، تایید دو مرحله را فعال کنید.',
                ENABLE_NEW_AUTH: 'فعالسازی احراز هویت دو مرحله ای جدید',
                ENABLE_NEW_AUTH_DESC: 'لطفا برای فعالسازی احراز هویت دو مرحله ای جدید ، کدهای تائیدیه را وارد نمایید',
                COMPLETE: 'تکمیل',
                DONE: 'انجام شد',
                ALERT_SUCCESS_ENABLE: 'احراز هویت دو مرحله ای حساب شما با موفقیت فعال شد.',
                ALERT_SUCCESS_CHANGE: 'تغییر احراز هویت دو مرحله ای شما با موفقیت انجام شد.',
                DOWNLOAD_FROM: 'دانلود از',
                LABEL_VERIFY_CODE: 'کد تأیید ایمیل',
                LABEL_TOTP_CODE: 'کد تایید دو مرحله ای',
                HINT_TOTP_CODE: ' کد 6 رقمی تایید دو مرحله ای خود را وارد نمایید.',
                HINT_VERIFY_CODE: 'اگر کد را در صندوق ورودی خود دریافت نکردید، لطفاً پوشه اسپم خود را بررسی کنید.',
                COPIED_SUCCESSFULLY: 'با موفقیت کپی شد',
                REMOVE_CURRENT: 'حذف فعلی',
                REMOVE_CURRENT_AUTH: 'حذف Authenticator فعلی',
                REMOVE_CURRENT_AUTH_DESC: 'با تأیید هویت ، Authenticator فعلی را حذف کنید',
                VERIFY_CHANGE: 'تأیید',
                VERIFY_CHANGE_TITLE: 'تایید کد دو مرحله ای فعلی ',
                VERIFY_CHANGE_DESC: 'برای تغییر احراز هویت دو مرحله ای فعلی ، کد نرم افزار Authenticator خود را تأیید کنید.',
                BACK_TO_SECURITY: 'بازگشت به امنیت',
                ARE_U_SURE: 'آیا از حذف احراز هویت دو مرحله ای اطمینان دارید؟',
                REQUESTE_DISABLE: 'درخواست هایی که از "احراز هویت دو مرحله ای" برای احراز هویت استفاده می کنند ، پس از غیرفعال کردن این روش غیرفعال می شوند.',
                DELETING_APP: 'حذف احراز هویت دو مرحله ای امنیت حساب شما را کاهش می دهد.',
                REMOVE_GOOGLE_AUTHENTICATOR: 'حذف احراز هویت دو مرحله ای',
                ALERT: {
                    GOOGLE_AUTHENTICATOR_SUCCESSFULLY_REMOVED: 'احراز هویت دو مرحله ای با موفقیت حذف شد!'
                }
            },
            ANTI_PHISHING: {
                ENABLE_ANTI_PHISHING_CODE: 'فعالسازی کد ضد فیشینگ',
                WHAT_IS_IT: 'کد ضد فیشینگ چیست؟',
                WHAT_IS_IT_ANS: 'یک کد ضد فیشینگ کدی است که به جلوگیری از اقدامات فیشینگ در وب سایت های جعلی TopChange یا آدرس ایمیل ها کمک می کند.',
                HOW_DOES_IT_WORK: 'چگونه کار می کند؟',
                HOW_DOES_IT_WORK_ANS: 'هنگامی که کد منحصر به فرد ضد فیشینگ خود را تنظیم کردید ، در همه ایمیل های اصلی TopChange گنجانده می شود.',
                ANTI_PISHING_CODE: 'کد ضد فیشینگ',
                CREAT_ANTI_PISHING_CODE: 'ساخت کد ضد فیشینگ',
                CHANGE_ANTI_PISHING_CODE: 'تغییر کد ضد فیشینگ',
                SHOW_ANTI_PISHING_CODE: 'نمایش کد ضد فیشینگ',
                PLZ_ENTER_CODE: 'لطفا کد 4-20 رقمی غیر از کاراکترهای خاص وارد کنید.',
                SECURITY_VERIFICATION: 'تاییدیه امنیتی',
                ENTER_SIX_DIGIT_FROM_APP: 'کد 6 رقمی را از اپلیکیشن اهراز هویت خود وارد کنید',
                TO_SECURE_YOUR_ACCOUNT_PLZ_COMPLETE_FLOWING_VERIFICATION: 'برای امنیت حساب خود ، لطفاً تأیید جاری را تکمیل کنید.',
                ANTI_PHISHING_CODE: 'کد ضد فیشینگ',
                OLD_ANTI_PHISHING_CODE: 'کد ضد فیشینگ قدیمی',
                CHANGE_CODE: 'تغییر کد',
                AUTHENTICATOR_CODE: 'کد تایید دو مرحله ای',

            },
            ALERT: {
                CHANGES_SAVED_SUCCESSFULLY: 'تغییرات با موفقیت ذخیره گردید.',
                ENTER_CODE_THAT_SENT_TO_EMAIL_AND_PASSWORD: 'لطفا کد {{codeLength}} رقمی ارسال شده به {{email}} و {{phone}} را وارد نمایید.'
            }
        },
        FRIENDS: {
            FRIEND: 'دوست',
            MY_FRIENDS: 'دوستان من',
            FRIENDS_REQUEST: 'درخواست های  دوستی',
            SENT_REQUEST: 'درخواست های ارسال شده',
            BLOCKED_USER: 'مسدود شده ها',
            ACCEPT: 'پذیرش',
            REJECT: 'ردکردن',
            UNBLOCK: 'لغو مسدود کردن',
            MORE: 'نمایش بیشتر',
            UNFRIEND: 'لغو دوستی',
            BLOCK: 'مسدود کردن ',
            DEPOSIT: 'شارژ حساب',
            WALLETS: 'کیف پول ها   ',
            SEND_FRIEND_REQUEST: 'ارسال درخواست دوستی',
            SEND_REQUEST: 'ارسال درخواست',
            ADD_FRIEND: 'افزودن دوست',
            SEND: 'Send',
            ALERT: {
                SUCCECC_REJECT: 'درخواست دوستی رد شد',
                SUCCECC_ACCEPT: 'درخواست دوستی تایید شد',
                SUCCECC_DELETE: 'درخواست دوستی حذف شد',
                SUCCECC_DELETE_FIREND: 'کاربر مورد نظر از لیست دوستان شما حذف شد',
                SUCCECC_BLOCK: 'کاربر مورد نظر مسدود شد',
                REQUEST_SENT_SUCCESSFULLY: 'درخواست دوستی با موفقیت ارسال شد',
                CONFIRM_DELETE_REQUEST: 'آیا از حذف این درخواست اطمینان دارید؟',
                CONFIRM_REJECT_REQUEST: 'آیا از رد کردن این درخواست اطمینان دارید؟',
                REQUEST_SENT_USER_NOT_FOUND: 'کاربر مورد نظر در سیستم وجود ندارد. دعوت شما از طریق ایمیل برای ایشان ارسال گردید'



            },
            ALERT_DELETE: 'آیا از حذف کاربر از دوستان خود اطمینان دارید؟',
            SEND_FRIEND_REQUEST_HINT: 'برای ارسال درخواست دوستی ایمیل فرد مور نظر را وارد کنید. در صورت وجود کاربر درخواست دوستی برای او ارسال میشود'
        },
        ACCOUNTS: {
            CARD_NUMBER: 'شماره کارت',
            CRYPTO: 'رمزارز',
            ACCOUNT_NUMBER: 'شماره حساب',
            IBAN_NUMBER: 'شماره شبا',
            SERVICE: 'پول الکترونیک',
            SERVICES: 'ارز های الکترونیک',
            BANKS: 'بانک ها',
            BANK: 'بانک',
            SELECT_BANK: 'انتخاب بانک',
            TAG: 'تگ',
            ACCOUNTS_INFORMATION: 'اطلاعات حساب',
            ACCOUNTS: 'حساب ها',
            ACCOUNT: 'حساب',
            ACCOUNT_NO: 'شماره حساب',
            CARD_NO: 'شماره کارت',
            TC_BANK_ACCOUNT: 'حساب بانکی TC',
            NEW_SERVICE: 'حساب پول الکترونیک جدید',
            NEW_CRYPTO: 'حساب رمزارز جدید',
            NEW_BANKS: 'حساب بانکی جدید',
            BRANCH_CODE: 'کد شعبه',
            BANK_NAME: 'نام بانک',
            SWIFT_CODE: 'کد سویفت',
            OWNER: 'صاحب حساب',
            BANK_ADDRESS: 'آدرس بانک',
            EDIT_BANK_ACCOUNT: 'ویرایش حساب بانکی',
            ADD_BANK_ACCOUNT: 'حساب بانکی جدید',
            MY_ACCOUNT: 'حساب من',
            TC_ACCOUNT: 'حساب TC',
            NEW_SERVICE_ACCOUNT: 'حساب پول الکترونیک جدید',
            EDIT_SERVICE_ACCOUNT: 'ویرایش حساب پول الکترونیک',
            EDIT_CRYPTO_ACCOUNT: 'ویرایش حساب رمزارز',
            ACCOUNT_OWNERS_NAME: 'نام صاحب حساب',
            BANK_ACCOUNT_LIST: 'لیست حساب های بانکی',
            CRYPTO_ACCOUNT_LIST: 'لیست حساب های رمزارز',
            EMONEY_ACCOUNT_LIST: 'لیست حساب های پول الکترونیک',
            REJECTED_TITLE: 'اطلاعات  نامعتبر !',
            REJECTED_TEXT: 'لطفا برای بررسی و ویرایش وارد جزئیات حساب شوید',
            BANK_IS_NOT_VALID: 'لطفا بانک را از گزینه های داخل لیست انتخاب کنید',
            CARD_NUMBER_IS_NOT_VALID: 'شماره کارت وارد شده نامعتبر می باشد',
            CARD_NUMBER_NOT_SUPPORTED: 'بانک شماره کارت وارد شده پشتیبانی نمی شود',
            ENTER_RELATED_CARD_NUMBER: 'لطفا شماره کارت {{bankName}} را وارد کنید',
            YOU_DONT_HAVE_ENOUGH_BANK_ACCOUNT_Q: 'حساب بانکی کافی ندارید؟',
            YOU_DONT_HAVE_ENOUGH_BANK_ACCOUNT: 'حساب بانکی کافی ندارید؟',
            FIRST_REGISTER_NEW_BANK_ACCOUNT: 'ابتدا حساب بانکی جدید ثبت نمایید.',
            THEN_REGISTER_YOUR_WITHDRAWAL_REQUEST_FROM_BEGINNING: 'سپس درخواست برداشت خود را از',
            REGISTER__FROM_BEGINNING: 'ابتدا ثبت نمایید.',
            BANK_ACCOUNT: 'حساب بانکی',
            ADD_ACOUNT: 'افزودن حساب',
            TOTAL_RECEIVED: "مجموع دریافتی",
            UN_ACCEPTABLE_BANK_HINT: 'از ثبت حساب های موسسات مالی خودداری نمایید',
            ALERT: {
                ADD_SUCCESS: 'اطلاعات حساب با موفقیت ذخیره شد. \n منتظر تایید اطلاعات بمانید',
                EDIT_SUCCESS: 'اطلاعات حساب با موفقیت ویرایش شد. \n منتظر تایید اطلاعات بمانید.',
                ADD_SUCCESS_EMONEY: 'اطلاعات حساب با موفقیت ذخیره شد.',
                EDIT_SUCCESS_EMONEY: 'اطلاعات حساب با موفقیت ویرایش شد.',
                DELETE_SERVICE: 'آیا از حذف این حساب پول الکترونیک اطمینان دارید؟',
                DELETE_BANK: 'آیا از حذف این حساب بانکی اطمینان دارید؟',
                DELETE_SUCCESS: 'حساب مورد نظر با موفقیت حذف شد',
                YOUR_SERVICE_ACCOUNT_IS_EMPTY: 'حساب پول الکترونیکی ثبت نشده است.',
                YOUR_CRYPTO_ACCOUNT_IS_EMPTY: 'هیچ حساب رمز ارزی ثبت نشده است.',
                ADD_BANK_ACCOUNT: 'افزودن حساب بانکی',
                ADD_SERVICE_ACCOUNT: 'افزودن حساب پول الکترونیک',
                ADD_CRYPTO_ACCOUNT: 'افزودن حساب رمزارز',
                VERIFY_TIME_INFO: 'این حساب بعد از اولین درخواست موفق  بصورت خودکار تایید می شود',
                ACCOUNT_INFO_COPIED: 'اطلاعات حساب در کلیپ بورد کپی شد',
                VERIFY_NEEDS: 'اطلاعات شخصی شما تایید نشده است.',
                BANK_ACCOUNT_IS_PENDING: 'حساب شما بعد از بررسی توسط کارشناسان سایت تایید خواهد شد.',
                FOR_ADD_BANK_ACCOUNT: 'برای افزودن حساب بانکی',
                YOUR_BANK_ACCOUNT_IS_EMPTY: 'حساب بانکی ای ثبت نشده است.',
                UN_ACCEPTABLE_BANK: 'کاربر گرامی حساب های بانکی بلوبانک سامان و موسسات مانند کوثر, موسسه ملل, موسسه نور,‌  مورد تایید نمی باشد لطفا از ثبت اطلاعات حساب این بانک ها خودداری نمایید.',
                IBAN_NUBER_IS_NOT_FOR_THIS_BANK: 'شماره شبای وارد شده مربوط به بانک انتخاب شده نمی باشد.',

            }
        },
        TICKETS: {
            ATTACHMENT: 'پیوست فایل',
            I_HAVE_TRACKING_NUMBER: 'شماره تیکت دارم',
            NEW_TICKET: 'تیکت جدید',
            TICKET_NUMBER: 'شماره تیکت',
            DEPARTMENT: 'دپارتمان',
            TICKET_STATE: 'وضعیت',
            SUBJECT: 'موضوع',
            PRIORITY: 'اولویت',
            TEXT: 'متن',
            TICKET_NO: 'شماره تیکت',
            LOCK_MESSAGE: 'کیف پول شما قفل شده لطفا جهت پیگیری تیکت ارسال کنید',
            MESSAGE: 'پیام',
            ALERT: {
                ADD_SUCCESS: 'تیکت شما با موفقیت در سیستم ثبت شد.',
                TICKET_REPLY_SUCCESS: 'پیام شما با موفقیت ارسال شد',
                CLOSE_SUCCESS: 'تیکت با موفقیت بسته شد',
                NOT_FOUND: 'تیکت مورد نظر یافت نشد',
                CLOSE_CONFIRM: 'آیا از بستن این تیکت اطمینان دارید؟',
                CLOSED_BEFORE: 'شما قبلا این تیکت را بسته اید',
                ADD_RATE_SUCCESS: 'امتیاز شما با موفقیت در سیستم ثبت شد.',
                SEND_MESSAGE_TO_OPEN_TICKETS: 'برای بازگشایی مجدد تیکت باید پاسخی ارسال کنید',
                TICKET_HAS_BEEN_ARCHIVED: 'این تیکت آرشیو شده است و امکان پاسخگویی به آن وجود ندارد',
                TICKET_HAS_BEEN_CLOSED: 'این تیکت بسته شده است و امکان پاسخگویی به آن وجود ندارد'
            }
        },
        FAQ: {
            HOW_CAN_HELP: 'خوش آمدید. چطور می توانم کمکتان کنم',
            ASK_QUESTION: 'پرسیدن سوال',
            BROWSE_TOPICS: 'موضوعات اصلی',
            FREQUENTLY_QUESTIONS: 'پرسش های متداول',
        },
        REQUEST: {
            CHANGE_STATUS_DATE: 'تاریخ تغییر وضعیت',
            DETAIL: 'جزئیات',
            DONT_HAVE_WALLET_NUMBER: 'شماره کیف پول را ندارم',
            ELECTRONIC_MONEY_PAYMENT: 'پرداخت پول الکترونیک',
            ELECTRONIC_MONEY: 'پول الکترونیک',
            ELECTRONIC_MONEY_NAME: 'نام پول الکترونیک',
            CRYPTO_NAME: 'نام رمزارز',
            SERVICE_NAME: 'نام سرویس',
            EXPERT_DESCRIPTION: 'توضیحات کارشناس',
            END: 'پایان',
            CRYPTO: 'رمزارز',
            BY_LOCAL_PAYMENT: 'از طریق پرداخت محلی',
            WITH_CRYPTOCURRENCY: 'از طریق رمزارز',
            WITH_EMONEY: 'از طریق پول الکترونیک',
            SERVICE_PAYMENT: 'پرداخت سرویس',
            LOCAL_PAYMENT: 'پرداخت محلی',
            CRYPTO_PAYMENT: 'پرداخت رمزارز',
            CRYPTOCURRENCY: "رمزارز",
            MORE_INFO: 'اطلاعات بیشتر',
            PAY_AMOUNT: 'مبلغ پرداختی',
            PAY_CURRENCY: 'ارز پرداختی',
            REQUEST_INFO: 'اطلاعات درخواست',
            REQUEST_DEPOSIT_INFO: 'اطلاعات درخواست',
            REQUESTS: 'درخواست ها',
            SELECT_FRIEND: 'انتخاب دوست',
            TRACKING_NUMBER: 'شماره پیگیری',
            THIRD_PARTY_WALLET: 'کیف پول شخص دیگر',
            TRANSFER: 'انتقال',
            TRANSFER_AMOUNT: 'مبلغ انتقال',
            VERIFY: 'تایید',
            WALLET: 'کیف پول',
            WAITING: 'انتظار',
            CONVERSATION_CLODES: 'این گفتگو بسته شده است',
            PAYMENT_AMOUNT: 'مبلغ قابل پرداخت',
            TRANSACTION_AMOUNT: 'مبلغ تراکنش',
            SELECT_BANK: ' انتخاب حساب بانکی',
            SELECT_PAYMENT_GATEWAY: 'انتخاب درگاه پرداخت',
            I_PAY: "پرداخت میکنم",
            COMPLETE_THE_REQUESt: 'تکمیل درخواست',
            CHANGE_INFORMATION: 'تغییر اطلاعات',
            SUBMIT_REQUEST: 'ثبت درخواست',
            VERIFY_INFORMATION: 'تایید اطلاعات',
            SUCCESS_ALERT: 'درخواست شما با موفقیت ثبت شد',
            VERIFY_INFO_ERROR_ALERT: 'صحت اطلاعات فوق را تایید نمایید',
            DEPOSIT: {
                CHARGE_AMOUNT: 'مبلغ شارژ',
                CHARGE_TYPE: 'روش شارژ',
                BY_ID: {
                    CREATE_ID: 'ایجاد شناسه',
                    SELECT_WALLET: 'انتخاب کیف پول',
                    CHANGE_DEFAULT_WALLET: 'تغییر',
                    PAY_BY_ID: 'پرداخت با شناسه واریز',
                    DEPOSIT_AMOUNT: 'واریز مبلغ',
                    MONEY_MEETING: 'دریافت مبلغ',
                    STEP1_TEXT: 'ابتدا مبلغ را از طریق ساتنا یا پایا به همراه شناسه واریز به حساب مقصد منتقل کنید.',
                    STEP1_TEXT2: ' ثبت شناسه واریز الزامی است',
                    STEP2_TEXT: 'منتظر شارژ کیف پول خود بمانید ،مبلغ به صورت خودکار طی سیکل پایا به کیف پول شما اضافه خواهد شد و به اطلاع شما خواهد رسید',
                    ALERT: "در صورتیکه از حساب بانک ملت مبلغ را به روش سپرده به سپرده انتقال دهید، با توجه به ملت بودن بانک مقصد کیف پول شما زودتر شارژ میشود.",
                    ALERT1: "هنگام انتقال وجه، ثبت شناسه واریز الزامی است. در صورت عدم ثبت یا ثبت نادرست شناسه واریز، کیف پول شما شارژ نخواهد شد؛ وجه پس از ۷۲ ساعت و کسر کارمزد پایا، بازگردانده خواهد شد",
                    DESTINATION_IBAN: "شبای مقصد",
                    DESTINATION_ACCOUNT_NUM: "شماره حساب مقصد",
                    DESTINATION_ACCOUNT_OWNER_NAME: "نام صاحب حساب",
                    DEPOSIT_ID: "شناسه واریز",
                    ORIGIN_IBAN: "شبا مبدا",
                    TIP1: 'واریز وجه باید با کارت‌های تایید شده شما درTC انجام شود، در غیر اینصورت مبلغ بعد از ۲۴ ساعت به حساب شما عودت داده خواهد شد.',
                    TIP2: 'اگر مبلغی را از حساب دیگری به‌جز حساب متصل به شناسه واریز کنید، وجه پس از ۷۲ ساعت و کسر کارمزد پایا وجه بازگردانده خواهد شد.',
                    ALERT_ADD: '- شماره شبا باید به نام خودتان و در TC تایید شده باشد. \n - هر شبای بانکی، صرفا یک شناسه واریز یکتا به صورت دائمی خواهد داشت.',
                    EMPTY_ID: "لطفا اقدام به ایجاد شناسه واریز نمایید",
                    NEW: 'جدید',
                    SELECT_DEFAULT_WALLET_TO_DEPOSIT: 'کیف پول پیشفرض که قصد شارژ آن را با شناسه واریز دارید؛ انتخاب نمایید.',
                    SELECT_SOURCE_ACCOUNT: 'برای شارژ کیف پول ریالی از طریق شناسه واریز به یکی از حساب های مقصد واریز را انجام دهید.',
                    ID_CREATED_SUCCESSFULLY: 'شناسه ی پرداخت با موفقیت ایجاد گردید.',
                    DEFAULT_WALLET_CHANGED_SUCCESSFULLY: 'عملیات با موفقیت انجام گردید',
                    YOU_DONT_HAVE_ENOUGH_BANK_ACCOUNT: 'حساب بانکی ندارید',
                    FIRST_REGISTER_BANK_ACCOUNT: 'ابتدا حساب بانکی ثبت نمایید.',
                    EDIT_MOBILE_NUMBER: 'ویرایش شماره موبایل',
                    STATUS: {
                        VERIFIED: 'تایید شده',
                        REJECTED: 'رد شده',
                        PENDING: 'منتظر تایید',
                    },
                    ID_CREATION_FAILED: 'ایجاد شناسه ناموفق',
                    EXCEPTION_IN_CREATION_ID: 'خطا در ایجاد شناسه',
                    ID_CREATION_PENDING: 'لطفا منتظر نمایش اطلاعات حساب مقصد و شناسه واریز بمانید.',
                    CREATE_ID_AGAIN_ALERT: 'کاربر گرامی لطفا مجدد اقدام به ایجاد شناسه کنید',
                    CONTACT_SUPPORT_ALERT: 'کاربر گرامی جهت رفع این مشکل لطفا با پشتیبانی در تماس باشید'
                },
                ALERT: {
                    WAIT_FOR_GET_CASH_PAY_DETAIL: 'درخواست شما با موفقیت ثبت گردید، لطفا منتظر دریافت پیام یا تماس مستقیم از سوی کارشناسان ما باشید. شما می توانید در این مرحله از درخواست خارج شده و پس از دریافت اطلاعات لازم و تحویل مبلغ، پرداخت خود را ثبت نموده تا شارژ کیف پول شما تکمیل گردد.',
                    WAIT_FOR_PROCESS_PAYMENT_REQUEST: 'کاربر گرامی پس از بررسی و تایید پرداخت های ثبت شده ی شما توسط کارشناسان ما کیف پول مورد نظر شارژ می گردد.',
                },
                MONY_CURRENCY: 'پرداخت محلی',
                DEPOSIT_INFO: 'اطلاعات پرداخت',
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: 'پیام درخواست شارژ',
                            REJECTED: 'رد پرداخت',
                            ACCOUNT_ASSIGNED: 'اطلاعات پرداخت'
                        },
                        BODY: {
                            REJECTED: 'درخواست با شماره پیگیری {{0}} رد شد.',
                            AUTO_REJECTED: 'درخواست با شماره پیگیری {{0}} رد شد.',
                            DONE: 'درخواست با شماره پیگیری {{0}} با موفقیت انجام شد. مبلغ {{1}} به کیف پول شما واریز شد.',
                            MESSAGE: 'پیامی برای درخواست با شماره پیگیری {{0}} از طرف کارشناس ارسال شده است.',
                            REFUND: 'درخواست با شماره پیگیری {{0}} عودت داده شد.',
                            ACCOUNT_ASSIGNED: 'اطلاعات حساب بانکی برای پرداخت درخواست شارژ با شماره پیگیری {{0}}  ثبت شد.'
                        }
                    }

                },

                STEPS_HINT: {
                    SELECT_WALLET: 'کیف پول خود را جهت شارژ انتخاب نمایید.',
                    ENTER_EMONEY_AMOUNT: 'مبلغ پول الکترونیک پرداختی جهت شارژ کیف پول را وارد نمایید.',
                    ENTER_CRYPTO_AMOUNT: 'مبلغ رمزارز پرداختی جهت شارژ کیف پول را وارد نمایید.',
                    ENTER_AMOUNT: 'مبلغ پرداختی جهت شارژ کیف پول را وارد نمایید.',
                    ACCEPT_INFO: 'جهت ثبت درخواست، صحت اطلاعات را بررسی و تائید نمایید.',
                    BANK_WAITING: 'درخواست شما با موفقیت ثبت شد، لطفا  منتظر دریافت اطلاعات حساب جهت پرداخت باشید.',
                    CASH_WAITING: 'درخواست شما با موفقیت ثبت شد، لطفا  منتظر دریافت اطلاعات محل پرداخت باشید.',
                    BANK_PAYMENT: 'لطفا مبلغ پرداخت را به حساب ذکر شده واریز نمایید.',
                    CASH_PAYMENT: 'پس از تحویل مبلغ، اطلاعات پرداخت را ثبت نمایید.',
                    ONLINE_PAYMENT: 'درخواست شما با موفقیت ثبت شد، لطفا حساب بانکی خود را انتخاب و مبلغ را به صورت انلاین پرداخت نمایید.',
                    CREDIT_ENTER_PAYMENT_INFO: 'لطفا اطلاعات پرداخت را وارد نمایید.',
                    PAYMENT_EMONEY: 'لطفا مبلغ را به حساب ذکر شده واریز و سپس اطلاعات پرداخت خود را ثبت نمایید.',
                    GATEWAY_PAY: 'درخواست شما با موفقیت ثبت گردید. لطفا با کلیک بر روی دکمه ی پرداخت مبلغ مورد نظر را از طریق درگاه سایت مبدا پرداخت نمایید.'
                },
                CRYPTO: {
                    WITH_CRYPTO: 'از طریق ارز دیجیتال',
                    WIDOE_GUIDE: 'راهنمای ویدیویی',
                    CURRENCY_TYPE: 'نوع ارز',
                    SELECT_NETWORK: 'شبکه را انتخاب کنید',
                    CONTROL_ADDRESS: 'آدرس واریزی خود را را به دقت کنترل کنید. در صورت وارد کردن آدرس نادرست، ممکن است دارایی شما غیر قابل دسترس شود.',
                    DIRECT_DEPOSIT: 'از واریز مستقیم از صرافی‌های بین‌المللی، به‌ خصوص صرافی‌های آمریکایی مانند CoinBase و Kraken که کاربران ایرانی را محدود می‌کنند، خودداری کنید. در صورت نیاز از کیف‌پول شخصی، آدرس‌های یک‌بار مصرف و روش‌های انتقال چند لایه برای حفظ امنیت دارایی‌هایتان استفاده کنید.',
                    DEPOSIT_ADDRESS: 'آدرس واریز تتر',
                    ASSETS_SECURITY: 'برای حفظ امنیت دارایی‌هایتان، لطفا فقط تتر را به این آدرس واریز کنید. واریز هر ارز دیگری به این آدرس ممکن است باعث از دست رفتن دارایی شما شود.',
                    SELECT_TRANSFER_NETWORK: 'برای دریافت آدرس واریز تتر، ابتدا شبکه انتقال را انتخاب کنید.'
                },
                DIRECT_DEPOSIT: {
                    DIRECT_DEPOSIT_TITLE: 'حواله بانکی',
                    ALERT: 'واریز وجه باید با کارت‌های تایید شده شما درTC انجام شود، در غیر اینصورت مبلغ بعد از ۲۴ ساعت به حساب شما عودت داده خواهد شد.',
                    ALERT_LINE_TWO: 'کیف‌پول انتخابی شما پس از تأیید واریز با نرخ تبدیل لحظه‌ای شارژ می‌شود.',
                    DESC_DIRECT_DEPOSIT: 'برای شارژ کیف پول خود به یکی از حساب های مقصد واریز را انجام دهید.',
                    MY_BANK_ACCOUNT: 'حساب‌های بانکی من',
                    DEPOSIT_AMOUNT_GUIDE_TEXT_ONE: 'ابتدا مبلغ را از طریق ساتنا، پایا یا پل به حساب مقصد منتقل کنید.',
                    MONEY_MEETING: 'نشست پول',
                    DEPOSIT_AMOUNT_GUIDE_TEXT_TWO: 'کیف‌پول انتخابی شما پس از تأیید واریز شما با نرخ تبدیل لحظه‌ای شارژ می‌شود.',
                    SELECT_WALLET_FOR_DIRECT_DEPOSIT: 'کیف پول پیشفرض که قصد شارژ آن را انتخاب نمایید.',
                    ONLY_RIAL_WALLET: 'فقط امکان شارژ کیف پول ریال را دارید',
                },
                OFFLINE: {
                    TITLE: 'واریز آفلاین',
                    CARD_OFFLINE_DEPOSIT: 'واریز کارت به کارت آفلاین',
                    IBAN_OFFLINE_DEPOSIT: 'شبای آفلاین',
                    DEPOSIT_CARD_NUMBER: 'شماره کارت واریز',
                    CONTINUED_GUIDE: 'راهنمای ادامه',
                    CARD_PAGE_DESC_SUPPORT: 'از شماره کارت بالا پرداخت کنید و رسید پرداخت را برای پشتیبانی ارسال کنید تا همین مورد پیگیری شود.',
                    EN_IBAN_OFFLINE: 'Iban Offline',
                    HOW_IS_THIS_ROUTE_DONE: 'این مسیر چگونه انجام می شود؟',
                    IBAN_PAGE_DESC_NUMBER: 'برای انتقال شبا، قبل از پرداخت وارد پشتیبانی شوید. مبلغ و مقصد واریز بررسی می شود و جزئیات پرداخت به صورت اختصاصی برای درخواست شما هماهنگ خواهد شد.',
                    ALERT_IBAN_PAGE: 'قبل از هرگونه انتقال شبا، ابتدا با پشتیبانی هماهنگ کنید.',
                    WALLET_TC: 'کیف پول تی‌سی',
                    BANK_CARD: 'کارت بانکی',
                    AMOUNT_RECEIVED: 'مبلغ دریافتی:',
                    ALERT_SELECT_BANK: 'شما فقط می‌توانید بانکی را انتخاب کنید که قبلاً در TC احراز هویت کرده‌اید.',
                    ALERT_RATE_BANK: 'واریز وجه باید با کارت‌های تایید شده در TC انجام شود، در غیر اینصورت مبلغ بعد از 72 ساعت به حساب شما عودت داده خواهد شد. کیف‌پول انتخابی شما پس از تایید واریز با نرخ تبدیل لحظه‌ای شارژ می‌شود.',
                    SUBMIT_FORM: 'ثبت فرم',
                    REFRENCE_NUMBER: 'کد سند / شماره پیگیری / شماره ارجاع',
                    ALERT_PRICE_RATE_COMMISSION: 'این مبلغ، مبلغ نهایی شارژ کیف پول نیست و مقدار کمیسیون و نرخ لحظه‌ای ممکن است آن را متاثر کند. برای اطلاع بیشتر با پشتیبانی ارتباط بگیرید.',
                    INFO_EXCHANGE_RAGE_SUBMIT: 'نرخ لحظه ثبت: هر {{payAmount}} {{payAmountCurrency}} معادل {{getAmount}} {{getAmountCurrency}} است و نرخ مبتنی بر نرخ لحظه واریز محاسبه می‌شود.',
                    CARD_NUMBER: 'شماره کارت',
                    IBAN_NUMBER: 'شماره شبا',
                    ALERT_UNNECESSARY_FORM_SUBMISSION_WARNING: 'در صورتی که واریز شما قطعی انجام نشده است، از ثبت فرم‌های غیرضروری خودداری نمایید.',
                }
            },

            WITHDRAWAL: {
                ACCOUNT_INFORMATION: 'اطلاعات حساب',
                DEPOSIT_TO_MY_ACCOUNT: 'واریز به حساب من',
                DEPOSIT_TO_THIRD_PARTY_ACCOUNT: 'واریز به حساب شخص دیگر',
                LOCAL_PAYMENT: 'پرداخت محلی',
                TO_CRYPTOCURRENCY_ACCOUNT: 'انتقال به حساب رمزارز',
                TO_EMONEY_ACCOUNT: 'انتقال به حساب پول الکترونیک',
                RECEIVER_NAME: 'نام دریافت کننده',
                RECEIVER_NAME_HINT: 'اگر دریافت کننده خودتان هستید نام خود را وارد نمایید ، اگر شخصی غیر از خودتان دریافت کننده مبلغ می باشد نام او را وارد نمایید',
                SELECT_ACCOUNT: 'انتخاب حساب',
                E_MONEY_PAYMENT: 'پرداخت پول الکترونیک',
                E_MONEY_WITHDRAWAL: 'برداشت پول الکترونیک',
                LOCAL_WITHDRAWAL: 'برداشت محلی',
                BANK_ACCOUNT: 'حساب بانکی',
                LOCATION: 'مکان دریافت',
                ALERT_PENDING_PROCCESING: 'منتظر تایید و بررسی',
                ALERT_PENDING_PROCCESING_Text: 'پس از بررسی و تایید اطلاعات، مبلغ به صورت خودکار طی سیکل پایا به حساب شما افزوده خواهد شد و به اطلاع شما خواهد رسید.',
                SETTLEMENT_TIME: 'زمان تسویه',
                SETTLEMENT_TIME_TEXT: 'مبلغ به صورت خودکار طی سیکل پایا* حداکثر تا ساعت ۱۷:۰۰ روز کاری آینده ، به حساب های شما منتقل خواهد شد و به اطلاع شما خواهد رسید.',
                WITHDRAW_BANK_RULE_TEXT: 'سقف کل مبلغ قابل برداشت روزانه تا {{value}} میلیون تومان در حداکثر {{count}} درخواست برداشت',
                WITHDRAW_ADD_BANK_ACCOUNT_TEXT: 'به دلیل محدودیت سقف واریز روزانه به هر شماره شبا  ({{value}} میلیون تومان)؛ برای دریافت کل مبلغ {{accountCount}} حساب بانکی دیگر ثبت نمایید و یا مبلغ درخواستی را تغییر دهید.',
                WITHDRAW_BANK_ACCOUNT_PENDING_VERIFY: 'حساب بانکی منتظر تایید',
                WITHDRAW_BANK_ACCOUNT_PENDING_VERIFY_TEXT: 'اطلاعات حساب بانکی شما در حال بررسی می باشد لطفا پس از تایید حساب درخواست برداشت ثبت نمایید.',
                DEPOSIT_TO: 'واریز به',
                WITHDRAWAL_INFO: 'اطلاعات برداشت',
                WAIT_FOR_CONFIRMATION_OF_ACCOUNT: 'منتظر تایید اطلاعات حساب بمانید',
                ACCOUNT_SELECTION_IS_REQUIRED: 'انتخاب حساب الزامی می باشد.',
                RECEIVED_AMOUNT_EXCEEDS_DAILY_SETTLEMENT_LIMIT: "مبلغ دریافتی از سقف مجاز تسویه روزانه بیشتر است.",
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: 'پیام درخواست برداشت',

                        },
                        BODY: {
                            DONE: 'درخواست با شماره پیگیری {{0}} با موفقیت انجام شد. مبلغ {{1}} از کیف پول شما برداشت شد.',
                            REJECTED: 'درخواست با شماره پیگیری {{0}} رد شد.',
                            REFUND: 'درخواست با شماره پیگیری {{0}} عودت داده شد.',
                            MESSAGE: 'پیامی برای درخواست با شماره پیگیری {{0}} از طرف کارشناس ارسال شده است.'
                        }
                    }
                },
                STEPS_HINT: {
                    SELECT_EMONEY_ACCOUNT: 'حساب پول الکترونیک خود را جهت واریز انتخاب نمایید.',
                    SELECT_CRYPTO_ACCOUNT: 'حساب رمزارز خود را جهت واریز انتخاب نمایید.',
                    SELECT_WALLET: 'کیف پول خود را جهت برداشت مبلغ انتخاب نمایید.',
                    ENTER_AMOUNT: 'مبلغ برداشت از کیف پول مورد نظر خود را وارد نمایید.',
                    ACCEPT_INFO: 'جهت ثبت درخواست، صحت اطلاعات را بررسی و تائید نمایید.',
                    SELECT_BANK_ACCOUNT: 'حساب بانکی خود را جهت واریز انتخاب نمایید.',
                    SELECT_LOCATION: 'شهر مورد نظر جهت دریافت مبلغ را انتخاب نمایید.',
                    ENTER_RECEIVER_NAME: 'نام و نام خانوادگی دریافت کننده را وارد نمایید.',
                    TRANSFER_TO_ACCOUNT: 'انتقال مبلغ مورد نظر به حساب {{value}} .'
                },
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: 'مبلغ برداشتی نمی‌تواند بیشتر از موجودی کیف پول باشد',
                    CRYPTO_REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: 'مبلغ برداشتی نمی‌تواند بیشتر از مبلغ قابل برداشت باشد',
                },
                CRYPTO: {
                    CHECK_NETWORK: 'در تعیین شبکه انتقال دقت کنید و مطمئن شوید که شبکه انتقال شما با شبکه انتقال آدرس مقصد یکی باشد.',
                    TO_ADDRESS: 'آدرس مقصد',
                    LOSE_ASSETS: 'وارد کردن آدرس نامعتبر منجر به از دست رفت دارایی شما می‌گردد.',
                    WITHDRAW_AMOUNT: 'مبلغ برداشت',
                    TETHER: 'تتر',
                    BALANCE: 'موجودی',
                    WITHDARABLE: 'قابل برداشت',
                    MIN: 'حداقل',
                    MAX: 'حداکثر',
                    CALCULATES: 'محاسبات',
                    FILL_INFO: 'ابتدا اطلاعات را وارد کنید',
                    CANCEL: 'انصراف',
                    REGISTER: 'ثبت درخواست',
                    NETWORK_FEE: 'هزینه انتقال شبکه',
                    FINAL_WITHDRAW_AMOUNT: 'مبلغ واریز به آدرس مقصد',
                    WITHDRAW_CONFIRMATION: 'تایید برداشت',
                    ENSURE_NETWORK: 'از درست بودن آدرس شبکه اطمینان پیدا کنید.',
                    CANNOT_CANCEL: 'پس از ثبت درخواست امکان لغو برداشت وجود ندارد.',
                    NETWORK: 'شبکه',
                    CANCEL_CONFIRM: 'لغو',
                    ACCEPT: 'تایید',
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: "مبلغ برداشتی نمی‌تواند بیشتر از حداکثر قابل برداشت شبکه ({{amount}} {{currency}}) باشد",
                    REQUESTED_AMOUNT_IS_LESS_THAN_BALANCE: "مبلغ برداشتی نمی‌تواند کمتر از حداقل قابل برداشت ({{amount}} {{currency}}) باشد",
                    DEPOSIT: 'شارژ کیف پول',
                    YOU_DONT_HAVE_A_CRYPTO_WALLET: 'کیف پول کریپتو ندارید.',
                    PLEASE_CREATE_A_WALLET_FIRST: 'لطفا ابتدا یک کیف پول ایجاد کنید.',
                    YOUR_WALLET_IS_EMPTY: 'کیف پول شما خالی است!',
                    FIRST_UP_TO_BALANCE_WALLET: 'لطفا ابتدا موجودی خود را شارژ کنید تا بتوانید برداشت خود را انجام دهید.',
                    PROCESSING: 'درحال پردازش',
                    ALERT_PENDING_PROCCESING: 'برداشت شما در شبکه بلاکچین در حال پردازش است. این فرآیند ممکن است کمی زمان ببرد؛ لطفاً شکیبا باشید.',
                    FROM_WALLET: 'از کیف پول',
                    WITHDRAWAL_AMOUNT_FROM_WALLET: 'مبلغ برداشت از کیف پول',
                    DESTINATION_ADDRESS: 'آدرس مقصد',
                    TRANSACTION_ID: 'شناسه تراکنش (hash)',
                    AMOUNT_DEPOSITED_TO_DESTINATION_ADDRESS: 'مبلغ واریز به آدرس مقصد',
                    NETWORK_TRANSFER_FEE: 'هزینه انتقال شبکه',
                    REJECTED_TITLE: 'علت رد درخواست',
                    ALERT_WITHDRAWABLE_TEXT: 'شما فقط به اندازه میزان شارژ رمزارز خود امکان برداشت رمزارز دارید.',
                    TOTAL_BALANCE: 'کل موجودی:',
                    WITHDRAWABLE_BALANCE: 'قابل برداشت:',
                    YOU_HAVE_NOT_ADDED_ANY_CRYPTO_ASSETS_YET: 'هنوز هیچ دارایی رمزارزی اضافه نکرده‌اید.',
                    CRYPTO_DEPOSIT: 'شارژ رمزارز',
                }
            },

            SEND: {
                ENTER_ALERT_INFORMATION: 'لطفا اطلاعات درخواست شده را وارد نمایید',
                INTERNAL_TRANSFER: 'انتقال داخلی',
                LOCAL_SEND: 'پرداخت محلی',
                RECEIVER: 'دریافت کننده',
                RECEIVER_FULL_NAME: 'نام دریافت کننده',
                RECEIVER_USER_NAME: 'نام کاربری دریافت کننده',
                SEND: 'ارسال',
                SEND_DATE: 'تاریخ ارسال',
                SEND_AMOUNT: 'مبلغ ارسال',
                PAY_AMOUNT: 'مبلغ پرداخت',
                SEND_FROM_TC_WALLET: 'ارسال از کیف پول TC',
                SEND_TYPE: 'نوع ارسال',
                TC_TO_TC: 'TC به TC',
                TO_TC: 'به TC',
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: 'مبلغ ارسالی نمی تواند بیشتر از موجودی کیف پول باشد',
                    WITHDRAWAL_AMOUNT_IS_MORE_THAN_BALANCE: 'مبلغ برداشتی با احتساب کارمزد نمی‌تواند بیشتر از موجودی کیف پول باشد',
                },
                ALERT: {
                    SEND_TC_WALLET_SUCCESS: 'انتقال به کیف پول مقصد با موفقیت انجام شد',
                    WAIT_FOR_GET_CASH_PAY_DETAIL: 'درخواست شما با موفقیت ثبت گردید، لطفا منتظر دریافت پیام یا تماس مستقیم از سوی کارشناسان ما باشید. شما می توانید در این مرحله از درخواست خارج شده و پس از دریافت اطلاعات لازم و تحویل مبلغ، پرداخت خود را ثبت نموده تا فرایند ارسال به کیف پول مقصد تکمیل گردد.',
                    WAIT_FOR_PROCESS_PAYMENT_REQUEST: 'کاربر گرامی پس از بررسی و تایید پرداخت های ثبت شده ی شما توسط کارشناسان ما کیف پول مقصد شارژ می گردد.',
                },
                TC_WALLET_SEND: 'پرداخت از کیف پول',

                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            ACCOUNT_ASSIGNED: 'اطلاعات پرداخت درخواست ارسال'
                        },
                        BODY: {
                            TO_ANOTHER: 'درخواست با شماره پیگیری {{0}} با موفقیت انجام شد. مبلغ {{1}} به {{2}} ارسال شد.',
                            REFUND: 'درخواست با شماره پیگیری {{0}} عودت داده شد.',
                            REJECTED: 'درخواست با شماره پیگیری {{0}} رد شد.',
                            DONE: 'درخواست با شماره پیگیری {{0}} با موفقیت انجام شد. مبلغ {{1}} به حساب مقصد شما واریز شد.',
                            ACCOUNT_ASSIGNED: 'اطلاعات حساب بانکی برای پرداخت درخواست ارسال با شماره پیگیری {{0}} ثبت شد.'
                        }
                    }
                },
                STEPS_HINT: {
                    SELECT_THIRD_PARTY_WALLET: 'کیف پول دریافت کننده را جهت ارسال مبلغ  مشخص نمایید.',
                    ENTER_SEND_AMOUNT: 'مبلغ پرداختی را وارد نمایید',
                    ACCEPT_INFO: 'جهت ثبت درخواست، صحت اطلاعات را بررسی و تائید نمایید.',
                    BANK_WAITING: 'درخواست شما با موفقیت ثبت شد، لطفا  منتظر دریافت اطلاعات حساب جهت پرداخت باشید.',
                    BANK_PAYMENT: 'لطفا مبلغ را به حساب ذکر شده واریز نمایید.',
                    CASH_WAITING: 'درخواست شما با موفقیت ثبت شد، لطفا منتظر دریافت اطلاعات محل پرداخت باشید.',
                    CASH_PAYMENT: 'پس از تحویل مبلغ، اطلاعات پرداخت را ثبت نمایید.',
                    ENTER_PAYMENT_INFO: 'لطفا اطلاعات پرداخت را وارد نمایید.',
                    ONLINE_PAYMENT: 'درخواست شما با موفقیت ثبت شد، لطفا حساب بانکی خود را انتخاب و مبلغ را به صورت انلاین پرداخت نمایید.'
                },
                TC_WALLET: {
                    NOTIFY: {
                        NOTIFICATION: {
                            BODY: {
                                RECEIVE: 'مبلغ {{0}} از کاربر {{1}} با شماره پیگیری  {{2}} دریافت شد.'
                            }
                        }
                    },
                    STEPS_HINT: {
                        SELECT_WALLET: ' کیف پول خود را جهت برداشت مبلغ انتخاب نمایید.',
                        SELECT_THIRD_PARTY_WALLET: 'کیف پول دریافت کننده را جهت ارسال مبلغ  مشخص نمایید.',
                        ENTER_SEND_AMOUNT: 'مبلغ ارسالی را وارد نمایید.',
                        ACCEPT_INFO: 'جهت ثبت درخواست، صحت اطلاعات را بررسی و تائید نمایید.',
                    },
                }
            },
            RECEIVE: {
                BE_ARCHIVED: 'بایگانی شود',
                RECIEVE_INFO: 'اطلاعات دریافت',
                ARCHIVE: 'بایگانی',
                ARCHIVED: 'بایگانی شده',
                TO_WALLET: 'به کیف پول',
                FROM_WALLET: 'از کیف پول',
                FROM_USER: 'از کاربر',
                AMOUNT: 'مبلغ دریافتی',
                ARCHIVED_DATE_FROM: 'بایگانی از تاریخ',
                ARCHIVED_DATE_TO: 'بایگانی تا تاریخ',
                ARCHIVED_SUCCESSFULLY: 'تراکنش مورد نظر با موفقیت بایگانی شد',
                MORE_INFO: 'اطلاعات بیشتر',
                RECIVE: 'دریافت',
                SENDER: 'فرستنده',
                RECEIVE_DATE: 'تاریخ دریافت',
                OTHER_WAY: {
                    NOTIFY: {
                        NOTIFICATION: {
                            BODY: {
                                TO_ANOTHER: 'مبلغ {{0}} از کاربر {{1}} با شماره پیگیری  {{2}} دریافت شد.',
                            }
                        }
                    }
                }
            },
            EXCHANGE: {
                CHANGE: 'تغییر',
                EXCHANGE: 'تبدیل',
                ELECTRONIC_MONEY_TO_ELECTRONIC_MONEY: 'تبدیل پول الکترونیک',
                EXCHANGE_AMOUNT: 'مبلغ تبدیل',
                LOCAL_PAYMENT: 'پرداخت محلی',
                PAY_SERVICE: 'سرویس پرداختی',
                SELECT: 'انتخاب',
                TC_TO_TC: 'TC به TC',
                EXCHANGE_TYPE: 'روش تبدیل',
                SELECT_CURRENCY: 'نوع ارز',
                EXCHANGE_DATE: 'تاریخ تبدیل',
                EXCHANGE_INFO: 'اطلاعات تبدیل',
                TC_WALLET: 'کیف پول TC',
                CURRENCY: 'ارز تبدیلی',
                SUBSERVICE: 'نوع سرویس',
                SELECTED_PAY_SERVICE: 'پرداخت با پول الکترونیک',
                GET_SERVICE: 'سرویس دریافتی',
                ELECTRONIC_MONEY: 'پول الکترونیک',
                SELECTED_GET_SERVICE: 'پرداخت به پول الکترونیک',
                NEW_EXCHANGE: 'تبدیل جدید',
                SELECT_PAY_SERVICE: 'انتخاب پول الکترونیک پرداختی',
                SELECT_GET_SERVICE: 'انتخاب پول الکترونیک دریافتی',
                NO_HAVE_ANY_GET_SERVICE: 'هیچ سرویس دریافتی ای وجود ندارد',
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: 'پیام درخواست تبدیل',

                        },
                        BODY: {
                            DONE: 'درخواست با شماره پیگیری {{0}} با موفقیت انجام شد. مبلغ {{1}} به حساب مقصد شما واریز شد.',
                            REJECTED: 'درخواست با شماره پیگیری {{0}} رد شد.',
                            REFUND: 'درخواست با شماره پیگیری {{0}} عودت داده شد.',
                            MESSAGE: 'پیامی برای درخواست با شماره پیگیری {{0}} از طرف کارشناس ارسال شده است.'
                        }
                    }
                },
                STEPS_HINT: {
                    SELECT_WALLET: ' کیف پول خود را جهت برداشت مبلغ انتخاب نمایید.',
                    SELECT_WALLET_TO_TRANSFER: ' کیف پول خود را جهت انتقال مبلغ انتخاب نمایید.',
                    ENTER_EXCHANGE_AMOUNT: 'مبلغ موردنظر جهت تبدیل را وارد نمایید.',
                    ACCEPT_INFO: 'جهت ثبت درخواست، صحت اطلاعات را بررسی و تائید نمایید.',
                    SELECT_PAY_GET_SERVICE: 'سرویس پرداختی/دریافتی را جهت تبدیل انتخاب نمایید.',
                    ENTER_ACCOUNT_INFO: 'اطلاعات حساب خود یا شخص گیرنده را مشخص نمایید.',
                    PAYMENT: 'درخواست شما با موفقیت ثبت شد، لطفا مبلغ را به حساب ذکر شده واریز و سپس اطلاعات پرداخت خود را ثبت نمایید.'
                },
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: 'مبلغ تبدیل نمی تواند بیشتر از موجودی کیف پول باشد'
                }
            },
            VOUCHER: {
                VOUCHER_NAME: 'نام ووچر',
                VOUCHER_TYPE: 'نوع ووچر',
                UNIT_PRICE: 'قیمت واحد',
                QUANTITY: 'تعداد خرید',
                USER_PRICE: 'قیمت مصرف کننده',
                TOTAL_PRICE: 'قیمت کل',
                UNIT_COMMISSION: 'کارمزد واحد',
                COMISSION: 'کارمزد',
                EXCHANGE_RATE: 'نرخ تبدیل',
                VOUCHER_ITEM: 'آیتم ووچر',
                MIN_QUANTITY: 'حداقل تعداد',
                MAX_QUANTITY: 'حداکثر تعداد',
                VOUCHER: 'ووچر',
                TOTAL_COMISSION: 'کارمزد کل',
                SERIAL_NUMBER: 'شماره سریال',
                AMOUNT: 'مبلغ',
                PURCHASED_VOUCHERS: 'ووچرهای خریداری شده',
                PURCHASED_INFO: 'اطلاعات خرید',
                PURCHASED_DATE: 'تاریخ خرید',
                WOULD_RECEIVE_VOUCHER_INFO_EMAIL: 'آیا مایلید اطلاعات ووچر خریداری شده را از طریق ایمیل دریافت کنید؟',
                STEPS_HINT: {
                    SELECT_WALLET: 'کیف پول خود را جهت خرید ووچر انتخاب نمایید.',
                    NUMBER_OF_PURCHASE: 'تعداد مورد نظر جهت خرید ووچر انتخاب شده را وارد نمایید.',
                    ACCEPT_INFO: 'جهت ثبت درخواست، صحت اطلاعات را بررسی و تائید نمایید.',
                }
            },
            POINTS: {
                TO_TC_WALLET: 'واریز به کیف پول TC',
                WITHDRAW_DATE: 'تاریخ برداشت',
                WITHDRAWAL_INFO: 'اطلاعات برداشت',
                WHITDRAW_POINT: 'برداشت امتیاز',
                TRANSACTION_NAME: 'نام تراکنش',
                GET_AMOUNT: 'مبلغ دریافتی',
                NUMBER_OF_POINT: 'تعداد امتیاز',
                EACH_1000_POINT: 'هر 1000 امتیاز',
                MY_POINTS: 'امتیاز های من',
                MIN_NUM_FOR_WITHDAWAL: 'حداقل امتیاز  لازم برای برداشت',
                INVOICE_TYPE: 'تبدیل امتیاز به موجودی',
                EACH: 'هر',
                WITHDRAWAL_POINTS: 'امتیاز برداشتی',
                NUMBER_OF_POINTS: 'تعداد امتیاز',
                POINTS: 'امتیاز',
                TOTAL_POINTS: 'امتیاز کل',
                WALLET: 'کیف پول',
                CHANGE_STATUS: 'وضعیت تغییر',
                TRANSACTION_TYPE: 'نوع تراکنش',
                CHANGE_TYPE: 'تغییر وضعیت',
                WITHDRAWAL: 'برداشت امتیاز',
                STEPS_HINT: {
                    SELECT_WALLET: 'کیف پول خود را جهت واریز مبلغ انتخاب نمایید.',
                    POINT_WITHDRAWAL: 'امتیاز مورد نظر جهت برداشت را وارد نمایید.',
                    ACCEPT_INFO: 'جهت ثبت درخواست، صحت اطلاعات را بررسی و تائید نمایید.',
                },
                ALERT: {
                    IS_LOWER_THAN_MIN: 'امتیاز جاری شما از حداقل امتیاز مجاز برای برداشت کمتر می باشد.'
                },
                VALIDATION: {
                    MIN_POINT_FOR_WITHDRAWAL: 'حداقل امتیاز قابل برداشت:'
                }
            },
            CONFIRMATION: {
                CONFIRMATION_CODE: 'تایید کد',
                CONFIRMATION_HELP_EMAIL: 'جهت ثبت درخواست، کد تاییدی که به ایمیل شما ارسال شده است را وارد نمائید',
                CONFIRMATION_HELP_SMS: 'جهت ثبت درخواست، کد تاییدی که به شماره تلفن همراه شما ارسال شده است را وارد نمائید',
                CONFIRMATION_HELP_2FA: 'جهت ثبت درخواست، کد تایید دو مرحله ای خود را وارد نمائید',
                SEND_CODE: 'ارسال کد',
                SECURITY_CODE: 'کد تایید',
                AUTHENTICATOR_CODE: "کد تایید دو مرحله ای",
                ENTER_CODE_FROM_AUTHENTICATOR: "اگر کد را در صندوق ورودی خود دریافت نکردید، لطفاً پوشه اسپم خود را بررسی کنید."
            },
            PAYMENT: {
                ACCOUNT_INFO: 'اطلاعات حساب',
                ADD: 'ثبت پرداخت',
                AMOUNT: 'مبلغ',
                AMOUNT_MUST_PAY: 'لطفا مبلغ {{value}} را به حساب TC واریز و سپس اطلاعات پرداخت خود را ثبت نمایید',
                AMOUNT_MUST_PAY_CASH: 'لطفا مبلغ {{value}} را در محل مورد نظر تحویل داده و سپس اطلاعات پرداخت خود را ثبت نمایید',
                AMOUNT_OUT_STANSING: 'مبلغ منتظر پرداخت',
                CREATED_DATE: 'تاریخ ثبت',
                INTER_PAYMENT_INFO: 'لطفا اطلاعات پرداخت را وارد نمایید',
                MY_PAYMENTS: 'پرداخت های من',
                NEW_PAYMENT: 'پرداخت جدید',
                PAY_AMOUNT: 'مبلغ پرداخت',
                PAYMENT_AMOUNT: 'مبلغ پرداخت',
                PAYMENT_DETAILS: 'جزئیات پرداخت',
                PAYMENT: 'پرداخت',
                PAYMENT_DATE: 'تاریخ پرداخت',
                PAYMENT_LOCATION: 'مکان پرداخت',
                PAYMENT_INFO: 'اطلاعات پرداخت',
                PAYMENT_REF_NUMBER: 'شماره مرجع',
                PAYMENT_HISTORY: 'تاریخچه پرداخت ها',
                PAY_NOW: 'پرداخت',
                REFRENCE_NUMBER: 'شماره درخواست',
                SENDER: 'فرستنده',
                SENDER_ACCOUNT_NUMBER: 'اطلاعات حساب',
                WALLET_ADDRESS: 'آدرس کیف پول',
                HASH: 'Hash',
                MEMO: 'Memo',
                TAG: 'Tag',
                SEND_BY_THIRD_PARTY: 'پرداخت از حساب شخص دیگر',
                SUM_OF_TOTAL_AMOUNT_APPROVED: 'جمع مبلغ تایید شده',
                TC_PAYMENTS: 'پرداخت های Tc',
                TRANSACTIONS_PAYMENTS: 'تراکنش های انتقال',
                TOTAL_WAITING_FOR_CONFIRMATION: 'مبلغ کل منتظر تایید',
                TC_ACCOUNT: 'حساب TC',
                TC_SERVICE_ACCOUNT: 'حساب TC',
                TOTAL_AMOUNT_PAID: 'جمع مبلغ پرداختی',
                YOUR_ACCOUNT: 'حساب شما',
                YOUR_SERVICE_ACCOUNT: 'حساب شما',
                YOU_HAVE: 'شما',
                YOUR_REQUEST_WILL_BE_REJECT_AFTER_TIME_FINISHED: 'زمان دارید که پرداخت خود را ثبت نمایید . بعد از اتمام  زمان در خواست شما رد می شود.',
                TIME_FINISHED: 'زمان شما برای ثبت پرداخت به پایان رسیده است',
                E_MONEY: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                REJECTED: 'رد پرداخت',
                            },
                            BODY: {
                                REJECTED: 'پرداخت درخواست با شماره پیگیری {{0}} رد شد.'
                            }
                        }
                    }
                },
                BANK: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                REJECTED: 'رد پرداخت',
                                ACCOUNT_ASSIGNED: 'اطلاعات پرداخت'
                            },
                            BODY: {
                                REJECTED: 'پرداخت درخواست شارژ با شماره پیگیری {{0}} رد شد.',
                                ACCOUNT_ASSIGNED: 'اطلاعات حساب بانکی برای پرداخت درخواست شارژ با شماره پیگیری {{0}}  ثبت شد.'
                            }
                        }

                    }

                },
                CASH: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                REJECTED: 'رد پرداخت',

                            },
                            BODY: {
                                REJECTED: 'پرداخت درخواست شارژ با شماره پیگیری {{0}} رد شد.',
                            }
                        }
                    }
                },
                ALERT: {
                    CANT_DELETE_PAYMENT: 'شما نمی توانید این پرداخت را حذف کنید',
                }
            },
            PAYMENT_GATEWAY: {
                TRANSACTION_ID: 'شناسه تراکنش',
                TYPE: 'نوع',
                AMOUNT: 'مبلغ',
                REQUESTED_AMOUNT: 'مبلغ درخواست',
                REQUESTED_AMOUNT_DETAIL: 'مبلغ درخواستی',
                PAY_AMOUNT: 'مبلغ پرداختی',
                GET_AMOUNT: 'مبلغ دریافتی',
                SETTLEMENT_AMOUNT: 'مبلغ تسویه حساب',
                STATUS: 'وضعیت',
                MERCHANT: 'مرچنت',
                CREATED_IP_ADDRESS: 'آدرس IP ایجاد شده',
                STATUS_HISTORY: 'تاریخچه وضعیت',
                INVOICE_NUMBER: 'شماره فاکتور',
                TERMINAL_ID: 'شناسه ترمینال',
                TERMINAL_WALLET: 'کیف پول ترمینال',
                CONSUMER_WALLET: 'کیف پول مشتری',
                USER: 'کاربر',
                SETTLEMENT_DATE: 'تاریخ تسویه حساب',
                ADDITIANAL_DATA: 'اطلاعات بیشتر',
                TERMINAL: 'ترمینال',
                LOCAL_DATE_TIME: 'زمان محلی',
                CONSUMER_ID: 'شناسه مشتری',
                RETURN_URL: 'آدرس URL برگشتی',
                STATUS_DATE: 'تاریخ وضعیت:',
                EXCHANGE_RATE: 'نرخ تبدیل',
            },
            ALERT: {
                ONLINE_PAYMENT: 'هشدار، لطفا در صفحه پرداخت بانکی از کارت انتخاب شده در تاپ چنج برای پرداخت استفاده کنید، در غیر اینصورت درخواست شما انجام نخواهد شد و مبلغ  تا 72 ساعت قابل پیگیری نخواهد بود !!',
                ADD_NEW_BANK: 'اگر مایل به ایجاد حساب بانکی جدید می باشید',
                AMOUNT_MUST_BE_INTEGER: 'مبلغ باید عدد باشد',
                AMOUNT_PRECISION_ERROR: 'مقیاس اعشار باید کمتر از {{vaule}} باشد.',
                REJECTED_TEXT: 'درخواست شما رد شد',
                WAITING_FOR_INFORMATION: 'لطفا منتظر دریافت اطلاعات پرداخت باشید',
                WAIT_FOR_GET_BANK_ACCOUNT_DETAILS: 'درخواست شما با موفقیت ثبت گردید، اطلاعات حساب بانکی جهت واریز مبلغ پرداخت به زودی از طریق اعلان ها به شما اطلاع داده می شود. شما می توانید در این مرحله از درخواست خارج شده و پس از دریافت اطلاعات، پرداخت خود را ثبت نموده تا شارژ کیف پول شما تکمیل گردد. ',
                WAIT_FOR_PROCESS_WITHDRAW_PAYMENT_REQUEST: 'کاربر گرامی پس از بررسی و تایید درخواست شما توسط کارشناسان ما مبلغ به حساب مورد نظر واریز می گردد',
                WAIT_FOR_PROCESS_WITHDRAW_BANK_PAYMENT_REQUEST: 'کاربر گرامی درخواست برداشت شما با موفقیت ثبت شد.\nپردازش برداشت­های ریالی در تاپچنج از طریق سیستم پایای بانکی انجام می گیرد. بنابراین مبالغ درخواستی شما، نهایتا تا عصر روز آینده­ ی کاری به حساب مقصد واریز خواهد شد. بدیهی است در روزهای جمعه و تعطیلات رسمی تسویه حساب از طریق سیستم پایا انجام نمی ­شود.\nدر نظر داشته باشید، پس از تکمیل درخواست و اطمینان تاپ چنج از تکمیل پروسه مبلغ از کیف پول شما کسر می ­شود. همچنین توجه فرمایید که درخواست پس از ثبت در سیستم در تمامی مراحل امکان لغو ندارد.',
                WAIT_FOR_PROCESS_WITHDRAW_BANK_PAYMENT_REQUEST2: 'لطفا پس از ثبت درخواست تا زمان اعلام شده (عصر روز آینده ­ی کاری) از مراجعه به پشتیبانی برای پیگیری مبلغ خودداری نمایید.',
                ONLINE_SUCCESS: 'پرداخت شما با موفقیت انجام و کیف پول شما شارژ شد.',
                MIN_ORDER: 'حداقل مبلغ باید {{value}} باشد',
                MAX_ORDER: 'حداکثر مبلغ باید {{value}} باشد',
                PAYMENT_ADD_SUCCESSFUL: 'پرداخت شما با موفقیت ثبت شد',
                CONFIRM_PAYMENT_DELETE: 'آیا از حذف این پرداخت با مبلغ {{value}} مطمئن هستید ؟',
                PAYMENT_DELETED_SUCCESS: 'پرداخت مورد نظر با موفقیت حذف گردید',
                CONFIRM_REQUEST_DELETE: 'آیا از حذف این درخواست مطمئن هستید؟',
                REQUEST_DELETED_SUCCESS: 'درخواست شما با موفقیت حذف شد',
                CAN_SEND_MESSAGE: 'ارسال پیام پس از ثبت درخواست فعال می شود',
                THERE_IS_NO_MESSAG: 'پیامی جهت نمایش وجود ندارد',
                COMMISION_DATA_NOT_FOUND: 'اطلاعات کارمزد یافت نشد',
                COMMISSION_DATA_IS_NOT_DEFIENED: 'اطلاعات کارمزد تعریف نشده است',
                CURRENCY_LIST_IS_NOT_FOUND: 'لیست ارزها پیدا نشد',
                CURRENCY_EXCHANGE_RATE_LIST_NOT_FOUND: 'لیست کارمزد تبدیل ارزها پیدا نشد',
                THERE_IS_NO_MESSAGE: 'هیچ پیامی برای نمایش وجود ندارد',
                THERE_IS_NO_MESSAGE_NEW: 'در حال حاضر پیامی وجود ندارد',
                REQUEST_WAS_NOT_FOUND: 'درخواست مورد نظر یافت نشد',
                PAYMENT_TEXT: 'درخواست شما در مرحله ی پرداخت می باشد',
                PROCESSING_TEXT: 'درخواست شما در حال بررسی می باشد',
                WHAIT_FOR_ASSIGN_PAYMENT: 'لطفا منتظر دریافت اطلاعات پرداخت توسط کارشناسان سایت باشید.',
                WAIT_TILL_ACCEPT_PAYMENT: 'لطفا منتظر تایید پرداخت توسط کارشناسان سایت باشید',
                WAIT_FOR_PROCESS_CREDIT_REQUEST: 'کاربر گرامی پس از بررسی و تایید اطلاعات پرداخت ارسال شده ی شما توسط کارشناسان ما کیف پول مورد نظر شارژ می گردد.',
                USE_V1: 'کاربر گرامی برای پیگیری این درخواست به نسخه ی قدیمی سایت مراجعه نمایید.',
                WAITING_MESSAGE: 'کاربر گرامی لطفا منتظر باشید تا کارشناسان ما درخواست شما را بررسی نمایند.',
                WAIT_FOR_PROCESS_WITHDRAW_CASH_PAYMENT: 'کاربر گرامی پس از بررسی و تایید درخواست شما توسط کارشناسان ما مبلغ به دریافت کننده مورد نظر تحویل داده می شود',
                WITHDRAWAL_POINT_SUCCESS: 'برداشت امتیاز با موفقیت انجام و مبلغ به کیف پول مورد نظر واریز شد.',
                BETWEEN_MY_WALLET_SUCCESS: 'انتقال پول بین کیف پول های مورد نظر با موفقیت انجام شد',
                NEED_VERIFY: 'برای استفاده از این قسمت باید ابتدا اهراز هویت های لازم را انجام دهید',
                REQUEST_SUCCESS_WAITING: 'درخواست شما ثبت شد و در حال بررسی است.',
                ALERT_REQUEST_SUCCESS_WAITING_TEXT: 'درخواست تا ساعات آتی بررسی خواهد شد و بر روی موجودی کیف پول درخواستی اعمال خواهد شد.'

            },
            ACCEPT_ABOVE_INFO: 'صحت اطلاعات فوق را می پذیرم.',
            QUANTITY: 'مقدار',
            ARCHIVE_DATE: 'تاریخ بایگانی',
            ARCHIVE: 'بایگانی',
            MY_WALLET: 'کیف پول من',
            OTHER_WAYS_TRANSMISSION: 'انتقال از روش های دیگر',
            TRANSFER_DATE: 'تاریخ انتقال',
            WALLET_NOT_FOUND: 'کیف پول پیدا نشد',
            DEPOSIT_PAYMENT_TYPE: 'روش شارژ',
            RECEIVE_CURRENCY: 'ارز دریافتی',
            WITHDRAWAL_AMOUNT: 'مبلغ برداشت',
            MONEY_CURRENCY: 'پرداخت محلی',
            SELL_AMOUNT: 'مبلغ فروش',
            BALANCE: 'موجودی',
            CHANGE_STATE: 'وضعیت تغییر',
            BANK: 'بانک',
            FRIEND: 'دوست',
            CALCULATED_AMOUNT_ALONE: 'مبلغ محاسبه‌',
            CHARGE_AMOUNT: 'مبلغ شارژ',
            AMOUNT: 'مبلغ شارژ',
            BUY_AMOUNT: 'مبلغ خرید',
            RECEIVER: 'دریافت کننده',
            PAY_ACCOUNT: 'پرداخت از حساب',
            DECIMAL_SCALE: 'مقیاس اعشار',
            ACCOUNT_INFO: 'اطلاعات حساب',
            REQUEST_DATE: 'تاریخ درخواست',
            SEND_DATE: 'تاریخ ارسال',
            DATE: 'تاریخ',
            ELECTROINC_MONEY: 'پول الکترونیک',
            EXCHANGE_RATE: 'نرخ تبدیل',
            THIRD_PARTY_INFORMATION: 'اطلاعات شخص',
            INITIAL_COST: 'هزینه اولیه',
            COMMISION: 'کارمزد',
            REQUEST_LIST: 'لیست درخواست ها',
            LOCATION: 'محل دریافت',
            GET: 'دریافتی',
            REFRENCE_NUMBER: 'شماره درخواست',
            MY_PAYMENT: 'پرداخت های من',
            MINIMUM_COMMISION: 'حداقل کارمزد ',
            GET_AMOUNT: 'مبلغ دریافتی',
            REQUESTED_DATE: 'تاریخ درخواست',
            DEPOSIT_INFORMATION: 'اطلاعات پرداخت',
            DIGITAL_CURRENCY: 'ارز دیجیتال',
            YOUR_REQUEST_SUBMITTED: 'درخواست شما با موفقیت ثبت شد',
            WAYS_SEND_TO_OTHERS: 'روش های ارسال به دیگران',
            RECIEVE_TYPE: 'نوع دریافت',
            WITHDRAWAL_TYPE: 'روش برداشت',
            RECIEVE_CURRENCY: 'ارز دریافتی',
            PAY_SERVICE: 'پول الکترونیک پرداختی',
            GET_SERVICE: 'پول الکترونیک دریافتی',
            EXCHANGE_TEXT: 'انتقال',
            POINT: 'امتیاز',
            EXCHANGE_TYPE: 'نوع مبادله',
            PAYMENT_TYPE: 'روش پرداخت',
            TOTAL_AMOUNT: 'جمع مبلغ پرداختی',
            MIN_AMOUNT: 'حداقل مبلغ',
            MAX_AMOUNT: 'حداکثر مبلغ',
            MAXIMUM_COMMISION: 'حداکثر کارمزد',
            MINIMUM_BONUS: 'حداقل پاداش ',
            MAXIMUM_BONUS: 'حداکثر پاداش',
            THIRD_PARTY: 'شخص دیگر',
            SECURITY: 'امنیتی',
            SEND_TO_THIRD_PARTY_TC_WALLET: 'ارسال به کیف پول دوستان',
            SEND_TO_THIRD_PARTY: 'واریز به حساب شخص دیگر',
            PAYMENT_INFO_WILL_SEND_VIA_NOTIFICATION: 'اطلاعات پرداخت از طریق اعلان ها برای شما ارسال می شود',
            WHEN_RECEIVE_PAYMENT_INFO: 'پس از دریافت اطلاعات پرداخت می توانید ادامه ی مراحل را پیگیری نمایید',
            MESSAGE_PLACE_HOLDER: 'پیام خود را وارد نمایید ...',
            BONUS_FIXED_AMOUNT: 'مبلغ ثابت',
            BONUS: 'پاداش',
            NO_PAYMENT: 'پرداخت ثبت شده ای جهت نمایش وجود ندارد',
            FROM_WALLET: 'از کیف پول',
            TO_WALLET: 'به کیف پول',
            NOTIFY: {
                TITLE: {
                    DEPOSIT_MONEY_CURRENCY: 'شارژ (پرداخت محلی)',
                    DEPOSIT_E_MONEY: 'شارژ (پول الکترونیک)',
                    DEPOSIT_CRYPTO: 'شارژ (رمزارز)',
                    WITHDRAWAL_MONEY_CURRENCY: 'برداشت (پرداخت محلی)',
                    WITHDRAWAL_E_MONEY: 'برداشت (پول الکترونیک)',
                    WITHDRAWAL_CRYPTO: 'برداشت (رمزارز)',
                    SEND_OTHER_WAY: 'ارسال (پرداخت محلی)',
                    SEND_TC_WALLET: 'ارسال (پول الکترونیک)',
                    RECEIVE_OTHER_WAY: 'دریافت (پرداخت محلی)',
                    RECEIVE_TC_WALLET: 'دریافت (کیف پول)',
                    EXCHANGE_MONEY_CURRENCY: 'تبدیل (کیف پول)',
                    POINT: 'برداشت امتیاز',
                    VOUCHER: 'واچر',
                },
                NOTIFICATION: {
                    TITLE: {
                        MESSAGE: 'پیام درخواست شارژ',


                    },
                    BODY: {
                        DONE: 'درخواست با شماره پیگیری {{0}} با موفقیت انجام شد. کیف پول شما {{1}} شارژ شد.',
                        REJECT: 'درخواست با شماره پیگیری {{0}} رد شد.',
                        REFUND: 'درخواست با شماره پیگیری {{0}} عودت داده شد.',
                        MESSAGE: 'پیامی برای درخواست با شماره پیگیری {{0}} از طرف کارشناس ارسال شده است.',
                    }
                }
            },

            COMMISSION: {
                REQUESTED_AMOUNT: 'مبلغ درخواست',
                FIXED_AMOUNT: 'مبلغ ثابت',
                CHARGE_AMOUNT: 'مبلغ شارژ',
                SELL_AMOUNT: 'مبلغ فروش',
                BUY_AMOUNT: 'مبلغ خرید',
                PAY_AMOUNT: 'مبلغ پرداختی',
                SEND_AMOUNT: 'مبلغ ارسالی',
                WITHDRAWAL_AMOUNT: 'مبلغ برداشتی',
                CONVERTED_AMOUNT: 'مبلغ تبدیل',
                CALCULATED_AMOUNT_BUNOS: 'مبلغ بااحتساب پاداش',
                UPDATE_TIME: 'بروزرسانی',
                COMMISSION: 'کارمزد',
                EXCHANGE_RATE: 'نرخ تبدیل',
                INITIAL_COST: 'هزینه اولیه',
                BONUS_FIXED_AMOUNT: 'مبلغ ثابت',
                BONUS: 'پاداش',
                MINIMUM_COMMISION: 'حداقل کارمزد ',
                MAXIMUM_COMMISION: 'حداکثر کارمزد',
                MINIMUM_BONUS: 'حداقل پاداش ',
                MAXIMUM_BONUS: 'حداکثر پاداش',
                POINT: 'امتیاز',
                GET_AMOUNT: 'مبلغ دریافتی',
                GET_AMOUNT_THIRD_PARTY: 'مبلغ دریافتی شخص دیگر',
                CALCULATED_AMOUNT: 'کسورات با احتساب کارمزد',
                CALCULATIONS: 'محاسبات',
                CALCULATION_DETAILS: 'جزییات محاسبه'
            },
            DIGITAL_CURRENCY_CRYPTO: 'ارز دیجیتال',
            TRANSACTION_NETWORK: 'شبکه تراکنش',
            TRANSACTION_ID: 'شناسه تراکنش',
            AMOUNT_CRYPTO: 'مبلغ',
            REQUESTED_DATE_TRANSACTION: 'تاریخ تراکنش',
            MORE: 'بیشتر',
            DEPOSIT_METHOD: 'روش شارژ',
            TRANSACTION_SOURCE_ADDRESS: 'آدرس مبدا تراکنش',
            TRANSACTION_DESTINATION_ADDRESS: 'آدرس مقصد تراکنش',
            RECEIVED_AMOUNT: "مبلغ دریافت شده",
            MORE_INFORMATION: "اطلاعات بیشتر",
            POINTS_CRYPTO: "امتیاز",
            VIEW_TRANSACTION_LINK: "مشاهده لینک تراکنش",
            DIRECTDEPOSIT: {
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            DIRECT_DEPOSIT: {
                                SUCCESSFUL: 'حواله بانکی موفق',
                                REFUND: 'بازگشت حواله بانکی'
                            }
                        },
                        BODY: {
                            DIRECT_DEPOSIT: {
                                SUCCESSFUL: 'حواله بانکی شما دریافت و کیف پول شما با موفقیت شارژ شد.',
                                REFUND: 'به دلیل ثبت نبودن حساب مبدا در تاپ‌چنج، مبلغ واریزی به حساب بانکی شما برگشت داده شد.'
                            }
                        }
                    }
                }
            }
        },
        HISTORY: {
            SERVICE: 'پول الکترونیک',
            WALLET: 'کیف پول',
            REQUEST_STATUS: 'وضعیت درخواست'
        },
        PROFILE: {
            CONTACT_INFO: "اطلاعات تماس",
            TITLE: 'پروفایل',
            ADDRESS: 'آدرس',
            ADDRESS_INFO: 'آدرس',
            ADDRESSES_DOC: 'انتخاب تصویر مدارک آدرس',
            BIRTH_DATE: 'تاریخ تولد',
            COUNTRY: 'کشور',
            CITY: 'شهر',
            PHONECALL_INTERVIEW: 'مصاحبه ی تلفنی',
            KYC: 'KYC',
            LETTER_OF_COMMITMENT: 'تعهدنامه',
            STATE: 'استان',
            LANDLINE_NUMBER: 'تلفن ثابت',
            ZIP_CODE: 'کد پستی',
            VERIFICATION: 'تایید اطلاعات',
            ENTER_CODE: 'کد را وارد نمایید',
            CHANGE_PASSWORD: 'تغییر رمز',
            ACCOUNT_INFO: 'اطلاعات حساب',
            OLD_PASSWORD: 'کلمه عبور قبلی',
            NEW_PASSWORD: 'کلمه عبور جدید',
            CONFIRM_NEW_PASSWORD: 'تایید کلمه عبور جدید',
            PERSONAL_INFO: 'اطلاعات شخصی',
            NOT_VERIFIED: 'تایید نشده',
            NOT_VERIFIED2: 'تایید نشده',
            NOT_VERIFIED3: 'تایید نشده',
            IDENTITY_CARD: 'کارت ملی',
            VERIFIED: 'تایید شده',
            VERIFIED2: 'تایید شده',
            VERIFY_NOW: 'تایید اطلاعات',
            VERIFY_PERSONAL_INFO: 'تایید اطلاعات شخصی',
            PHOTO: 'تصویر',
            IMAGE_DETAIL: 'جزئیات تصویر',
            VERIFY_TEXT: 'تایید',
            DRIVING_LICENSE: 'گواهینامه',
            PASSPORT: 'پاسپورت',
            PHONE_NUMBER: 'شماره تلفن همراه',
            FRONT_OF_ID_CARD: 'انتخاب تصویر روی کارت ملی',
            BACK_OF_ID_CARD: 'انتخاب تصویر پشت کارت ملی',
            FRONT_IMAGE: 'روی کارت',
            BACK_IMAGE: 'پشت کارت',
            TAKE_IMAGE: 'گرفتن عکس',
            IF_IMAGE_NOT_GOOD: 'اگر کیفیت تصویر مناسب نیست',
            TAKE_NEW_ONE: 'یک تصویر جدید بگیرید',
            REG_DATE: 'تاریخ عضویت',
            UPLOAD_IMAGE: 'انتخاب تصویر',
            UPLOAD_DRIVING_PHOTO: 'انتخاب تصویر گواهینامه',
            UPLOAD_FRONT_OF_YOUR_IDENTITY_CARD_IMAGE: 'جلوی تصویر شناسنامه خود را بارگذاری کنید',
            UPLOAD_BACK_OF_YOUR_IDENTITY_CARD_IMAGE: 'پشت تصویر شناسنامه خود را بارگذاری کنید',
            UPLOAD_PASSPORT_PHOTO: 'انتخاب تصویر پاسپورت',
            UPLOAD_IDENTITY_CARD_PHOTO: 'آپلود تصویر کارت ملی',
            UPLOAD_PHOTO_OF_PASSPORT: 'آپلود تصویر پاسپورت',
            UPLOAD_IMAGE_FROM_YOUR_STORAGE: 'آپلود تصویر از حافظه ی دستگاه خود',
            USE_CAMERA_TO_TAKE_IMAGE: 'از دوربین گوشی خود برای گرفتن تصویر استفاده کنید',
            USER_GROUP: 'گروه کاربری',
            MOBILE_NUMBER: 'شماره تلفن همراه',
            WRITE_BLOW_CODE_ON_PAPER: 'کد زیر را روی کاغذ بنویسید',
            YOUR_PHONE_NUMBER: 'شماره تلفن همراه',
            EDIT_MOBILE_INFO: 'برای تغییر شماره تلفن همراه ابتدا باید شماره فعلی خود را تایید نمایید',
            VERIFY_CURRENT_PHONE_NUMBER: 'تایید شماره تلفن همراه فعلی',
            SELECT_ONE_BELOW_OPTIONS: 'لطفا یکی از گزینه های زیر را انتخاب کنید',
            ENTER_YOUR_PHONE_NUMBER: 'شماره تلفن همراه خود را وارد نمایید',
            CHANGE_YOUR_PHONE_NUMBER_QUESTION: 'آیا می خواهید شماره تلفن همراه خود را تغییر دهید؟',
            PLEASE_VERFY_PROFILE: 'برای استفاده از خدمات سایت لطفا اطلاعات خود را تایید نمایید',
            VERIFY_DESCRIPTION: 'کاربر گرامی ، جهت افزایش امنیت و جلوگیری از هرگونه تخلف توسط افراد سودجو ، لطفاً اطلاعات زیر را تأیید کنید.',
            FIRST_NAME: 'نام',
            LAST_NAME: 'نام خانوادگی',
            BIRTHDAY: 'تاریخ تولد',
            GENDER: 'جنسیت',
            BIRTHDATE: 'تاریخ تولد',
            YOUR_PHONE_NUMBER_IS: 'شماره موبایل شما',
            CHANGE_AVATAR: 'تغییر عکس کاربری',
            SELECT_AVATAR_MESSAGE: 'لطفا عکس کاربری خود را انتخاب و دکمه ذخیره را کلیک نمایید!',
            SELECT_AVATAR: 'آواتار را انتخاب کنید',
            PHONECALL_INTERVIEW_DESCRIPTION: 'کاربر گرامی به منظور حفظ و ارتقاء امنیت حساب کاربری شما, الزامی می باشد که برای بهره گیری از سرویس های مالی اقدام به احراز هویت از طریق تماس تلفنی کارشناسان ما نمایید. لطفا جهت برقراری ارتباط با کارشناسان ما و انجام احراز هویت بر روی دکمه زیر کلیک نمایید. لطفا توجه نمایید که در صورت عدم پاسخگویی به تماس کارشناسان ما شما تا 3 ساعت قادر به ثبت درخواست مجدد جهت مصاحبه تلفنی نخواهید.',
            PHONECALL_INTERVIEW_DESCRIPTION1: '1.در صورت نیاز به ثبت هر یک از درخواست های زیر نسبت به وریفای مصاحبه تلفنی اقدام نمایید، در غیر اینصورت نیازی به گذراندن این مرحله ندارید.',
            ADDRESS_DESCRIPTION1: '1.در صورت نیاز به ثبت هر یک از درخواست های زیر نسبت به وریفای آدرس اقدام نمایید، در غیر اینصورت نیازی به گذراندن این مرحله ندارید.',
            PHONECALL_INTERVIEW_DESCRIPTION2: '2. لطفا توجه نمایید که در صورت عدم پاسخگویی به تماس کارشناسان ما تا 3 ساعت قادر به ثبت درخواست مجدد جهت مصاحبه تلفنی نخواهید بود.',
            CALL_ME: 'با من تماس بگیر!',
            RETRY_CALL_DIALOG_TEXT: 'لطفا توجه داشته باشید که برای بهره گیری از سرویس های مالی احراز هویت شما از طریق تماس تلفنی کارشناسان ما الزامی می باشد. بدین منظور لطفا بر روی گزینه تلاش مجدد کلیک نمایید.',
            WAITING_FOR_PHONECALL: 'کاربر گرامی درخواست شما ارسال شده است و در مدت زمان 2 ساعت با شما تماس حاصل میگردد لطفا صبور باشید.',
            PHONECALL_INTERVIEW_DONE: 'شما مصاحبه تلفنی را با موفقیت گذرانده اید!',
            PHONECALL_INTERVIEW_REJECTED: 'درخواست شما رد شد',
            PHONECALL_INTERVIEW_CONFIRM_DES: 'کاربر گرامی توجه داشته باشید که تایید تماس های تلفنی فقط برای موارد زیر الزامی است در غیر این صورت نیازی به انجام این تایید نخواهید داشت',
            SUPPORT: 'پشتیبانی',
            SUSPENDED: 'معلق شده',
            SUSPEND_ALERT: 'کیف پول های شما مسدود شد.',
            SKIP: 'رد کردن',
            REQUESTS_TYPE: {
                DEPOSIT_E_MONEY: 'شارژ از طریق پرداخت محلی',
                DEPOSIT_MONEY_CURRENCY: 'شارژ از طریق پول الکترونیک',
                EXCHANGE_MONEY_CURRENCY: 'تبدیل(پرداخت محلی)',
                WITHDRAWAL_POINT: 'برداشت امتیاز',
                SEND_MONEY_CURRENCY: 'ارسال از طریق پرداخت محلی',
                SEND_TC_WALLET: 'ارسال از کیف پول',
                SEND_E_MONEY: 'ارسال از طریق پول الکترونیک',
                VOUCHER: 'خرید ووچر',
                WITHDRAWAL_E_MONEY: 'برداشت از طریق پول الکترونیک',
                WITHDRAWAL_MONEY_CURRENCY: 'برداشت از طریق پرداخت محلی',
            },
            VERIFY: {
                VERIFY: 'تایید',
                REQUIRED: 'اجباری',
                OPTIONAL: "اختیاری",
                TYPE: {
                    ADDRESS: 'اطلاعات آدرس',
                    PERSONAL: 'اطلاعات شخصی',
                    PERSONAL_IDENTITY: 'اطلاعات شخصی',
                    PERSONAL_PASSPORT: 'اطلاعات شخصی',
                    DRIVER_LICENSE: 'اطلاعات شخصی',
                    PHOTO_UPLOAD: 'اطلاعات عکس',
                    PHOTO_CAMERA: 'اطلاعات عکس',
                    PHOTO: 'عکس'
                },
                NOTIFY: {
                    TITLE: {
                        VERIFY_INFO: 'تایید اطلاعات'
                    },
                    NOTIFICATION: {
                        BODY: {
                            ACCEPTED: '{{0}} شما تایید شد.',
                            REJECTED: '{{0}} شما رد شد.'
                        }
                    },
                    KYC: {
                        NOTIFICATION: {
                            TITLE: {
                                ACCEPTED: 'احراز هویت',
                                REJECTED: 'احراز هویت'
                            },
                            BODY: {
                                REJECTED: 'احراز هویت شما در سیستم رد شد.',
                                ACCEPTED: 'احراز هویت شما با موفقیت در سیستم تأیید شد.'
                            }
                        }
                    }
                },
                KYC: {
                    INFORMATION: 'اطلاعات',
                    ENTER_TO_KYC: 'وارد KYC شوید',
                    IRANIAN_USERS_CONFIRM_ALERT: 'لطفا اگر مدارک ارسالی شما صادره از ایران می باشد حتما مشخصات خود (نام - نام خانوادگی) را به فارسی وارد نمایید.',
                    DESCRIPTION: 'کاربر گرامی لطفا جهت افزایش امنیت و جلوگیری از هرگونه تخلف سودجویانه احراز هویت خود را انجام دهید',
                    ALERT_ERROR: 'متأسفانه احراز هویت شما انجام نشد، لطفاً با تیم پشتیبانی تماس بگیرید',
                    ALERT_DONE: 'احراز هویت شما با موفقیت انجام شده است.',
                    ALERT_WAITING: 'در حال تکمیل پروسه احراز هویت ...',
                },
                LETTER_OF_COMMITMENT: {
                    ALERT_DONE: 'شما با موفقیت تعهد نامه خود را ارسال نموده اید.',
                    ALERT_MISS_MATCH_DATA: 'متأسفانه احراز هویت شما با مشکل مواجه، لطفاً با تیم پشتیبانی تماس بگیرید.',
                    TEXT: 'اینجانب <strong>{{name}}</strong> با شماره ملی <strong>{{code}}</strong> مدارک خود را جهت احراز هویت در سایت (Top Change) ارسال کرده ام و با آگاهی کامل تصدیق می کنم که ثبت نام توسط اینجانب انجام شده است و مدارک را در اختیار شخصی دیگر قرار نداده ام. همچنین متعهد می شوم از دریافت پول نقد و ارز دیجیتال به هر شکلی در ازای استفاده از حساب کاربری ام توسط افراد دیگر خودداری کنم. اینجانب تایید می کنم که اطلاعات حساب بانکی خود را در اختیار شخص دیگری قرار نداده ام و در صورتی دریافت سپرده غیر قانونی مسئولیت قانونی و قضایی آن از جمله مجازات قانونی و جبران خسارت شاکی بر عهده بنده است.',
                    CONFIRM_CHECKBOX: 'اطلاعات فوق را تایید می نمایم',
                    MISS_MATCH_DATA: 'اطلاعات متناقض',
                }
            },

            ERROR: {
                PASSWORD_IS_NOT_SAME: 'تایید رمز جدید با رمز جدید متفاوت است'
            },
            TAKE_PIC_DESCRIPTION: 'کاربر گرامی جهت جلوگیری از هر گونه تخلفات و حفظ امنیت تراکنش ها عکس خود را با مشخصات زیر برای ما ارسال نمایید.' + '<br/>' + '* تمامی اطلاعات را با خودکارآبی بر روی کاغذ سفید نوشته شود.' + '<br/>' + '* حجم عکس کمتر از 2 مگابایت باشد.' + '<br/>' + ' <div class="title">۱- برگه سفید</div> یک برگه سفید را با اطلاعات مشخص شده در تصویر مقابل خود بگیرید.' + '<br/>' + ' <div class="title">۲- چسباندن کارت شناسایی</div> کارت شناسایی خود را همانند آنچه در تصویر میبینید به برگه بچسبانید.' + '<br/>' + ' <div class="title">۳- نوشتن کد</div> کد نمایش داده شده در فرم زیر با دست خط خودتان در برگه بنویسید.' + '<br/>' + ' <div class="title">۴- نوشتن متن</div> اینجانب ...... با شماره ملی ...... در تاریخ ......مدارک خود را جهت احراز هویت در سایت تاپ چنج ارسال کرده و این اطلاعات را در اختیار دیگری قرار نداده‌ام و متعهد می‌شوم از دریافت وجه و خرید ارز دیجیتال برای اشخاص دیگری تحت هر عنوانی خودداری کنم و هرگونه مسئولیت پیگرد حقوقی و قضایی این موارد را بپذیرم.' + '<br/>' + ' <div class="title">۵- امضا</div> امضای شما.',
            ALERT: {
                PASSWORD_CHANGED_SUCCESSFULLY: 'کلمه عبور با موفقیت تغییر یافت! لطفا مجددا به سیستم وارد شوید',
                MOBILE_NUMBER_HAS_BEEN_VERIFIED: 'شماره تلفن همراه شما با موفقیت تایید شد',
                MOBILE_NUMBER_HAS_BEEN_SUCCESSFULLY_REGISTRED: 'شماره تلفن همراه شما با موفقیت ثبت شد',
                PEERSONAL_INFO_HAS_BEEN_UPDATED: 'اطلاعات شخصی شما با موفقیت بروزرسانی گردید.',
                ADDRESS_HAS_BEEN_UPDATED: 'اطلاعات آدرس شما با موفقیت به روزرسانی گردید.',
                ERROR_PERSONAL_INFO_NOT_VERIFIED: 'اطلاعات شخصی شما تایید نشده است',
                ERROR_PERSONAL_INFO_REJECTED: 'درخواست تایید اطلاعات شخصی شما رد شد',
                ERROR_PHOTO_VERIFY_REJECTED: 'درخواست اهراز هویت شما رد شد',
                PERSONAL_INFO_SHOULD_MATCH_WITH_ID_CARD: 'توجه : اطلاعات شخصی وارد شده باید با کارت ملی و یا پاسپورت شما مطابقت داشته باشد.',
                PERSONAL_INFO_VERIFY_IS_PENDING: 'اطلاعات شما توسط کارشناسان ما در حال بررسی می باشد.',
                ADDRESS_VERIFY_IS_PENDING: 'اطلاعات آدرس شما توسط کارشناسان ما در حال بررسی می باشد.',
                PHOTO_VERIFY_IS_PENDING: 'اطلاعات شما توسط کارشناسان ما در حال بررسی می باشد.',
                PERSONAL_INFO_VERIFYED: 'اطلاعات شما با موفقیت تایید شده است',
                PHOTO_VERIFY_ACCEPTED: 'هویت شما با موفقیت تایید شده است.',
                ADDRESS_VERIFYED: 'آدرس شما با موفقیت تایید شده است',
                DOCUMENTS_UPLOADED: 'بارگزاری مدارک با موفقیت انجام شد',
                ERROR_ADDRESS_INFO_REJECTED: 'در خواست تایید آدرس شما رد شد.',
                ADDRESS_UPLOAD_HINT: 'توجه : برای تایید آدرس یک اسکن واضح از یکی از مدارک معتبر مانند قبض سال جاری (تلفن ثابت، آب، برق، گاز)، سند ملک یا وسایل نقلیه، اجاره نامه و بیمه نامه آپلود کنید. \n برای تایید اطلاعات باید ادرس وارد شده در سیستم و اطلاعات روی قبض ارسالی یکسان باشند',
                ERROR_ADDRESS_INFO_NOT_VERIFIED: 'اطلاعات ادرس شما تایید نشده است',
                VERIFY_NEEDS: 'اطلاعات شخصی شما تایید نشده است.',
                NEED_FILL_PERSONAL_FORM: 'لطفا ابتدا فرم اطلاعات شخصی را تکمیل نموده تا قسمت تایید اطلاعات کاربری برای شما فعال شود ',
                NEED_FILL_ADDRESS_FORM: 'تایید آدرس اجباری نمی باشد ، در صورتیکه بخواهید از تمامی امکانات سایت بهره مند شوید می توانید آدرس خود را تایید نمایید',
                ADDRESS_IS_OPTIONAL: 'لطفا ابتدا فرم اطلاعات آدرس را تکمیل نموده تا قسمت تایید اطلاعات شخصی برای شما فعال شود',
                PASSWORD_MIN_LENGTH: 'کلمه ی عبور باید حداقل {{value}} کارکتر باشد',
                PASSWORD_MAX_LENGTH: 'کلمه ی عبور حداکثر می تواند {{value}} کارکتر باشد',
            }

        },
        NOTIFICATION: {
            TITLE: 'اعلان',
            NOTIFICATIONS: 'اعلان ها',
            SELL_SUCCESSFUL: 'فروش موفقت آمیز',
            BUY_SUCCESSFUL: 'خرید موفقت آمیز',
            MY_ORDERS: 'سفارش‌های من',
            REGISTER_NEW_AD: 'ثبت آگهی جدید',
            SELL: 'فروش ارز',
            DESCRIPTION: 'توضیحات',
            EMPTY: 'اعلانی برای نمایش وجود ندارد',
            FRIENDS: 'دوستان',
            TICKETS: 'تیکت',
            ADMIN: 'پشتیبان',
            NEW: 'جدید',
            ME: 'خودم',
            TYPE: 'نوع اعلان',
            EMPTY_TICKETS: 'موردی برای نمایش وجود ندارد',
            EMPTY_FRIENDS: 'درخواست جدیدی وجود ندارد',
            ALERTS: 'اعلانات',
            YOU_HAVE_NO_NEW_MESSAGES: 'شما پیام جدیدی ندارید.',
            SHOW_ALL: 'نمایش همه',
            READ_ALL: 'خواندن همه',
            ANNOUNCEMENT: 'اطلاعیه‌ها',
        },
        P2P: {
            DEPOSIT_PAGE: {
                EARN_MORE_P2P: 'با P2P سود کن و جایزه ببر',
                SALE: 'موجودی'
            },
            USER: {
                NOTIFICATION: {
                    BODY: {
                        ADVERTISEMENT: {
                            INPROGRESS: "شما یک خریدار برای آگهی فروش <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> دارید.",
                            CREATED: "آگهی فروش <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> &rlm;( P2P ) شما با موفقیت ثبت شد.",
                            DONE: "آگهی فروش <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> &rlm;( P2P ) شما با موفقت تکمیل شد.",
                            CANCEL: "آگهی فروش <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> &rlm;( P2P ) شما با موفقیت لغو شد.",
                            CLOSED: "آگهی خرید <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> &rlm;( P2P ) شما  بسته شد.",
                            RETURN: {
                                REMAIN: {
                                    AMOUNT: {
                                        DONE: "آگهی فروش <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{2}}</span></span> &rlm;( P2P ) شما به کمتر از « کمترین خرید » رسید و مبلغ <span class=\"fa-number-dir\">&rlm;{{1}}<span>{{2}}</span></span> به کیف پول {{3}} منتقل شد."
                                    }
                                }
                            },
                            ORDER: {
                                TAKECOLLATERAL: "مبلغ <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> &rlm; وثیقه ی  شما توسط پشتیبانی برداشته شد."
                            }
                        },
                        SELLER: {
                            DONE: "سفارش فروش <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> &rlm;( P2P ) شما با موفقت به پایان رسید."
                        },
                        BUYER: {
                            DONE: "سفارش خرید <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> &rlm;( P2P ) شما با موفقت به پایان رسید."
                        },

                        ORDER: {
                            CONFIRM: "کاربر گرامی لطفا نسبت به بررسی صحت پرداخت و آزاد سازی آگهی فروش <span class=\"fa-number-dir\">&rlm;{{0}}<span>{{3}}</span></span> &rlm;( P2P ) هر چه سریع تر اقدام کنید.",
                            TAKECOLLATERAL: "مبلغ <span class=\"fa-number-dir\">&rlm;{{2}}<span>{{3}}</span></span> &rlm; وثیقه ی  شما توسط پشتیبانی برداشته شد."
                        }
                    },
                    TITLE: {
                        ADVERTISEMENT: {
                            INPROGRESS: "درخواست خرید P2P",
                            CREATED: "آگهی فروش P2P",
                            DONE: "آگهی فروش P2P",
                            CANCEL: "لغو آگهی P2P",

                            CLOSED: "بسته شدن آگهی P2P",
                            RETURN: {
                                REMAIN: {
                                    AMOUNT: {
                                        DONE: "بازگشت مبلغ باقیمانده P2P"
                                    }
                                }
                            },
                            ORDER: {
                                TAKECOLLATERAL: "وثیقه P2P",
                            }
                        },
                        ORDER: {
                            CONFIRM: "صحت پرداخت P2P",
                            TAKECOLLATERAL: "وثیقه P2P",
                        },
                        SELLER: {
                            DONE: "سفارش فروش P2P"
                        },
                        BUYER: {
                            DONE: "سفارش خرید P2P"
                        }
                    },
                }

            },
            ADMIN: {
                NOTIFICATION: {
                    TITLE: {
                        ADVERTISEMENT: {
                            CANCEL: 'لغو آگهی P2P'
                        }
                    },
                    BODY: {
                        ADVERTISEMENT: {
                            CANCEL: 'آگهی شما با شماره پیگیری {{1}} توسط پشتیبانی لغو شد.'
                        }
                    }
                }
            },
            FILTER: 'فیلتر',
            TYPE: 'نوع',
            STATUS: 'وضعیت',
            WALLET: 'کیف پول',
            SELECT_WALLET: 'انتخاب کیف پول',
            FROM_DATE: 'از تاریخ',
            TO_DATE: 'تا تاریخ',
            CLEAR_ALL: 'پاک کردن همه',
            SEARCH: 'جستجو',
            TRACKING_NUMBER: 'شماره پیگیری',
            OPERATION: 'عملیات',
            VALUE: 'مقدار',
            PAYMENT_METHOD: 'روش پرداخت',
            REQUEST_DATE: 'تاریخ درخواست',
            BUYERS: 'خریدارها',
            BUYER: 'خریدار',
            TABLE_EMPTY_MESSAGE: 'نتیجه ای یافت نشد!',
            BUY: 'خرید',
            SELL: 'فروش',
            DONE: 'انجام شد',
            IN_PROGRESS: 'در جریان',
            SUPPORT: 'پشتیبانی',
            CLOSED: 'بسته',
            TRANSFER_RATE: 'نرخ تبدیل',
            PRICE: 'قیمت',
            BACK: 'بازگشت',
            RELEASE: 'آزاد سازی',
            CARD_NUMBER: 'شماره کارت',
            DEPOSIT: 'مبلغ واریز شده',
            DOCUMENT: 'عکس رسید',
            RECEIVE_CONFIRMATION_TITLE: 'آیا از صحت پرداخت خریدار مطمئن هستید ؟',
            CONFIRM_CONTINUE: 'تایید و ادامه',
            CONFIRM: 'تایید',
            CANCEL: 'لغو',
            GET_CODE: 'دریافت کد',
            CHECK_AGAIN: 'بازگشت و بررسی مجدد',
            TWO_STEP_VERIFICATION: 'احراز هویت دو مرحله‌ای اکانت',
            CALL_SUPPORT: 'تماس با پشتیبانی',
            ENTER_CONVERSATION: 'وارد گفتگو شوید',
            MY_ADS: 'آگهی‌های من',
            CREATE_NEW_AD: 'ساخت آگهی جدید',
            SOLD_PERCENTAGE: 'درصد فروش‌رفته',
            SELLABLE_AMOUNT: 'مقدار قابل فروش',
            SOLD_AMOUNT: 'مقدار فروش رفته',
            EXCHANGE_REATE: 'نرخ تبدیل',
            AD_CREATE_DATE: 'تاریخ ثبت آگهی',
            SHOW_ORDER: 'مشاهده سفارش',
            PERCENTAGE: 'درصد',
            VALIDATION: {
                CANT_BE_MORE_THAN_REQUEST_AMOUNT: "مبلغ نباید بیشتر ازمبلغ قابل فروش باشد",
                CANT_BE_SET_ZERO: "مبلغ نمیتواند صفر باشد",
                CANT_BE_LESS_VALUE: 'کمتر از {{value}} مبلغ نمیتواند باشد.',
                SELECT_WALLET_FIRST: 'ابتدا کیف پول مورد نظر خود را انتخاب کنید',
                AMOUNT_CANT_BE_MORE_THAN_BALANCE: 'مبلغ نمی تواند از موجوی کیف پول بیشتر باشد',
                AMOUNT_CANT_BE_MORE_THAN_ADV_AMOUNT: 'مبلغ درخواستی نمی تواند از مبلغ کل اگهی بیشتر باشد',
                AMOUNT_CANT_BE_MORE_MAX_PAY: 'مبلغ پرداختی باید کمتر از {{amount}} {{currency}} باشد.',
                AMOUNT_CANT_BE_LESS_THAN_TEN: 'حداقل مقدار قابل فروش 10 {{value}} است .',
                AMOUNT_CANT_BE_LESS_THAN: 'حداقل مقدار قابل فروش {{value}} {{currency}} است .',
                AMOUNT_CANT_BE_SET_ZERO: 'مقدار قابل فروش نمیتواند صفر باشد.',
            },
            DESCRIPTION: {
                RELEASE_PROPERTY: 'لطفا دارایی فروخته شده خود را در مدت زمان مشخص شده آزاد کنید. در غیر این صورت خریدار به پشتیبانی مراجعه خواهد کرد و پس از بررسی کارشناسان پلتفرم ارز فروخته شده را به کیف پول خریدار منتقل خواهد کرد.',
                PAYMENT_LIMIT: 'با توجه به محدودیت پرداخت از طریق کارت به کارت، این امکان وجود دارد که خریدار از چند کارت بانکی استفاده کرده باشد بنابراین در بررسی دقیق اطلاعات واریزی دقت کنید.',
                INFORMATION_DISCREPANCY: 'در صورت هر گونه مغایرت اطلاعات پرداختی فروشنده، ارز خود را آزاد نکنید و دکمه «عدم صحت اطلاعات» را بزنید. در صورت آزادسازی اشتباه، هیچ مسئولیتی در برابر بازگرداندن وجه پرداختی شما نخواهد داشت.',
                IMPORTANT_INFORMATION: 'اطلاعات حساس بانکی خود را در اختیار کاربران نگذارید تا افراد از آن سواستفاده نکنند.',
                TRANSFORM_THROUGH_CHANNEL: 'شما هیچ وقت نباید با هیچ فرم جا به جایی پول که از طریق کانال ثالثی همچون شبکه های اجتماعی و یا پیامرسان ها و یا معامله رو در رو، معامله ای انجام هید. پلتفرم نمی تواند مسئول خسارت و یا ضرری باشد که خارج از پلتفرم انجام شده باشد. همچنین پلتفرم در هیچ بخشی از جا به جایی P2P دخالتی ندارد.',
                PAYMENT_SPECIFIED_TIME: 'لطفا پرداخت خود را در زمان مشخص انجام دهید و مطمئن شوید دکمه « پرداخت شد، بعدی » را بزنید. بعد از اینکه فروشنده پرداخت را تایید کرد ، سیستم دارایی دیجیتال را به اکانت شما منتقل میکند.',
                POSSIBLE_MULTIPLE_CARD: 'با توجه به محدودیت پرداخت از طریق کارت به کارت ، این امکان وجود دارد که از چند کارت بانکی استفاده کنید.',
                DEPOSIT_FROM_ACCOUNT: 'توجه داشته باشید که حتما و اکیدا از حساب بانکی انتخابی خود پول  واریز کنید. در صورت هرگونه مغایرت اطلاعات پرداختی، فروشنده ارز  خود را آزاد نخواهد کرد و هیچ مسئولیتی دربرابر بازگرداندن وجه پرداختی شما نخواهد داشت.',
                DEPOSIT_AMOUNT_CORRECTLY: 'هنگام واریز پول مراقب باشد مبلغ را درست واریز کنید. در صورت کم بودن مبلغ واریزی ، پلتفرم  معادل مبلغ واریزی شما ، ارز به  کیف پول شما واریز می‌کند. همنچنین در صورت واریز بیش از مبلغ تعیین شده ، تلاش کنید با فروشنده گفتگو کنید و مشکل خود را حل کنید. پلتفرم در این زمینه مسئولیتی نخواهد داشت.',
                AFTER_EACH_PAYMENT: 'توجه داشته باشید که بعد از هر پرداخت ،شماره کارت ، شماره پیگیری ( ارجاع ) و مبلغ پرداختی خود را وارد کنید و همچنین عکس رسید پرداخت خود را در محل تعبیه شده، آپلود کنید.',
                PAYMENT_RECEIPT: 'لطفا رسید پرداخت های خود را پایان معامله نزد خود نگه دارید.',

                PAY_ATTENTION: "به مدت زمان باقیمانده جهت پرداخت دقت نمایید",
                PAY_WITH_BANK: "جهت پرداخت با کارت بانکی میتوانید مبلغ را از یک یا چند کارت ارسال کنید",
                NOTE_BANK_CARDS: "توجه داشته باشید همه‌ی کارت‌های بانکی استفاده‌شده باید حتما به نام خودتان باشد. در غیر اینصورت فروشنده میتواند مبلغ را نپذیرد، معامله فسخ شده و پلتفرم مسئولیتی در این قبال ندارد.",
                ENSURE_AMOUNT_SEND: "در ارسال مبلغ دقت کنید که بیشتر یا کمتر نباشد. در این‌صورت نیاز به ارتباط با فروشنده از سمت پلتفرم وجود دارد و ممکن است حل مشکل زمان زیادی ببرد.",
                AFTER_PAYMENT: "بعد از هر پرداخت، شماره کارت، شماره پیگیری(ارجاع) و مبلغ پرداختی خود را وارد کنید و همچنین عکس رسید پرداخت خود را در محل تعبیه‌شده، آپلود نمایید.",
                PAYMENT_RECEIPTS: "لطفا رسید پرداخت‌های خود را پایان معامله نزد خود نگه دارید",
                CONDUCT_TRANSACTION: "به هیچ عنوان با هیچ فرم جا‌به‌جایی پول که از طریق کانال ثالثی همچون شبکه‌های اجتماعی و یا پیام‌رسان‌ها و یا معامله‌ی رودررو، معامله‌ای انجام ندهید. پلتفرم نمی‌تواند مسئول خسارت و یا ضرری باشد که خارج از پلتفرم انجام شده‌است.",
                ADDITIONALLY: "همچنین پلتفرم هیچ دخل و تصرفی در معاملات P2P ندارد و صرفا این بستر را جهت انجام معاملات شما ایجاد کرده‌است.",
            },
            CUSTOMER_PAYMENT_INFORMATION: 'اطلاعات پرداخت مشتری',
            PAYMENT_INFORMATION: 'اطلاعات پرداخت',
            TOO_MUCH_DEPOSITED: 'خریدار مبلغ بیش از اندازه واریز کرده است. لطفا با پشتیبانی تماس بگیرید.',
            EXCESS_AMOUNT: 'مبلغ مازاد',
            REMAINING_RELEASE_TIME: 'زمان باقی مانده آزاد سازی',
            CHAT_WITH_SUPPORT: 'چت با پشتیبانی',
            ENTER_YOUR_MESSAGE: 'پیام خود را وارد کنید',
            CONFIRMATION: {
                CONFIRMING: 'توجه فرمایید تایید پیام فوق، به منزله‌ی دریافت کامل پول و تایید صحت اطلاعات پرداختی خریدار است.',
                DISCREPANCIES: 'لطفا در صورت مشاهده هرگونه مغایرت اکیدا تاکید می‌شود با پشتیبانی در ارتباط باشید.',
                AFTER_CONFIRMING: 'بعد از تایید این پیام، پول شما آزاد سازی می‌شود و پلتفرم هیچ گونه مسئولیتی در قبال آن نخواهد داشت.'
            },
            EMAIL_CODE: 'کد ایمیل',
            SENT_EMAIL_TEXT: "کد 6 رقمی ارسال شده به {{value}} را وارد کنید.",
            ADVERTISE: {
                SEARCH: 'جستجو',
                CURRENCY_TYPE: 'نوع ارز',
                CURRENCY_AMOUNT: 'مقدار ارز دلخواه',
                DESIRED_AMOUNT: 'مبلغ مورد نظر',
                ACTIVE_ADVERTISES: 'آگهی‌ها‌ی فعال',
                SELLER: 'فروشنده',
                TRANSACTION: 'معامله',
                COMPLETE: 'تکمیل',
                EXCHANGE_RATE: 'نرخ تبدیل',
                SELL_AMOUNT: 'مبلغ فروش',
                SELL: 'فروش',
                MIN: 'حداقل',
                PAYMENT_METHOD: 'روش پرداخت',
                BUY_CURRENCY: 'خرید ارز',
                BUY: 'خرید',
                ADVERTISE: 'آگهی ها',
                VIDEOHELP: 'راهنمای ویدیویی',
                CREATE_ADVERTISE: 'ساخت آگهی',
                MY_ORDERS: 'سفارش‌های من',
                ENTER_AMOUNT: "وارد کردن مقدار ارز",
                PAID_VALUE: "مبلغ پرداختی شما",
                SELECT_WALLET: "انتخاب کیف پول",
                USER: "کاربر",
                ORDER: "سفارش",
                COMPLETED: "تکمیل شده ",
                AVAILABLE: "موجود",
                TIME_LIMIT: "محدودیت زمان واریز",
                MINUTE: "دقیقه",
                CANCEL: "انصراف",
                DOLLAR: 'تی‌سی‌دی',
                RIAL: 'ریال',
                DERHAM: 'درهم',
                EURO: 'یورو',
                DERHAM_WALLET: 'کیف پول درهم ',
                EURO_WALLET: 'کیف پول یورو ',
                DOLLAR_WALLET: 'کیف پول تی‌سی‌دی  ',
                EMPTY_DATA: 'نتیجه ای یافت نشد',
                ORDER_BY: 'نمایش بر اساس',
                NewestListing: 'جدیدترین آگهی',
                LowestPrice: 'پایین‌ترین نرخ تبدیل',
                HighestAmount: 'بیشترین موجودی',
                DEALS: 'معامله',
                SUCCESSFUL: 'موفق',
                AMOUNT: 'موجودی',
            },
            BUYER_INFORMATION: "اطلاعات خریدار",
            ENTERED_VALUE_EXCEEDS_LIMITS: "مقدار وارد شده بیشتر از حد مجاز است",
            MINIMUM_ALLOWED_AMOUNT: "حداقل مبلغ مجاز {{number}} {{currency}} می باشد",
            VIEW_MY_ORDERS: "مشاهده سفارش‌های من",
            MY_AD_INFO: "اطلاعات آگهی من",
            DETAILS: "جزییات",
            REQUESTED_FOR_SALE: "مبلغ درخواستی برای فروش",
            SALABLE_AMOUNT: "مبلغ قابل فروش",
            COLLATERAL_AMOUNT: "وثیقه ({{value}}%)",
            COMMISSION: "کمیسیون ({{value}}%) ",
            EQUIVALENT_RIAL: "معادل ریالی",
            MINIMUM_PURCHASE: "کمترین خرید در هر سفارش",
            CARD_TO_CARD: "کارت به کارت",
            SATNA: "ساتنا",
            PAYA: "پایا",
            BUYER_DIPOSIT_LIMIT: "محدودیت زمان واریز خریدار",
            ADVERTISING_PERIOD: "مدت زمان آگهی",
            VIEW_PAYMENTS: "مشاهده پرداخت ها",
            ORDER_COMPLETED: "سفارش شما تکمیل شد",
            SHARE_YOUR_EXPERIENCE: "لطفا تجربه ی خود را از این معامله با ما به اشتراک بگذارید.",
            PAYMENTS: "پرداخت ها",
            PURCHASE_INFO: "اطلاعات فروش من",
            PAYMENT_INFO: "اطلاعات پرداخت من",
            NEXT: "بعدی",
            STEPPER: {
                PURCHASE_AMOUNT: "تعیین مقدار خرید",
                SALES_DETERMINATION: "تعیین مقدار فروش",
                COMMITMENT_LATER: "تعهد نامه",
                CONFIRM_INFORMATION: 'تایید اطلاعات',
                ADVERTISEMENT_REGISTRATION: 'ثبت آگهی',
                CURRENCY_RECEIPT: 'دریافت ارز',
                PAYMENT: "پرداخت",
            },
            ENTER_CURRENCY_AMOUNT: "وارد کردن مقدار ارز",
            CURRENCY_AMOUNT: "مقدار ارز",
            DOLLAR: "تی‌سی‌دی",
            PAYMENT_AMOUNT: "مبلغ پرداختی شما",
            RIAL: "ریال",
            CHOOSE_WALLET: "انتخاب کیف پول",
            CHOOSE_BANK_ACCOUNT: "انتخاب حساب بانکی",
            USER_DOT: "کاربر:",
            DIPOSIT_DOT: "موجودی:",
            TRANSFER_RATE_DOT: "نرخ تبدیل:",
            PAYMENT_METHOD_DOT: "روش پرداخت:",
            DIPOSIT_TIME_LIMIT_DOT: "محدودیت زمان واریز:",
            BUY_CURRENCY: "خرید ارز",
            COMMITMENT_LATER_DESCRIPTION: {
                RESPONSIBLE_FOR_AD: "صادق و عادل باشید، در کمال احترام برخورد کنید و در برابر آگهی خود مسؤلیت پذیر باشید.",
                SALLER_PRICE_BUYER: "قیمت سفارش های برقرار شده بین فروشنده و خریدار نهایی و غیر قابل مذاکره است",
                SPECIFIED_TIME: "لطفا آزاد سازی خود را در مدت زمان تعیین شده انجام دهید. در صورت پایان یافتن این زمان ، شما باید به خریدارو تیم پشتیبانی پاسخگو باشید. در صورت عدم پاسخگویی،پلتفرم مجاز به آزادسازی مبلغ آگهی میباشد",
                CONTROLLED_ASSETS_PLATFORM: "پرداخت شما مستقیما به حساب فروشنده میرود و فقط دارایی دیجیتالی که فروشنده در حین معامله میخواهد بفروشد توسط پلتفرم کنترل میشود.",
                DIPOSIT_FROM_ACCOUNT: "*** توجه داشته باشید که حتما و اکیدا از حساب بانکی انتخابی خود پول واریز کنید. در صورت هرگونه مغایرت اطلاعات پرداختی، فروشنده ارز خود را آزاد نخواهد کرد و هیچ مسئولیتی دربرابر بازگرداندن وجه پرداختی شما نخواهد داشت",
                DIPOSIT_FROM_ACCOUNT2: "توجه داشته باشید که مبلغ دریافتی باید از همان حساب ذکر شده در فرم پرداخت واریز شده باشد . در صورت مغاییرت به هیچ عنوان آزاد سازی را انجام ندهید و به پشتیبانی اطلاع دهید . در صورت آزاد سازی پلتفرم هیجگونه مسعولیتی در قبال مبلغ آزاد شده ندارد",
                OVERPAY_CARE: "درصورت مغاییرت مبلغ دریافتی بافرم پرداخت ،به هیچ عنوان آزادسازی راانجام ندهید و به پشتیبانی مراجعه بفرمایید",
                PRESS_WITHOUT_PAYING: "اگر بدون اینکه پرداخت کرده باشید و اطلاعات فرم پرداخت رو با اطلاعات غیر واقعی پر کرده باشید و روی دکمه پرداخت شد بزنید، دسترسی شما برای همیشه از این سرویس بسته خواهد شد و پلتفرم ادعای هرگونه خسارت ناشی از آن را محفوظ می دارد",
                DOES_NOT_PAY_LIMITATION: "درصورتیکه پس از دریافت مبلغ درحساب بانکی خود آزادسازی را انجام ندهید پلتفرم میتواند آزادسازی راانجام داده ودسترسی شمابه سرویس پی تو پی رابرای همیشه مسدود کند",
                DIGITAL_ASSETS_MENTION: "لطفا به اطلاعاتی درباره ی دارایی های دیجیتال خود حین جا به جایی های بانکی اشاره نکنید . در غیر این صورت ممکن است پرداخت شما رهگیری گردد و یا اینکه بانک مبلغ شما رو بلوکه کند.",
                AVAILABLE_UNFULFILLED: "اگر سفارشات تکمیل نشده یا اختلافاتی با خریدار دارید، لطفاً مطمئن شوید که همیشه از طریق شماره تلفن همراه یا ایمیلی که در پلتفرم ثبت کرده‌اید در دسترس باشید.",
                THIRD_CHANNELS: "شما هیچ وقت نباید با هیچ فرم جا به جایی پول که از طریق کانال ثالثی همچون شبکه های اجتماعی و یا پیامرسان ها و یا معامله ی رودر رو ، معامله ای انجام دهید. پلتفرم نمیتواند مسئول خسارت و یا ضرری باشد که خارج از پلتفرم انجام شده باشد. همچنین پلتفرم در هیچ بخشی از جابه‌جایی P2P دخالتی ندارد.",
                COMMITMENT_LATER: "کاربران باید در هنگام استفاده از پلتفرم از به کار بردن الفاظ رکیک و توهین آمیز خودداری کنند. در صورت مشاهده این رفتار با شما برخورد خواهد شد.",
                SHARE_ACCOUNT_WARNING: "در هیچ صورت از حساب کاربری فرد دیگری استفاده نکنید. همچنین اطلاعات حساب خود را به هیچ عنوان در اختیار دیگران قرار ندهید. در صورت دیده شدن چنین رفتاری حساب شما مسدود خواهد شد و در صورت نیاز به پلیس فتا اطلاع داده خواهد شد.",
                AGENDA_VIOLATION: "در صورت هرگونه نقض «دستورالعمل‌های فروشنده» اعلام شده، پلتفرم می‌تواند مطابق با قوانین و مقررات مربوطه، یا بنا به صلاح دید خود، اقداماتی را که صلاح می‌داند، از جمله گرفته شدن وثیقه ، مسدود کردن حساب متخلف یا غیرفعال کردن هر گونه عملکرد حساب در پلتفرم معاملاتی اتخاذ کند.",

                THIRD_PARTY_PAYMENT_WARNING: "فقط از حساب بانکی و روش پرداختی استفاده کنید که به نام خودتان و مطابق اطلاعات احراز هویت‌شده شما باشد؛ پرداخت شخص ثالث مجاز نیست.",
                ASSET_LOCK_WARNING: "پس از شروع معامله، دارایی فروشنده در امانت قفل می‌شود و تا تکمیل یا لغو سفارش قابل استفاده نخواهد بود.",
                PAYMENT_DEADLINE_WARNING: "خریدار موظف است مبلغ کامل سفارش را در مهلت تعیین‌شده و طبق اطلاعات پرداخت اعلام‌شده واریز کند.",
                FINAL_TRANSACTION_WARNING: "معاملات P2P نهایی هستند؛ قبل از ثبت سفارش، مبلغ، قیمت و اطلاعات پرداخت را با دقت بررسی کنید.",

                BUYER_PAYMENT_DEADLINE: "خریدار موظف است مبلغ کامل سفارش را در مهلت تعیین‌شده و طبق اطلاعات پرداخت اعلام‌شده واریز کند.",
                RELEASE_DEADLINE_WARNING: "لطفا آزاد سازی خود را در مدت زمان تعیین شده انجام دهید. در صورت پایان یافتن این زمان ، شما باید به خریدار و تیم پشتیبانی پاسخگو باشید. در صورت عدم پاسخگویی، پلتفرم مجاز به آزادسازی مبلغ آگهی میباشد",
                FAKE_PAYMENT_CONFIRMATION_WARNING: "اگر بدون اینکه پرداخت کرده باشید و اطلاعات فرم پرداخت رو با اطلاعات غیر واقعی پر کرده باشید و روی دکمه پرداخت شد بزنید، دسترسی شما برای همیشه از این سرویس بسته خواهد شد و پلتفرم ادعای هرگونه خسارت ناشی از آن را محفوظ می دارد.",
                OFF_PLATFORM_TRANSACTION_WARNING: "شما هیچ وقت نباید با هیچ فرم جا به جایی پول که از طریق کانال ثالثی همچون شبکه های اجتماعی و یا پیامرسان ها و یا معامله ی رودر رو ، معامله ای انجام دهید. پلتفرم نمیتواند مسئول خسارت و یا ضرری باشد که خارج از پلتفرم انجام شده باشد. همچنین پلتفرم در هیچ بخشی از جابه‌جایی P2P دخالتی ندارد.",
            },
            COMMITMENT_ACCEPTION_PT_ONE: "اینجانب {{value}} تعهدنامه‌ی بالا،",
            RULES: " قوانین و مقررات ",
            COMMITMENT_ACCEPTION_PT_TWO: "را خواندم و با آن موافق هستم.",
            COMMITMENT_ACCEPTION: "اینجانب {{value}} تعهدنامه‌ی بالا، <span class=\"username\">قوانین و مقررات</span> را خواندم و با آن موافق هستم.",
            TERMS_COMMITMENT_AGREEMENT: "اینجانب {{value}} <a> شرایط استفاده از سرویس </a>را خواندم و با آن موافق هستم.",
            DATE_DOT: "تاریخ:",
            TIME_DOT: "زمان:",
            PAYMENT_TO_DOT: "پرداخت به:",
            RECEIVER_PARAMETER_DOT: "گیرنده: <span>{{value}} (فروشنده)</span>",
            PRICE_DOT: "مبلغ:",
            CARD_NUMBER_DOT: "شماره کارت:",
            ACCOUNT_NUMBER_DOT: "شماره حساب:",
            IBAN_NUMBER_DOT: "شماره شبا:",
            BANK_TITLE_DOT: "عنوان بانک:",
            ENTER_PAYMENT_INFORMATION: "ورود اطلاعات پرداختی شما",
            REMAINING_TIME_DOT: "زمان باقیمانده:",
            ENTER_DEPOSIT_AMOUNT: 'وارد کردن مبلغ واریزی',
            DEPOSIT_AMOUNT: 'مبلغ واریزی',
            ENTER_TRACKING_NUMBER: 'وارد کردن شماره پیگیری',
            RECEIPT_IMAGE: 'تصویر رسید(اجباری)',
            UPLOAD_LIMIT_HINT: 'کمتر از {{value}} MB',
            UPLOAD_LIMIT_ERROR: 'حداکثر حجم فایل: {{value}} مگابایت',
            UPLOAD_LIMIT_TYPE: 'فایل های مجاز: {{value}}',
            SUBMIT: 'ثبت',
            DONE_NEXT: 'پرداخت شد، بعدی',
            EXPECTATION: 'انتظار!',
            PAYMENT_NOTIFIED: 'کاربر گرامی پرداخت شما به فروشنده اطلاع داده شد.',
            AFTER_SELLER_CONFIRMED: 'بعد از تایید پرداخت شما از طرف فروشنده، پول به کیف پول شما منتقل خواهد شد.',
            WATING_SELLER_CONFIRMATION: 'کاربر گرامی، پرداخت شما به فروشنده اطلاع داده شد. برای گفتگو با فروشنده، می‌توانید از طریق آیکون چت بالای صفحه وارد چت این سفارش شوید یا به لیست سفارش‌های من مراجعه کنید. پس از تایید پرداخت، پول به کیف پول شما منتقل خواهد شد.',
            NEED_TO_CONTACT_THE_SELLER: 'نیاز به ارتباط با فروشنده دارید؟',
            ENTER_THE_ORDER_CHAT: 'ورود به چت سفارش',
            REMAINING_AMOUNT: 'مبلغ باقی مانده',
            MY_SALES_INFORMATION: 'اطلاعات خرید من',
            DESIRED_CURRENCY_AMOUNT: "مقدار ارز دلخواه",
            VALUE_NOT_ALLOWED: "مقدار وارد شده مجاز نمی باشد",
            MINIMUM_PURCHASE_PER_ORDER: "کمترین خرید در هر سفارش",
            AD_DURATION: "مدت زمان نمایش آگهی",
            DAY: "روز",
            COMPUTING: "محاسبه",
            TOTAL_REQUESTED_AMOUNT: "مقدار درخواستی کل",
            MINIMUM_ORDER_LIMIT: "کمترین حد سفارش",
            EXCHANGE_RATES_TYPES: "انواع نرخ ارز",
            FLOATING_CONVERSION_RATE: "نرخ تبدیل شناور",
            FINAL_RATE_CONVERTION: "نرخ نهایی = نرخ تبدیل شناور بازار",
            USER_DETERMINES_SALES_RATE: "تعیین نرخ فروش ( تبدیل) توسط کاربر",
            FIXED_CONVERTION_RATE: "نرخ تبدیل ثابت",
            ATTENTION: "توجه",
            GUARANTEE_AMOUNT_COMPLY: "مبلغ وثیقه به عنوان ضمانت کاربر برای رعایت اصول و قوانین P2P پلتفرم در نظر گرفته شده است.این مبلغ بعد از بسته شدن آگهی، به کیف پول شما باز خواهد گشت.",
            HIDDEN_AD_CASE: "آگهی شما در موارد زیر از دید عموم پنهان می‌شود:",
            AD_TIME_OVER: "اگر مدت زمان تعیین‌شده برای نمایش آگهی، تمام شود. در این صورت می‌توانید آگهی فعلی خود را حذف و آگهی جدیدی ایجاد کنید.",
            AD_REMAIN_AMOUNT: "مبلغ باقی‌مانده از آگهی شما، از مقدار «کمترین خرید در هر سفارش» پایین‌تر بیاید. در این صورت می‌توانید آگهی خود را حذف کنید. مبلغ باقی‌مانده به کیف پول شما باز می‌گردد.",
            ORDERS_FOR_SALE: "زمانی که ۴ سفارش برای آگهی فروش شما وجود داشته باشد، آگهی شما به طور خودکار پنهان می‌شود.",
            SUPPORT_AGAINST_ORDERS: "به محض اینکه ۳ درخواست پشتیبانی علیه سفارشات خود دریافت کنید، همه تبلیغات شما به طور موقت پنهان می‌شوند.",
            RULES_VIOLATION_BAN: "با توجه به تخطی از قوانین مشخص‌شده، کارشناس مربوطه می‌تواند شما را از استفاده از سرویس P2P به صورت موقت یا دائم منع کند.",
            NEW_BANK_REGISTERATION: "کاربر گرامی ، در صورت نیاز به ثبت اطلاعات حساب بانکی جدید میتوانید",
            CLICK_HERE: "<span>اینجا</span> کلیک کنید",
            GOT_IT: "متوجه شدم",
            RETURN_TO_WALLET_CONFIRMATION: "بازگشت مبلغ باقیمانده به کیف پول",
            REMAINING_AMOUNT_TRANSFER_NOTICE: "مبلغ باقیمانده آگهی شما کمتر از « کمترین حد خرید » شما می‌باشد. بنابراین باقیمانده ی این مقدار به کیف پول شما منتقل خواهد شد. توجه داشته باشید که آگهی شما دیگر قابل مشاهده نیست. شما میتوانید آگهی جدیدی را ثبت کنید.",
            TRANSFER_NOTICE_CREATE: 'مبلغ باقیمانده آگهی شما به کیف پول شما منتقل خواهد شد. توجه داشته باشید که آگهی شما دیگر قابل مشاهده نیست. شما میتوانید آگهی جدیدی را ثبت کنید.',
            CANCEL_ADVERTISEMENT: "لغو آگهی",
            DELETE_ADVERTISEMENT_WARNING: "امکان حذف آگهی وجود ندارد. ابتدا به سفارشات « در‌جریان » خود رسیدگی کنید و آن ها را کامل کنید.",
            NO_BUYER_FOUND: "خریداری یافت نشد",
            ADVERTISEMENT_CLOSED_NOTIFICATION: "کاربر گرامی با توجه به این که در مدت زمان تعیین شده برای آگهی شما خریداری پیدا نشد،‌آگهی شما بسته شد.",
            CANCEL_SALE_CONFIRMATION: "آیا از لغو کردن آگهی فروش خود اطمینان دارید ؟",
            YES_SALE_CONFIRMATION: "بله",
            NO_SALE_CONFIRMATION: "خیر",
            MINUTES: "دقیقه",
            EDIT_INFORMATION: "ویرایش اطلاعات",
            MY_ORDERS: "سفارش‌های من",
            ALL_ITEMS: "همه",
            RETURN_TO_MAIN: "بازگشت به صفحه اصلی",
            AD_SUCCESSFULLY_REGISTERED: "آگهی شما با موفقیت ثبت شد",
            AD_RESPONSIBILITY: "لطفا در برابر آگهی خود مسؤلیت پذیر باشید و در صورت دریافت نوتیفیکیشن، در اسرع وقت به آن رسیدگی کنید.",
            PAYMENT_PERIOD: "مدت زمان پرداخت",
            CARD_INFO: "اطلاعات کارت",
            DESIRED_AMOUNT: "ورود مبلغ دلخواه",
            CURRENT_RATE: "نرخ فعلی",
            WARNING: "هشدار",
            I_REALIZED: "متوجه شدم",
            AVOID_BECOMING_VICTIM: "برای اینکه قربانی کلاهبرداران نشوید، هرگز قبل از پرداخت واقعی، ارز را انتقال ندهید! کسی را که ادعا می کند پشتیبان مشتری است و شما را متقاعد می کند که تراکنش را قبل از دریافت پرداخت انجام دهید باور نکنید چرا که آنها کلاهبردار هستند. پس از تایید سفارش توسط فروشنده و انتقال دارایی به خریدار، معامله انجام شده تلقی می شود و قابل مناقشه نیست. همچنین پلتفرم هیچ مسئولیتی در قبال تراکنش های خارج از پلتفرم نخواهد داشت.",
            CHOOSE_FILE: "انتخاب فایل",
            ORDER_STATUS: {
                NEW_BUY: 'پرداخت',
                NEW: 'در انتظار خریدار',
                IN_PROGRESS: 'در جریان',
                SUPPORT: 'پشتیبانی',
                CANCEL: 'لغو',
                CLOSED: 'بسته شده',
                DONE: 'انجام شده'
            },
            ADVERTISE_TYPES: {
                BUY: 'خرید',
                SELL: 'فروش'
            },
            TIME_REMAINING_TO_COMPLETE_PAYMENT: "زمان باقی‌مانده شما برای ثبت پرداخت",
            SUBTITLE_CHECK_TIMER: 'در صورت ثبت نکردن پرداخت در زمان مشخص شده سفارش به پشتیبانی می‌رود.',
            REGISTER_PAYMENT_INFORMATIN: "ثبت اطلاعات پرداخت",
            ACTION_TO_RELEASE: "آزادسازی",
            DELETE_ADVERTISMENT: 'حذف آگهی',
            DETAIL_ADVERTISMENT: 'جزییات آگهی',
            DELETE_ORDER: 'حذف سفارش',
            DETAIL_ORDER: 'جزییات سفارش',
            BALANCE_WALLET: "موجودی: {{balance}} {{currency}}",
            CURENTR_MARKET_RATE: "نرخ فعلی خرید از تاپ‌چنج:",
            CURENTR_MARKET_RATE_CRYPTO: "نرخ لحظه‌ای بازار:",
            YOUR_EXCHANGE_RATE: "نرخ فروش شما:",
            ALLOWED_RANGE: "بازه مجاز: {{min}} - {{max}}",
            ALLOWED_RANGE_PERCENTAGE: "بازه مجاز: <span class='percent-range'>{{min}}% - {{max}}%</span>",
            ERROR_VALIDATE_ALLOWED_RANGE: "نرخ وارد شده باید در بازه مجاز {{min}} - {{max}} باشد.",
            ERROR_VALIDATE_ALLOWED_RANGE_PERCENTAGE: "درصد وارد شده باید در بازه مجاز <span class='percent-range'>{{min}}% - {{max}}%</span> باشد.",

            TEXT_CHANGE_PERCENT_LOWER: 'نرخ فروش شما همیشه {{value}}٪ پایین‌تر از نرخ تاپ‌چنج خواهد بود.',
            TEXT_CHANGE_PERCENT_HIGHER: 'نرخ فروش شما همیشه {{value}}٪ بالاتر از نرخ تاپ‌چنج خواهد بود.',
            TEXT_CHANGE_PERCENT_STATIC: 'نرخ فروش شما همیشه برابر با نرخ تاپ‌چنج خواهد بود.',

            TEXT_CHANGE_PERCENT_LOWER_CRYPTO: 'نرخ فروش شما همیشه {{value}}٪ پایین‌تر از نرخ بازار خواهد بود.',
            TEXT_CHANGE_PERCENT_HIGHER_CRYPTO: 'نرخ فروش شما همیشه {{value}}٪ بالاتر از نرخ بازار خواهد بود.',
            TEXT_CHANGE_PERCENT_STATIC_CRYPTO: 'نرخ فروش شما همیشه برابر با نرخ بازار خواهد بود.',
            AMOUNT_PAID: 'مبلغ پرداختی',
            EXCHANGE_RATE: 'نرخ تبدیل',
            ORDER_TRACKING_NUMBER: 'شماره پیگیری سفارش',
            AD_TRACKING_NUMBER: 'شماره پیگیری آگهی',
            DESTINATION_BANK: 'بانک مقصد',
            VIEW_DESTINATION_BANK: 'مشاهده بانک مقصد',
            VIEW_DESTINATION_BANK_DESCRIPTION: 'از این به بعد می‌توانید بانک مقصد آگهی‌دهنده را پیش از ورود به معامله ببینید تا انتخاب دقیق‌تری داشته باشید.',
            BANK_NAME: 'بانک {{name}}',
            DIALOG_EXCHANGE_RATE: {
                CHANGE: {
                    TITLE: "نرخ تبدیل واردشده با نرخ فعلی تفاوت زیادی دارد",
                    NEW_EXCHANGERATE: "نرخ تبدیل شما:",
                    TC_EXCHANGERATE: "نرخ فعلی خرید از تاپ‌چنج:",
                    DESCRIPTON: "نرخ تبدیلی که انتخاب کرده‌اید با نرخ تبدیل فعلی در TC اختلاف زیادی دارد. لطفاً قبل از ثبت، آن را بررسی کنید. آیا از این مقدار مطمئن هستید؟",
                    EDIT_EXCHANGE_RATE: "ویرایش نرخ تبدیل",
                    CONTINUE: "ادامه",
                }
            },
            PRICE_TOLERANCE_VALIDATION_FAILED: "قیمت واردشده اختلاف زیادی با قیمت بازار دارد. لطفاً آن را اصلاح کرده و مجدداً تلاش کنید.",
            DIALOG_TERMS_COMMITMENT_AGREEMENT: {
                ALERT_TXT: 'لطفا قبل از ثبت آگهی با دقت قوانین را مطالعه کنید!'
            },

            ACTIVE_ORDERS_AD_VISIBILITY_WARNING: "زمانی که ۴ سفارش برای آگهی فروش شما وجود داشته باشد، آگهی شما به طور خودکار پنهان می‌شود.",
            SUPPORT_REQUESTS_AD_VISIBILITY_WARNING: "به محض اینکه ۳ درخواست پشتیبانی علیه سفارشات خود دریافت کنید، همه تبلیغات شما به طور موقت پنهان می‌شوند.",
            FINAL_P2P_TRANSACTION_WARNING: "معاملات P2P نهایی هستند؛ قبل از ثبت سفارش، مبلغ، قیمت و اطلاعات پرداخت را با دقت بررسی کنید.",
            P2P_COLLATERAL_NOTICE: "مبلغ وثیقه به عنوان ضمانت کاربر برای رعایت اصول و قوانین P2P پلتفرم در نظر گرفته شده است.این مبلغ بعد از بسته شدن آگهی، به کیف پول شما باز خواهد گشت.",
            P2P_SERVICE_RESTRICTION_WARNING: "با توجه به تخطی از قوانین مشخص‌شده، کارشناس مربوطه می‌تواند شما را از استفاده از سرویس P2P به صورت موقت یا دائم منع کند.",

            P2P_SEND_METHOD_PRICE_NOTICE: 'کاربر گرامی، برای مبالغ تا سقف ۱۵ میلیون تومان، واریز را از طریق کارت‌به‌کارت انجام دهید. برای مبالغ بیش از ۱۵ میلیون تا سقف ۲۰۰ میلیون تومان، لطفاً از روش حساب‌به‌حساب استفاده نمایید. توجه داشته باشید در این روش، بانک مبدأ و مقصد باید یکسان باشد و از انتقال وجه از طریق شماره شبا خودداری فرمایید.',
            CONFIRM_PAYMENT_NOTICE: 'اطلاعات پرداخت شما ثبت شده است. برای تأیید پرداخت و ادامه درخواست، حتماً روی دکمه «{{btnTex}}» بزنید.',
            CONFIRM_PAYMENT: 'تأیید پرداخت',
            UNCONFIRMED_PAYMENT_EXIT_NOTICE: 'پرداخت شما هنوز تأیید نهایی نشده است. آیا می‌خواهید از این صفحه خارج شوید؟',
            RELEASE_ELIGIBILITY_CHECKING: 'در حال بررسی امکان آزادسازی…',
            RELEASE_ELIGIBILITY_CHECK_FAILED: 'امکان آزادسازی بررسی نشد. صفحه را دوباره بارگذاری کنید.',
            RELEASE_AVAILABLE_AFTER_DEADLINE: 'مهلت اولیه به پایان رسید. پس از تأیید واریز، همچنان می‌توانید دارایی را آزاد کنید.',
            RELEASE_UNAVAILABLE_AFTER_DEADLINE: 'مهلت اولیه به پایان رسید. در وضعیت فعلی سفارش، امکان آزادسازی وجود ندارد.',
        },
        AFFILIATE: {
            AFFILIATE_REQUEST: {
                ENTER_CODE_DESCRIPTION: "شما می‌توانید در عین حال که همکار ما (Affiliate) هستید از طرف شخص دیگری نیز دعوت شوید و با توجه به شرایط دعوت‌کننده امتیاز دریافت کنید.",
                ENTER_CODE: "ثبت کد دعوت",
                AFFILIATE_CONDITIONS: "شرایط عضویت",
                SOCIAL_MANAGEMENT_BLOCKCHAIN: "داشتن گروه‌های اجتماعی در حوزه‌ی بازارهای مالی و انتقالات ارزی که مدیریت آن را بر عهده دارید.",
                ONLINE_FINANCIAL_PLATFORMS: "حضور موثر در شبکه‌های اجتماعی مرتبط با بازارهای سرمایه مانند یوتیوب, توییتر, اینستاگرام و تلگرام.",
                COMMUNITY_EVENTS_ATTRACTION: "دسترسی به کلوپ‌های هواداری , برنامه‌ها و کنفرانس‌های مالی و امکان ایجاد فضای تبلیغاتی برای سوق‌دهی کاربران جدید به سمت پلتفرم TopChange",
                CONTENT_COLLABORATION_IMPACT: "تجربه و توانایی برای تولید محتوای مربوط به فعالیت‌های مشترک با TopChange و امکان تاثیرگذاری بر گروه‌های مختلف کاربری",
                SEND_REQUEST: "اگر قصد دارید عضوی از سرویس همکاری TopChange باشید، کلیک کنید:",
                SEE_FORM: "فرم ارسال درخواست Affiliate"
            },
            AFFILIATE_SEND_REQUEST: {
                SEND_AFFLIATE_REQUEST: "ارسال درخواست همکاری",
                WEBSITE_ADDRESS: "آدرس وبسایت",
                SOCIAL_MEDIA: "وب سایت یا هر سوشال مدیای دیگری که عضو هستید مانند تلگرام، توییتر و ...",
                COOPEREATED_COMPANY: "شرکت یا برنامه افیلیت قبلی که با آن همکاری داشتید",
                DESCRIPTION: "استراتژی خود را برای همکاری توضیح دهید (تولید محتوا، کمپین های سوشال مدیا، ایمیل مارکتینگ، با هر تکنیک تبلیغاتی دیگر)",
                ENTER_DESCRIPTION: "پیام خود را بنویسید...",
                TRANSACTION_VOLUME: "حجم معاملات",
                ESTIMATED_MONTHLY_TRADING_VOLUME: "حجم تخمینی معاملات ماهانه خود را به تی‌سی‌دی بنویسید.",
                SEND: "ارسال",
                SUBMIT_SUCCESS_MESSAGE: "درخواست شما با موفقیت ثبت شد منتظر تماس از سمت تی سی باشید"
            },
            INVITEE_ENTER_CODE: {
                INVITATION_CODE: "کد دعوت",
                ENTER_INVITATION_CODE: "ابتدا کد دعوت معرف خود را اعمال نمایید",
                YOUR_INVITATION_CODE: "کد دعوت",
                ENTER_INVITAION_CODE_HINT: " کد دعوت خود را وارد نمایید",
                ACTIONS: 'ثبت',
                CAN_INVITED: " شما می توانید در عین حال که افیلیت هستید از طرف شخص دیگری نیز دعوت شوید و با توجه به شرایط دعوت کننده امتیاز دریافت نمایید. ",
            },
            INVITEE_INDEX: {
                YOUR_INVITATION_CODE: "کد معرف شما",
                REQUEST_EMAIL: "چنانچه قصد تغییر دعوت کننده خود را دارید به ایمیل زیر درخواست دهید.",
                DEFAULT_BONUS: "پاداش تعریفی از سمت افیلیت برای شما",
                FROM_AFFILIATE_SHARE: "از سهم افیلیت",
                MY_PERFORMANCE: "عملکرد من",
                VIEW_HISTORY: "مشاهده تاریخچه",
                MY_AFFILIATE: "افیلیت من",
                UNPAID_BONUS: "پاداش تسویه نشده",
                PAID_BONUSES: "کل پاداش‌های دریافتی",
                SCORE: "امتیاز",
            },
            INVITEE_HISTORY: {
                FILTERS: "فیلتر ها",
                TRACKING_NUMBER: "شماره پیگیری",
                IDENTIFICATION_CODE: " کد معرف",
                PROGRAM: " برنامه",
                FROM_DATE: "از تاریخ",
                TO_DATE: " تا تاریخ",
                TYPE: "نوع",
                MY_REWARD: "پاداش من",
                SCORE: "امتیاز",
                AFFILIATE: "افیلیت",
                STATUS: "وضعیت",
                ACTION_DATE: "تاریخ عملیات",
                ACTION: "عملیات",
            },
            FILTER: 'فیلتر',
            FROM_DATE: 'از تاریخ',
            TO_DATE: 'تا تاریخ',
            CLEAR_ALL: 'پاک کردن همه',
            SEARCH: 'جستجو',
            YOUR_AFFILIATE_PROGRAM: 'برنامه درآمدزایی شما',
            BONUS_FROM_BROKER: 'بونوس از بروکر',
            BONUS_FROM_SPECIAL_WALLETS: '{{bonus}}% بونوس از کیف پول(ها) {{specialWallets}}',
            FROM_ALL_BROKERS: 'بونوس از همه بروکرها',
            SHARE_YOUR_REFERRAL: 'لینک معرفی خود را با دنبال کنندگان یا کانال‌های خود به اشتراک بگذارید.',
            ENCOURAGE_FRIENDS_TRANSACTIONS: 'تشویق دوستان به انجام تراکنش',
            RECEIVE_REWARDS: 'دریافت پاداش',
            YOUR_REFERRAL_CODE: 'کد دعوت شما',
            VIDEO_GUIDE: 'راهنمای ویدیویی',
            MANAGEMENT_OF_CODES: 'مدیریت کدها',
            SHARE: 'اشتراک گذاری',
            EXPLANATION_STEPS: 'توضیح مراحل',
            MORE_GUIDANCE: 'راهنمایی بیشتر',
            CREATE_YOUR_OWN_CODE: 'کد و لینک دعوت خودتان را ایجاد کنید.',
            SHARE_YOUR_CODE: 'لینک یا کدی که در اختیار دارید را با افراد دیگر به اشتراک بگذارید.',
            ENCOURAGE_FRIENDS_COMPLETE_TRANSACTIONS: 'دوستانتان را تشویق به و انجام تراکنش تعریف شده در برنامه های خود کنید.',
            MANAGE_REFERRAL_CODES: 'کدهای دعوت خود را مدیریت نمایید.',
            CHANGE_BONUSES_PERCENTAGE: 'شما می توانید با توجه به شرایط خود درصد پاداش ها را برای کد های متفاوت تغییر دهید.',
            REFERRAL_CODE: 'کد معرف',
            INVITEE_USERNAME: 'نام کاربری دعوت شونده',
            OPERATION: 'عملیات',
            BONUS_RECEIVED: 'پاداش دریافتی',
            INTRODUCED_PEOPLE_NUMBER: 'تعداد معرفی شونده',
            INTRODUCED_PERSON_SHARE: 'سهم معرفی شده',
            MY_SHARE: 'سهم من',
            INVITATION_CODE: 'کد دعوت',
            MY_OVERALL_PERFORMANCE: 'عملکرد کلی من',
            VIEW_HISTORY: 'مشاهده تاریخچه',
            THE_REFEREES: 'ریفری‌ها',
            BONUS_AVAILABLE: 'پاداش موجود',
            TOTAL_REWARDS_RECEIVED: 'کل پاداش‌های دریافتی',
            MY_BEST_REFEREE: 'ریفری‌ برتر من     ',
            YOUR_INVITATION_CODE: 'کد دعوت شما',
            GENERATE_REFERRAL_SAHRE: 'کدهای ارجاع ایجاد کنید و کمیسیون ها را با دعوت کنندگان خود به اشتراک بگذارید.',
            CREATE_INVITATION_CODE: 'ایجاد کد دعوت',
            EDIT: 'ویرایش',
            VIEW_TRANSACTIONS: 'مشاهده تراکنش ها',
            NAME_CHANGE: 'تغییر نام',
            NEW_NAME: 'نام جدید',
            CHANGE: 'تغییر',
            CREATE_CODE: 'ایجاد کد',
            INVITED_PERSON_SHARE: 'سهم دعوت شونده',
            YOUR_SHARE: 'سهم شما',
            NAME: 'نام',
            CANCEL: 'لغو',
            CREATE: 'ایجاد',
            INVITED_PERSON: 'دعوت شونده',
            TOTAL_REWARDS: 'پاداش کل',
            MY_REWARD: 'پاداش من',
            INVITED_PERSON_REWARD: 'پاداش دعوت شونده',
            OPERATION_DATE: 'تاریخ عملیات',
            TRACKING_NUMBER: 'شماره پیگیری',
            TRANSACTION_TYPE: 'نوع تراکنش',
            CHANGE_STATUS: 'تغییر وضعیت',
            SCORE: 'امتیاز',
            TOTAL_SCORE: 'امتیاز کل',
            INVITING_MONETIZATION_PROGRAM: 'برنامه درامد زایی معرفی دوستان',
            BECOME_AFFILIATE: 'درخواست همکاری با تاپ‌ چنج',
            INVITED_BY_FRIENDS: 'از طرف دوستم معرفی شده ام',
            REFERRAL_LINK: 'لینک معرف',
            INCOME_SOURCE_REFERRALS: 'کدهای معرف درآمدزا',
            SUCCESSFUL_REFERRALS: 'دعوت های موفق',
            AFFILIATE_SHARE: 'سهم افیلیت',
            AFFILIATE_NEW_REQUEST: {
                TITLE_FORM: 'فرم برنامه همکاری',
                DESCRIPTION_SUCCESS_FORM: 'درخواست شما با مشخصات زیر تایید شد.',
                DESCRIPTION_PENDING_FORM: 'درخواست شما با موفقیت ارسال شد. کارشناسان ما پس از بررسی حساب شما را ثبت خواهند کرد. و شما می‌توانید اطلاعات فرم خود را در این قسمت مشاهده فرمایید.',
                DESCRIPTION_FORM: 'با سلام کاربر گرامی، جهت شروع فعالیت در برنامه‌ی همکاری تاپ‌چنج لطفا فرم زیر را پر نمایید.',
                TELEGRAM_ID: 'آی‌دی تلگرام',
                EXPECTED_INVITEE_COUNT: 'در ماه اول حدودا چند زیرمجموعه اضافه خواهید کرد؟',
                EXPECTED_MONTHLY_VOLUME: 'مجموع حجم معاملات بروکری زیر مجموعه‌های شما در ماه اول حدودا چقدر خواهد بود؟',
                TYPICAL_TRADE_SIZE: 'زیرمجموعه‌های شما معمولا با چه مبالغی معامله خواهند کرد؟',
                INVITEE_COUNT_0_10: '0 تا 10 نفر',
                MONTHLY_VOLUME_1000_10000: '1000 تا 10,000 دلار',
                TRADE_SIZE_LOW_100_1000: 'مبلغ پایینتر ( 100 تا 1000 دلار)',
                TARGET_BROKERS: 'برای کدام بروکرها قصد جذب زیرمجموعه از طریق تاپ‌چنج دارید؟',
                REFERRAL_TRADING_BROKERS: 'زیرمجموعه‌های شما معاملات خود را با کدام بروکرها خواهند داشت؟',
                HAS_IB_EXPERIENCE: 'آیا تا بحال تجربه فعالیت به شکل آی‌بی داشته اید؟',
                IB_EXPERIENCE_BROKERS: 'با کدام بروکرها چنین تجربه‌ای داشته‌اید',
                STRATEGY: 'منابع و استراتژی شما برای فعالیت در زمینه‌ی برنامه‌ی همکاری تاپ‌چنج چه خواهد بود؟',
                STRATEGY_HINT: 'تولید محتوا، کمپین‌های سوشیال مدیا، ایمیل مارکتینگ، کانال‌های مختلف در سوشیال مدیا یا هر تکنیک دیگری',
                BIGGEST_CHALLENGE: 'بزرگ‌ترین چالش شما برای فعالیت در این برنامه چه خواهد بود؟',
                COMMENTS: 'اگر نظر یا پیشنهادات دیگری دارید با ما به اشتراک بذارید.',
                SUBMIT_REQUEST: 'ثبت درخواست',
                CLEAR_FORM: 'پاک کردن فرم',
                YES: 'بله',
                NO: 'خیر',
                TYPE_EXPECTED_INVITEE_COUNT: {
                    From0To10: '0 تا 10 نفر',
                    From11To30: '11 تا 30 نفر',
                    From31To50: '31 تا 50 نفر',
                    From51To100: '51 تا 100 نفر',
                    Over100: '100+ نفر',
                },
                TYPE_TYPICAL_TRADE_SIZE: {
                    Low: 'مبلغ پایین‌تر (100 تا 1,000 دلار)',
                    Medium: 'مبلغ متوسط  (1,000 تا 10,000 دلار)',
                    High: 'مبلغ بالا  (1,000,000+ دلار)',
                },
                TYPE_EXPECTED_MONTHLY_VOLUME: {
                    From1KTo10K: '1,000 - 10,000 دلار',
                    From10KTo50K: '10,001 - 50,000 دلار',
                    From50KTo100K: '50,001 - 100,000 دلار',
                    From100KTo250K: '100,001 - 250,000 دلار',
                    From250KTo1M: '250,001 - 1,000,000 دلار',
                    Over1M: '1,000,000+ دلار',
                },
                ALERT: {
                    SEND_SUCCESSFUL: 'ارسال موفق',
                    SEND_SUCCESSFUL_DESC: 'درخواست شما با موفقیت ارسال شد. کارشناسان ما پس از بررسی حساب شما را ثبت خواهند کرد.',
                    SEND_ERROR: 'خطا در ارسال',
                    SEND_ERROR_DESC: 'مشکلی در ارسال درخواست شما پیش آمد. لطفاً اتصال اینترنت خود را بررسی کرده و دوباره امتحان کنید. و یا با پشتیبانی تماس بگیرید.',
                    SEND_REJECTED: 'درخواست رد شد',
                    SEND_REJECTED_DESC: 'متأسفیم، درخواست شما تأیید نشد. لطفاً اطلاعات را بررسی کرده و دوباره تلاش کنید. و یا با پشتیبانی تماس بگیرید.',
                    SHOW_FORM: 'نمایش فرم',
                    TRY_AGAIN: 'تلاش مجدد',
                    TRACKING_NUMBER: 'کد پیگیری:',
                    TRY_AGAIN_ON: 'تلاش دوباره در ',
                },
                STATUS: {
                    Pending: 'در انتظار بررسی',
                    Approved: 'تأیید شده',
                    Rejected: 'رد شده',
                    Expired: 'بسته‌شده بدون بررسی',
                }
            },
        },
        TRANSFER: {
            TRANSFER_FROM_TC_TO_GC: 'انتقال کیف پول های TopChange به وب سایت  GreenChange',
            GC_ADDRESS: 'https://greenchange.io',
            TRANSFER_ANNOUNCEMENT: {
                TITLE: 'انتقال کیف پول های رمزارز TopChange به وب سایت Greenchange',
                DESCRIPTION: 'کاربرانی که قبلا در سایت TopChange در زمینه ی رمزارز فعالیت داشته اند، این دسته از کاربران با همان ایمیل و کلمه عبور حساب TopChange خود قادر به ورود به سایت GreenChange هستند و نیازی به ثبت نام و احراز هویت در سایت GreenChange نخواهند داشت. همچنان می توانند به فعالیت خود بر کیف پول های فیات در TopChange ادامه دهند ولیکن می بایست پس از انتقال کیف پول های رمزارز به GreenChange، مبادلات خود را در خصوص رمز ارزها در وبسایت GreenChange انجام دهند.',
                ITEM1: 'واریز و برداشت رمز ارزها به روش اتوماتیک',
                ITEM2: 'افزایش امنیت تراکنش ها',
                ITEM3: 'افزودن خدمات بیشتر در حوزه رمزارز'
            },
            NEW_CHANGES: {
                TITLE: 'تغییرات جدید رمزارزها در سایت TopChange',
                BUY: {
                    TITLE: 'خرید رمزارز',
                    PRE_DESCRIPTION: 'شارژ کیف پول های رمزارز GreenChange از طریق موجودی کیف پول های فیات شما در TopChange',
                    DESCRIPTION: 'شارژ کیف پول های رمزارز شما در سایت GreenChange می تواند از طریق موجودی کیف پول های فیات شما در سایت TopChange صورت پذیرد.'
                },
                SELL: {
                    TITLE: 'فروش رمزارز',
                    PRE_DESCRIPTION: 'برداشت از کیف پول های رمزارز GreenChange و انتقال مبلغ به کیف پول های فیات شما در TopChange',
                    DESCRIPTION: 'شما می توانید جهت فروش رمزارز های خود از کیف پول GreenChange به کیف پول های فیات خود در TopChange واریز نموده و از طریق روش های برداشت در TopChange به صورت نقدی، بانکی و ... وجه مورد نظر را دریافت نمایید.'
                }
            },
            TRANSFER_LERANING: {
                TITLE: 'جهت انتقال کیف پول های رمزارز TopChange به GreenChange  چه کنم؟',
                QUESTION_ONE_LOGIN_TITLE: 'تراکنش مربوط به کیف پول های رمزارز در TopChange داشته ام',
                QUESTION_ONE_LOGIN_DESCRIPTION: 'این دسته از کاربران با همان ایمیل و کلمه عبور حساب TopChange خود قادر به ورود به سایت GreenChange هستند و نیازی به ثبت نام و احراز هویت در سایت GreenChange نخواهند داشت.<br/>همچنان می توانند به فعالیت خود بر کیف پول های فیات در TopChange ادامه دهند ولیکن می بایست پس از انتقال کیف پول های رمزارز به GreenChange، مبادلات خود را در خصوص رمز ارزها در وبسایت GreenChange انجام دهند',
                QUESTION_ONE_LOGIN_BTN: 'ورود به GreenChange',
                QUESTION_ONE_REGISTER_TITLE: 'تا کنون ثبت درخواست در کیف پول های رمزارز TopChange نداشته ام!',
                QUESTION_ONE_REGISTER_DESCRIPTION: 'این دسته از کاربران هم می توانند به فعالیت خود بر کیف پول های فیات در TopChange ادامه دهند. اما در صورتیکه علاقمند به استفاده از خدمات رمز ارزها باشند باید در سایت GreenChange ثبت نام کرده و احراز هویت بنمایند.',
                QUESTION_ONE_REGISTER_BTN: 'ثبت نام در GreenChange ',
                TRANSFER_DEADLINE: 'آخرین مهلت جهت انجام انتقال: 27 تیر ماه ساعت 16:00 ',
                QUESTION_TWO_REGISTER_DESCRIPTION: 'شما در طول این مدت فرصت دارید تا کیف پول های رمزارز خود را از <span class="tc-span">TopChange</span> به <span class="gc-span">GreenChange</span> منتقل کنید و یا نسبت به برداشت موجودی های رمزارز خود اقدام نمایید، در غیر اینصورت انتقال کیف پول های رمزارز شما در تاریخ 27 تیر ماه ساعت 16:00 صبح به صورت اتوماتیک انجام می گیرید.'
            },
            TRANSFER_REPORT: {
                TITLE: 'انتقال کیف پول های TopChange به وب سایت GreenChange',
                DESCRIPTION: 'ﮐﺎرﺑﺮ ﮔﺮاﻣﯽ در ﺳﺎﯾﺖ GreenChange ﮐﺎرﺑﺮی ﺑﺎ ﻣﺸﺨﺼﺎت شما وﺟﻮد دارد، در ﺻﻮرﺗﯽ ﮐﻪ اﯾﻦ ﺣﺴﺎب ﮐﺎرﺑﺮی ﻣﺘﻌﻠﻖ ﺑﻪ ﺷﻤﺎ ﻣﯽ ﺑﺎﺷﺪ ﻧﺴﺒﺖ ﺑﻪ اداﻣﻪ اﻧﺘﻘﺎل اﻗﺪام ﻧﻤﺎﯾﯿﺪ، در ﻏﯿﺮ اﯾﻨﺼﻮرت از ﺑﺨﺶ ﺗﯿﮑﺖ ﺑﺎ ﻣﺎ در ارﺗﺒﺎط ﺑﺎﺷﯿﺪ.',
                WALLET: 'کیف پول',
                PRICE: 'مبلغ',
                CLICK_HERE: 'کلیک کنید!',
                I_WANT_MORE_ABOUT_TRANSFER: 'می خواهم در مورد انتقال کیف پول های رمز ارز بیشتر بدانم.',
                BOX_INFO: {
                    TITLE: 'مشخصات',
                    TEXT: 'کاربر گرامی با توجه به اینکه شما قبلا در سایت Topchange فعالیت در زمینه ی رمزارزها انجام داده اید یک حساب کاربری برای شما در سایت Greenchange ساخته شده است که برای ورود به آن می توانید از اطلاعات ورود حساب Topchange خود استفاده نمایید. لطفا این مورد را بررسی کرده و در صورت تایید عملیات انتقال موجودی کیف پول ها را انجام دهید، در غیر اینصورت از بخش<a href="/support/tickets"> تیکت </a> با ما در ارتباط باشید.',
                    FULL_NAME: 'نام و نام خانوادگی',
                    USERNAME: 'نام کاربری',
                    DATE_OF_BIRTH: 'تاریخ تولد',
                    NATIONAL_CODE: 'شماره ملی',
                    PASSPORT: 'پاسپورت'
                },
                CHECK_INFO_TXT: 'مشخصات نمایش داده شده در سایت GreenChange متعلق به من می باشد.',
                CHECK_POLICY_TXT: 'اینجانب می پذیرم که :<br/><ul><li>یک حساب کاربری جدید درسایت گرین چنج (https://greenchange.io) برای ما ساخته شود.</li><li>برای دسترسی به حساب کاربری خود در GreenChange من باید از نام کاربری و کلمه عبور خود در TopChange استفاده نمایم.</li><li>تمام دارایی رمزارز من در TopChange به GreenChange منتقل خواهد شد.</li></ul>',
                TRANSFER_BTN: 'انتقال',
            },
            CONFIRM_DIALOG: {
                TITLE: 'تائید انتقال',
                ENTER_CODE: 'برای ارسال درخواست خود، لطفا کد تأییدی را که به <span>{{phoneNumber}}</span> و <span>{{userEmail}}</span> ارسال شده است وارد کنید.',
                CANCEL: 'لغو'
            },
            LEARN_FILES: {
                TITLE: 'فایل های آموزشی',
                FILE_NAME1: 'روش انتقال مبلغ از GreenChange به TopChange',
                FILE_NAME2: 'احراز هویت',
                FILE_NAME3: 'روش انتقال مبلغ از TopChange به GreenChange',
            },
            ALERT: {
                TRANSFER_DONE_SUCCESSFULLY: 'عملیات انتقال با موفقیت انجام گردید.',
                TRANSFER_DONE: 'کاربر گرامی، انتقال کیف پول های رمزارز شما از TopChange به GreenChange با موفقیت انجام پذیرفت.',
                TRANSFER_DONE1: 'انتقال موفقیت آمیز بود!',
                TRANSFER_DONE2: 'شما می توانید وارد سایت GreenChange شوید و کیف پول های رمزارز خود را مشاهده نمایید.',
                TRANSFER_DONE3: 'ورود به سایت Greenchange',
                WITHOUT_TRANSACTION: 'کاربر گرامی، تراکنشی در کیف پول های رمزارز شما وجود ندارد.'
            }
        },
        GENERAL: {
            STATUSES: "وضعیت",
            VIDEO_GUIDE: "راهنمای ویدیویی",
            GUIDE: "راهنما",
            ATTENTION: 'توجه',
            BACK: 'بازگشت',
            TITLE: 'عنوان',
            SHOW_ALL: 'مشاهده همه',
            DASHBOARD: 'داشبورد',
            TRANSACTIONS: 'تراکنش ها',
            EXCHANGE: 'تبدیل',
            CHANGE: "تغییر",
            WITHDRAW: 'برداشت',
            RECIEVE: 'دریافت',
            DEPOSIT: 'شارژ',
            CHOOSE: 'انتخاب',
            IMPORTANT_POINTS: 'نکات مهم',
            CONTANCT_SUPPORT_FOR_MORE_INFO: 'برای اطلاعات بیشتر با پشتیبانی تماس بگیرید',
            DOWNLOAD: 'دانلود',
            EMONEY: 'پول الکترونیک',
            CONTINUE_CONFIRM: 'ادامه تائید',
            AUTH_ALERT_TEXT: 'کاربرگرامی، برای {{value}} تائید احراز هویت های زیر الزامی می باشد:',
            AUTHENTICATION: 'احراز هویت',
            SUMMARY: 'مشخصات درخواست',
            CRYPTO: 'رمزارز',
            ADD: 'ثبت',
            ADD2: "افزودن",
            DONE: 'تایید شد',
            REFUND: 'بازگشت مبلغ',
            ACTION: 'عملیات',
            ALERT: 'هشدار',
            ALL: 'همه',
            EXAMPLE: 'مثال',
            ACTIONS: 'عملیات',
            ATTACHMENT: 'فایل ها',
            ATTACHMENT_VIEW: 'فایل پیوست',
            ALLOWED_FILES: 'فرمت های مجاز',
            AT_LEAST: 'حداقل',
            BALANCE: 'موجودی',
            BLOCK: 'مسدود کردن',
            CLICK_HERE: 'اینجا کلیک کنید',
            CONFIRM: 'تایید',
            CODE: 'کد',
            CANCEL: 'انصراف',
            CATEGORY: 'گروه',
            DELETE: 'حذف',
            SECOND_AGO: 'ثانیه قبل',
            MINUTES_AGO: 'دقیقه قبل',
            HOURS_AGO: 'ساعت قبل',
            DESCRIPTION: 'توضیحات',
            DATE: 'تاریخ',
            STATUS_DATE: 'تاریخ تغییر وضعیت',
            LAST_STATUS_DATE: 'تاریخ آخرین تغییر وضعیت',
            DATE_FROM: 'از تاریخ',
            DATE_TO: 'تا تاریخ',
            CHANGE_FILE: 'تغییر فایل',
            EXPORT: 'خروجی',
            ERROR: 'خطا',
            EMAIL: 'ایمیل',
            SMS: 'پیامک',
            HELP: 'راهنما',
            OPTIONAL: "اختیاری",
            LAST_UPDATE: 'آخرین بروزرسانی',
            CLICK_TO_COPY_NUMBER: 'برای کپی روی شماره کلیک کنید',
            TRACKING_NUMBER_COPIED_SUCCESSFULLY: "شماره پیگیری با موفقیت کپی شد.",
            COPIED: 'کپی شد',
            SAVE: 'ذخیره',
            YES: 'بله',
            NO: 'خیر',
            CREATE: 'ایجاد',
            ACTIVE: 'فعال',
            NEW: 'جدید',
            EDIT: 'ویرایش',
            WATING: 'در حال انتطار',
            FILTER: 'فیلتر',
            CLEARE_ALL: 'پاک کردن همه',
            MESSAGE: 'پیام',
            MORE_INFO: 'اطلاعات بیشتر',
            NEXT: 'بعدی',
            POINT: 'امتیاز',
            SEARCH: 'جستجو',
            REPLAY: 'پاسخ',
            ROW: 'ردیف',
            TYPE: 'Type',
            CLOSE: 'بستن',
            SUBJECT: 'موضوع',
            SUBMIT: 'ثبت',
            EXIT: 'خروج',
            DETAILS: 'جزئیات',
            SEND: 'ارسال',
            REJECTED: 'رد شد',
            WAITING: 'انتظار',
            CONGRATULATION: 'تبریک',
            UPLOADING: 'در حال آپلود',
            CONFIRM_AND_UPLOAD: 'تایید و آپلود',
            PHONE: 'گوشی',
            SERVICE: 'پول الکترونیک',
            SEND_CODE: 'ارسال کد',
            SECURITY_CODE: 'کد تایید',
            STATUS_TEXT: 'وضعیت',
            SELECT_FILE: 'انتخاب فایل',
            EXPERT_COMMENT: 'توضیح کارشناس',
            SELL: 'فروش',
            BUY: 'خرید',
            REQUEST: 'درخواست',
            QUICK_ACCESS: 'دسترسی سریع',
            TEXT: 'متن',
            NAME: 'نام',
            MALE: 'مرد',
            FEMALE: 'زن',
            UNKNOWN: 'جنسیت مشخص نیست',
            NOT_APPLICABLE: 'غیر قابل تشخیص',
            UPDATE: 'بروزرسانی',
            TRACKING_NUMBER: 'شماره پیگیری',
            NEW_STATUS: 'وضعیت های جدید',
            SMS_CREDIT: 'اعتبار پیامکی',
            RETURN: 'برگشت',
            ALERT_DELETE: 'آیا از حذف {{value}} مطمئن هستید؟',
            ALERT_SECURE_CODE_TIME_EXPIRED: 'کد تایید منقضی شده است',
            NO_ITEM_TOـSHOW: 'موردی برای نمایش وجود ندارد',
            HOME: 'خانه',
            DEACTIVE: 'غیر فعال',
            NOTHING_TO_DISPLAY: 'موردی برای نمایش وجود ندارد',
            TEXT_COPIED: 'کپی انجام شد!',
            CLICK_FOR_COPY: 'برای کپی کلیک کنید',
            RETRY: 'تلاش مجدد',
            SELECT: 'انتخاب',
            VERIFY: 'تایید',
            PLEASE_CONTACT_SUPPORT: 'لطفا با پشتیبانی تماس بگیرید.',
            ENTER_THE_INFORMATION_FIRST: '-ابتدا اطلاعات را وارد کنید-',
            I_UNDERSTAND: 'متوجه شدم',
            FROM_DATE: 'از تاریخ',
            TO_DATE: 'تا تاریخ',
            TH_1: 'اول',
            TH_2: 'دوم',
            TH_3: 'سوم',
            TH_4: 'چهارم',
            TH_5: 'پنجم',
            TH_6: 'ششم',
            TH_7: 'هفتم',
            TH_8: 'هشتم',
            TH_9: 'نهم',
            TH_10: 'دهم',
            TH_11: 'یازدهم',
            TH_12: 'دوازدهم',
            TH_13: 'سیزدهم',
            TH_14: 'چهاردهم',
            TH_15: 'پانزدهم',
            TH_16: 'شانزدهم',
            TH_17: 'هفدهم',
            TH_18: 'هجدهم',
            TH_19: 'نوردهم',
            TH_20: 'بیستم',
            _1: 'یک',
            _2: 'دو',
            _3: 'سه',
            _4: 'چهار',
            _5: 'پنج',
            _6: 'شش',
            _7: 'هفت',
            _8: 'هشت',
            _9: 'نه',
            _10: 'ده',
            _11: 'یازده',
            _12: 'دوازده',
            _13: 'سیزده',
            _14: 'چهارده',
            _15: 'پانزده',
            _16: 'شانزده',
            _17: 'هفده',
            _18: 'هجده',
            _19: 'نوزده',
            _20: 'بیست',

            FILE_UPLOAD_LIMITAION: {
                SIZE: 'حداکثر حجم فایل: {{value}} مگابایت',
                FORMAT: 'فایل های مجاز: {{value}}'
            },
            INPUT: {
                CHOOSE_CURRENCY: 'نوع ارز',
                MORE_INFO: 'اطلاعات بیشتر',
            },
            STATUS: {
                PENDING: 'در حال بررسی',
                WAITING: 'درحال انتظار'
            },
            DISABLED: "غیرفعال",
            TRANSACTION_NUMBER: "شماره تراکنش",
            DIGITAL_CURRENCY: 'ارز دیجیتال',
            TRANSACTION_ID: "شناسه تراکنش (hash)",
            SEE_ALL: "مشاهده همه",
            VIEW_PROFILE: 'نمایش پروفایل',
            NO_RESULTS: 'موردی یافت نشد',
            DOWNLOAD_APP: 'دانلود برنامه',
            VALIDATION_CALCULATION: {
                CalculationFunctionRequired: 'تابع محاسبه مشخص شده اجباری است.',
                CalculationFunctionNotFound: 'تابع محاسبه مشخص شده پیدا نشد.',
                AmountNotFound: 'مقدار مورد نیاز پیدا نشد.',
                NullTierRanges: 'بازه‌ها خالی (null) هستند.',
                TierRangesValidationError: 'یک یا چند بازه نامعتبر هستند.',
                TargetTierRangeNotFound: 'بازه هدف مشخص شده پیدا نشد.',
                RequestedAmountRequired: 'مبلغ درخواستی اجباری است.',
                PayOrGetAmountRequired: 'مبلغ پرداخت یا دریافت اجباری است.',
                RequestedAmountOutOfTierRange: 'مبلغ درخواستی خارج از بازه‌های تعریف شده است.',
                PayOrGetAmountOutOfTierRange: 'مبلغ پرداخت یا دریافت خارج از بازه‌های تعریف شده است.',
                ExchangeRateIsIncorrect: 'نرخ تبدیل ارز نادرست است.',
                Overlap: 'بازه‌ها با هم هم‌پوشانی دارند.',
                Gap: 'بین بازه‌ها فاصله وجود دارد.',
                ComingSoon: 'این اعتبارسنجی برای استفاده‌های آینده در نظر گرفته شده است.',
                RequestedAmountNotInTierRange: 'مبلغ درخواستی در بازه قرار ندارد!',
                AMOUNT_BECAME_NEGATIVE: 'مبلغ منفی شد',
            },
            DEACTIVATION: 'غیرفعال سازی',
            TRACKING_CODE: 'کد رهگیری',
            TRANSACTION_INFORMATION: 'اطلاعات تراکنش',
            TRANSACTION_STATUS: 'وضعیت تراکنش',
            CONTACT_SUPPORT: 'ارتباط با پشتیبانی',
            PRICE: "مبلغ",
            STAY_ON_PAGE: 'ماندن در صفحه',
            LEAVE_PAGE: 'خروج از صفحه',
        },
        ENUM: {
            WALLET_TYPES: {
                SAVING_ACCOUNT: 'حساب قرض الحسنه',
                TRANSIT_ACCOUNT: 'حساب جاری'
            },
            ARCHIVE: {
                ARCHIVED: 'آرشیو شده',
                NONE_ARCHIVED: 'آرشیو نشده'
            },
            WALLET_CHANGE_TYPE: {
                OUTGOING_PAYMENTS: 'برداشت',
                INCOMING_PAYMENTS: 'شارژ'
            },
            CHANGE_TYPE: {
                DECREASE: 'افزایش',
                INCREASE: 'کاهش'
            },
            SEEN_USER_TYPES: {
                NOBODY: 'هیچکس',
                FRIENDS: 'دوستان',
                EVERYONE: 'همه'
            },
            PRIORITY_TYPES: {
                HIGH: 'بالا',
                MEDIUM: 'معمولی',
                LOW: 'پایین'
            },
            TICKET_STATUS: {
                OPEN: 'باز',
                ANSWERD: 'پاسخ داده شده',
                CUSTOMER_REPLY: 'پاسخ من',
                ON_HOLD: 'در انتظار',
                IN_PROGRESS: 'در حال بررسی',
                CLOSED: 'بسته',
                TC_CONTACT: 'پیام TC',
                ARCHIVED: "آرشیو شده"
            },
            PAYMENT_TYPE: {
                BANK: 'بانک',
                CASH: 'نقدی',
                CREDIT: 'کردیت',
                ONLINE: 'آنلاین',
                ELECTRONIC_MONEY: 'پول الکترونیک',
                ID: 'حواله بانکی',
                Crypto: 'ارز دیجیتال',
                OfflineCard: 'کارت به کارت آفلاین',
                OfflineIBAN: 'شبای آفلاین'
            },
            SEND_PAYMENT_TYPE: {
                BANK: 'بانک به TC',
                CASH: 'نقدی به TC',
                CREDIT: 'کردیت به TC',
                ONLINE: 'آنلاین به TC',
                ELECTRONIC_MONEY: 'پول الکترونیک به TC'
            },
            PAYMENT_STATUS: {
                NO_CONFIRMED: 'تایید نشده',
                PENDING: 'در حال بررسی',
                ACCEPTED: 'تایید شده',
                REJECTED: 'رد شده',
                AWAITINGAPPROVAL: 'منتظر تایید',
                FAILURE: 'ناموفق',
                NOTFOUND: 'پیدا نشد',
                CANCELED: 'لغو شده',
                COMPLETED: 'کامل شده',
                Incomplete: 'تکمیل نشده',
                Refund: 'عودت مبلغ'
            },
            ACCOUNT_STATUS: {
                Unverified: 'عدم تایید',
                VERIFIED: 'تایید شده',
                PENDING: 'در انتظار تایید',
                Accepted: 'تایید شده',
                Rejected: 'عدم تایید',
                Blocked: 'مسدود شده',
                New: 'در انتظار تایید',
                Inquiring: 'در انتظار تایید',
                OnHold: 'در انتظار تایید'
            },
            REQUEST_STATUS: {
                NEW: 'جدید',
                PROCESSING: 'در حال پردازش',
                PENDING: 'در حال بررسی',
                ACCEPTED: 'تایید شده',
                REJECTED: 'رد شده',
                PAYMENT: 'پرداخت',
                DONE: 'انجام شده',
                DELETED: 'حذف شده',
                FAILED: 'ناموفق',
                REFUND: 'بازگشت وجه',
                Paying: "پرداخت",
            },
            REQUEST_STATUS_DIRECT_DEPOSIT: {
                Done: 'انجام شده',
                Refunded: 'بازگشت وجه',
            },
            REQUEST_STATUS_CRYPTO: {
                New: 'جدید',
                Processing: 'در حال پردازش',
                Accepted: 'در حال پردازش',
                Failed: 'رد شده',
                Completed: 'تایید شده',
                Broadcast: 'در حال پردازش',
                Pending: 'در انتظار',
                Sending: 'در حال ارسال',
                AwatingApproval: 'در انتظار تأیید',
                Paying: 'پرداخت',
                Done: 'تایید شده',
                Canceled: 'لغو شده',
                Failure: 'ناموفق',
                Exception: 'ناموفق',
                Scheduled: 'در حال پردازش'
            },
            GATE_WAY_REQUEST_STATUS: {
                New: "جدید",
                Cancel: 'کنسل شده',
                Paid: 'پرداخت شده',
                Verified: 'تایید شده',
                ExpireToken: 'توکن منقضی شده',
                ExpireRequest: 'درخواست منقضی شده',
                Refund: 'ریفاند'
            },
            ONLINE_PAYMENT_STATUS: {
                INCOMPLETE: 'تکمیل نشده',
                FAILED: 'ناموفق',
                SUCCESS: 'موفق',
                REFUND: 'بازگشت مبلغ'
            },
            DIRECT_DEPOSIT_PAYMENT_STATUS: {
                PENDING: 'در حال بررسی',
                NO_CONFIRMED: 'تایید نشده',
                ACCEPTED: 'موفق',
                Refund: 'بازگشت مبلغ',
                REJECTED: 'رد شده',
                AWAITINGAPPROVAL: 'منتظر تایید',
                FAILURE: 'ناموفق',
                NOTFOUND: 'پیدا نشد',
                CANCELED: 'لغو شده',
                COMPLETED: 'کامل شده',
                Incomplete: 'تکمیل نشده',
            },
            POINT_CHANGE_TYPE: {
                WithdrawalPoints: 'امتیازهای برداشت شده',
                ReceivedPoints: 'امتیاز های دریافت شده'
            },
            GATEWAY_ACTION_TYPE: {
                Deposit: 'شارژ',
                Withdraw: 'برداشت',
                50: 'شارژ',
                100: 'برداشت'
            },
            SETTLEMENT_STATUS_TYPE: {
                New: 'جدید',
                Completed: 'تکمیل شده',
                Failed: 'شکست خورده',
                1: 'جدید',
                2: 'تکمیل شده',
                3: 'شکست خورده',
            },
            TRANSACTION_TYPES: {
                BUY_SERVICE: 'خرید پول الکترونیک',
                SELL_SERVICE: 'فروش پول الکترونیک',
                EXCHANG_ESERVICE: 'مبادله پول الکترونیک',
                DEPOSIT: 'شارژ',
                WITHDRAWAL: 'برداشت',
                BETWEEN_MY_WALLETS: 'بین کیف پول ها',
                INTERNAL_TRANSFER: 'انتقال داخلی',
                CHARGE_SMS_PANEL: 'شارژ پنل پیامکی',
                WITHDRAWAL_POINT: 'برداشت امتیاز',
                VOUCHER_SERVICE: 'سرویس ووچر',
                CHARGE_WALLET_CREDIT: 'شارژ اعتباری کیف پول',
                TC_PAY_GATEWAY: 'درگاه پرداخت TC',
                WalletCorrectionRequest: 'تصحیح کیف پول',
                PointCorrectionRequest: 'تصحیح امتیاز',
                Transition: 'انتقال',
                TerminalSettlement: 'تسویه اتوماتیک',
                BrokerDeposit: 'واریز از کارگزار',
                DirectDeposit: 'حواله بانکی',
                LOCK_WALLET: 'قفل کردن کیف پول',
                UNLOCK_WALLET: 'باز کردن قفل کیف پول',
                P2P_INTERNAL_TRANSFER: 'انتقال داخلی P2P',
                P2P_PENALTY: 'جریمه P2P',
                AffiliateProgram: 'برنامه افیلیت',
                P2PCommission: 'کمیسیون P2P',
                CryptoDeposit: 'شارژ ارز دیجیتال',
                CryptoWithdrawal: 'برداشت ارز دیجیتال',
            },
            NOTIFICATION_TYPE: {
                Deposit: 'شارژ',
                Withdrawal: 'برداشت',
                Send: 'ارسال',
                Receive: 'دریافت',
                Exchange: 'تبدیل',
                Point: 'امتیاز',
                Voucher: 'ووچر',
                RequestMessage: 'پیام درخواست',
                Ticket: 'تیکت',
                ExpertTicket: 'تیکت پشتیبان',
                Friend: 'دوستان',
                ContactUs: 'تماس با ما',
                VerifyInfo: 'تایید اطلاعات',
                VerifyBankAccount: 'تایید حساب بانکی',
                WalletChange: 'کیف پول',
                DirectDeposit: 'حواله بانکی',
                PointChange: 'تغیر امتیاز',
                P2P: 'P2P',
                Crypto: 'شارژ ارز دیجیتال',
                CryptoWithdraw: 'برداشت ارز دیجیتال',
                Chat: 'چت'
            },
            REQUEST_TYPE_VALIDATION: {
                0: 'شارژ از طریق پول الکترونیک',
                1: 'شارژ از طریق ارز پولی',
                2: 'مبادله ارز پولی',
                3: 'مبادله ی پول الکترونیک',
                4: 'برداشت امتیاز',
                5: 'ارسال ارز پولی',
                6: 'ارسال از کیف پول خود',
                7: 'خرید ووچر',
                8: 'برداشت پول الکترونیک',
                9: 'برداشت ارز پولی'
            },
            REQUEST_TYPE: {
                1: 'شارژ',
                2: 'برداشت',
                3: 'ارسال',
                4: 'تبدیل',
                5: 'امتیاز',
                6: 'ووچر'
            },
            REQUEST_TYPE_ACTICE_REQUESTS: {
                1: 'شارژ',
                2: 'برداشت',
                3: 'ارسال',
                4: 'ارسال',
                5: 'برداشت',
                6: 'شارژ',
                7: 'تبدیل',
                8: 'پنل پیامکی',
                9: 'امتیاز',
                10: 'ووچر'
            },
            INVITEE_STATUS: {
                CLEARED: 'تسویه شده ',
                OUTSTANDING: 'تسویه نشده ',
            },
            POINT_SORT_OPTION: {
                Newest: 'جدید‌ترین',
                Oldest: 'قدیمی‌ترین',
                MostPoints: 'بیشترین امتیاز',
                LeastPoints: 'کمترین امتیاز'
            }
        },
        VALIDATION: {
            INVALID: '{{name}} معتبر نیست',
            MIN_LENGTH: 'حداقل حروف مجاز برای {{name}} ({{value}}) حرف می باشد',
            MAX_LENGTH: 'حداکثر حرف مجاز برای {{name}} ({{value}}) حرف می باشد',
            AGREEMENT_REQUIRED: 'تایید قوانین و مقررات الزامی می باشد',
            NOT_FOUND: 'درخواست مورد نظر یافت نشد',
            REQUIRED: 'وارد کردن {{name}} الزامی می باشد',
            INVALID_FIELD: 'مقدار وارد شده برای {{name}} معتبر نیست',
            FILE_MAX_SIZE: 'حجم فایل مورد نظر بیشتر از حد مجاز است.',
            FILE_EXTENSION: 'فرمت فایل انتخاب شده صحیح نمی باشد.',
            SELECT: 'انتخاب {{name}}  الزامی می باشد',
            SELECTION_REQUIRED: 'انتخاب یک گزینه الزامی است',
            REQUIRED_FIELD: 'پر کردن این فیلد الزامی است.',
        },
        USER: {
            ACCOUNT: {
                BANK: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                BLOCKED: 'حساب بانکی',
                                REJECTED: 'حساب بانکی',
                                ACCEPTED: 'حساب بانکی'
                            },
                            BODY: {
                                BLOCKED: 'حساب {{0}} شما مسدود شد.',
                                REJECTED: 'اطلاعات حساب {{0}} شما رد شد.',
                                ACCEPTED: 'اطلاعات حساب {{1}} شما تایید شد.'
                            }
                        }
                    }
                }
            },
            CREDIT: {
                POINT: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                CORRECTION_INCREASE: 'افزایش امتیاز',
                                CORRECTION_DECREASE: 'کسر امتیاز'
                            },
                            BODY: {
                                CORRECTION_INCREASE: 'امتیاز بابت اصلاحیه به مجموع امتیازات شما اضافه شد.',
                                CORRECTION_DECREASE: 'امتیاز بابت اصلاحیه از مجموع امتیازات شما کسر شد.'
                            }
                        }
                    }
                }
            },
            ALERT: {
                ERROR: {
                    TRY_COUNT_EXPIRED_OR_KEY_NOT_FOUND: 'کد وارد‌شده اشتباه است.'
                }
            }
        },
        FRIEND: {
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        NEW_REQUEST: 'درخواست دوستی',
                        NEW_REQUEST_TO_NOT: 'درخواست دوستی',
                        ACCEPTED: 'درخواست دوستی',
                        REJECTED: 'درخواست دوستی',
                        CANCEL: 'درخواست دوستی'

                    },
                    BODY: {
                        NEW_REQUEST: 'درخواست جدیدی از طرف {{0}} برای شما ارسال شده است.',
                        ACCEPTED: 'درخواست دوستی شما توسط {{0}} تایید شد.',
                        REJECTED: 'درخواست دوستی شما توسط {{0}} رد شد.',
                        CANCEL: 'درخواست دوستی شما توسط {{0}} حذف شد.'
                    }
                }
            }
        },
        WALLET: {
            ACCOUNT_NUMBER: 'شماره حساب',
            DIACTIVE: 'غیرفعال',
            WALLET: 'کیف پول',
            WALLET_NAME: 'نام کیف پول',
            WALLETS: 'کیف پول ها',
            WALLET_TYPE: 'نوع کیف پول',
            WHO_CAN_SEE_MY_WALLET: 'مشاهده توسط',
            CHOOSE_CURRENCY: 'نوع ارز',
            CRYPTO_CURRENCY: 'رمزارز',
            CRYPTO_CURRENCIES: 'رمز ارزها',
            FIAT: 'فیات',
            CRYPTO_WALLETS: 'کیف پول های رمزارز',
            FIAT_WALLETS: 'کیف پول های فیات',
            TEXT: 'متن',
            TRANSIT: 'کیف پول های پس انداز',
            SAVING: 'کیف پول های عبوری',
            VIEW_FRIENDS: 'دوستان',
            NOBODY: 'خصوصی',
            EVERYONE: 'همه',
            NEW_WALLET: 'ایجاد کیف پول',
            EDIT_WALLET: 'ویرایش کیف پول',
            EDIT_WALLETS: 'ویرایش کیف پول',
            TC_WALLETS: 'کیف پول TC',
            TRANSACTIONS: 'تراکنش ها',
            TRANSACTION_TYPE: 'نوع تراکنش',
            CHANGE_TYPE: 'نوع تغییر',
            SELECT_WALLET_FOR_REPORTING: 'لطفا اول کیف پول را انتخاب کنید',
            SELECT_DATE_FOR_REPORTING: 'لطفا تاریخ شروع و پایان را انتخاب کنید حداکثر بازه مجاز 31 روز می باشد.',
            LOCK_MESSAGE: 'کیف پول شما قفل شده لطفا جهت پیگیری با بخش پشتیبانی تماس حاصل نمایید.',
            CURRENCY_IS_DEACTIVE: ' امکان استفاده از این کیف پول به علت عدم سرویس یا اختلال در نرخ ارز مقدور نمی باشد. لطفا تا برطرف نمودن آن صبور باشید.',
            SUPPORT_TICKET: 'تیکت پشتیبانی',
            DESCRIPTION: 'توضیحات',
            MY_WALLETS: 'کیف پول های من',
            SEEN_USER_REQURED: 'لطفا انتخاب کنید چه کسانی اجازه ی دیدن کیف پول شما را دارند',
            BALANCE: 'موجودی',
            INVOICE_NUMBER: 'شماره فاکتور',
            INFO_USER: 'کیف‌پول‌های <span>{{dispalyName}}</span> <span>({{email}})</span>',
            WALLET_OWNERSHIP_CERTIFICATE_RETRIEVAL: 'دریافت گواهی کیف پول‌ها',
            WITHDRAWABLE_AMOUNT: 'مبلغ قابل برداشت:',
            WITHDRAWABLE_USDT: 'تتر قابل برداشت:',
            ALERT: {
                SUCCESS_ADD: 'کیف پول با موفقیت ایجاد گردید',
                SUCCESS_EDIT: 'ویرایش کیف پول با موفقیت انجام شد',
                CANT_USE_WALLET_FOR_INTERNAL_TANSFER: 'از این کیف پول برای انتقال داخلی نمی توانید استفاده کنید',
                BALANCE_IS_LOW: 'موجودی کیف پول شما کافی نیست',
                EXPORT_TRANSACTION_HINT: 'حداکثر بازه ی مجاز برای خروجی گرفتن یک ماه می باشد .',
                FOR_CREATE_WALLET_YOU_NEED_VERIFY: 'برای ایجاد کیف پول ابتدا باید مراحل اهراز هویت خود در سایت را انجام دهید.',
                THERE_IS_NO_WALLET_TO_DISPLAY: 'هیچ کیف پولی جهت نمایش وجود ندارد',
                USDT_MERGED_WITH_USD_NOTICE: 'کیف پول تتر شما ادغام شده است. نگران نباشید، تمام دارایی‌های شما کاملاً محفوظ است و به صورت خودکار به کیف پول جدید منتقل شده‌ است.',
            },
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        DECREASE: 'کاهش موجودی کیف پول',
                        INCREASE: 'افزایش موجودی کیف پول',
                        PG_DECREASE: 'مبلغ {{0}} از کیف پول {{1}} از طریق درگاه TC با شماره پیگیری {{2}} برداشت شد.',
                        PG_INCREASE: 'مبلغ {{0}} به کیف پول {{1}} از طریق درگاه TC با شماره پیگیری {{2}} واریز شد.',
                        CORRECTION_DECREASE: 'میلغ {{0}} بابت اصلاحیه از کیف پول {{1}} کسر شد.',
                        CORRECTION_INCREASE: 'میلغ {{0}} بابت اصلاحیه به کیف پول {{1}} واریز شد.',
                        IPG_SETTLEMENT_INCREASE: 'مبلغ  {{0}} {{4}} به کیف پول ریالی  شما اضافه شد'
                    },
                    BODY: {
                        PG_DECREASE: 'مبلغ {{0}} از کیف پول {{1}} از طریق درگاه TC با شماره پیگیری {{2}} برداشت شد.',
                        PG_INCREASE: 'مبلغ {{0}} به کیف پول {{1}} از طریق درگاه TC با شماره پیگیری {{2}} واریز شد.',
                        CORRECTION_DECREASE: 'میلغ {{0}} بابت اصلاحیه از کیف پول {{1}} کسر شد.',
                        CORRECTION_INCREASE: 'میلغ {{0}} بابت اصلاحیه به کیف پول {{1}} واریز شد.',
                        IPG_SETTLEMENT_INCREASE: 'مبلغ  {{0}} {{4}} به کیف پول ریالی  شما اضافه شد'
                    }
                }
            }
        },
        SUPPORT: {
            ANNOUNCEMENT: {},
            TICKET: {
                DISABLED_NEW_TICKET_MESSAGE: 'کاربر گرامی ارسال تیکت جدید غیر فعال می باشد، لطفا برای ارتباط با پشتیبانی از بخش چت آنلاین سایت استفاده نمایید.',
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            CLOSED: 'تیکت',
                            ADD_REPLY: 'تیکت',
                            EXPERT_TICKET: 'تیکت کارشناس'
                        },
                        BODY: {
                            CLOSED: 'تیکت با شماره {{0}} توسط کارشناسان بسته شد.',
                            ADD_REPLY: 'برای تیکت با شماره {{0}} پاسخ جدیدی توسط کارشناسان ثبت شده است.',
                            EXPERT_TICKET: 'از طرف کارشناسان برای شما تیکت ثبت شده است.'
                        }
                    }
                }
            },
            CHAT: {
                TRACKING_NUMBER: "شماره پیگیری",
                SELLER: 'فروشنده',
                BUYER: 'خریدار',
                TRANSACTIONS: 'معامله',
                SUCCESS: 'موفق',
                SUPPORT: 'پشتیبانی',
                WRITE_YOUR_MESSAGE_HERE: 'پیام خود را اینجا بنویسید...',
                CONFIRM_AND_START_CHAT: 'تایید و شروع چت',
                THIS_CONVERSATION_HAS_ENDED: 'این مکالمه پایان یافته است.',
                SHOW_ALL: 'نمایش همه',
                SHOW_LESS: 'نمایش کمتر',
                CHAT_WITH_SELLER: 'چت با فروشنده',
                CHAT_WITH_BUYER: 'چت با خریدار',
                GROUP_YESTERDAY: 'دیروز',
                GROUP_TODAY: 'امروز',
                RULES: {
                    RULE_ONE: {
                        TITLE: 'تأیید هویت طرفین',
                        TEXT_ONE: 'شما تأیید می‌کنید که نقش خود را به‌عنوان خریدار یا فروشنده به‌درستی مشخص کرده‌اید.',
                        TEXT_TWO: 'هرگونه استفاده از هویت جعلی، معرفی نادرست، یا تلاش برای فریب طرف مقابل ممنوع است.',
                    },
                    RULE_TWO: {
                        TITLE: 'حفظ امنیت و محرمانگی',
                        TEXT_ONE: 'در مکالمه از ارسال اطلاعات حساس، محرمانه، یا شخصی که می‌تواند برای سوءاستفاده استفاده شود خودداری کنید.',
                        TEXT_TWO: 'مسئولیت حفاظت از اطلاعات خود بر عهده‌ی شماست.',
                    },
                    RULE_THREE: {
                        TITLE: 'رفتار مسئولانه و قانونی',
                        TEXT_ONE: 'هرگونه تهدید، توهین، مطالبه غیرقانونی، درخواست خلاف قوانین کشور، یا رفتار غیرحرفه‌ای ممنوع است.',
                        TEXT_TWO: 'توافقات مالی یا معاملاتی باید شفاف، قابل پیگیری و مطابق با قوانین باشد.',
                    },
                    RULE_FOUR: {
                        TITLE: 'پرهیز از انتقال وجه خارج از چارچوب امن',
                        TEXT_ONE: 'تا زمانی که شرایط معامله نهایی و روشن نباشد، از انتقال هرگونه وجه خودداری کنید.',
                        TEXT_TWO: 'در صورت نیاز، تنها از روش‌های امن معرفی‌شده توسط پلتفرم استفاده شود.',
                    },
                    RULE_FIVE: {
                        TITLE: 'شفافیت در معامله',
                        TEXT_ONE: 'فروشنده موظف است جزئیات کالا یا خدمت، قیمت نهایی، شرایط تحویل و موارد احتمالی را به‌صورت شفاف اعلام کند.',
                        TEXT_TWO: 'خریدار موظف است شرایط، انتظارات و نیازهای خود را روشن بیان کند.',
                    },
                    RULE_SIX: {
                        TITLE: 'امکان مداخله تیم پشتیبانی',
                        TEXT_ONE: 'تیم پشتیبانی در هر زمان و بدون اطلاع قبلی حق ورود به مکالمه را دارد.',
                        TEXT_TWO: 'در صورت مشاهده رفتار مشکوک، نقض قوانین، یا درخواست یکی از طرفین، پشتیبانی می‌تواند گفتگو را بررسی، محدود یا متوقف کند.',
                    },

                    INTERNAL_CHAT_ONLY: "تمامی مکاتبات مرتبط با معامله فقط از طریق چت داخلی پلتفرم انجام شود.",
                    EXTERNAL_CHANNEL_FORBIDDEN: "انتقال گفتگو به هر کانال خارج از پلتفرم ممنوع است و در بررسی اختلافات معتبر نخواهد بود.",
                    CONTACT_SHARING_FORBIDDEN: "ارسال شماره تماس، آی‌دی شبکه‌های اجتماعی یا انتقال گفتگو به خارج از پلتفرم ممنوع است.",
                    UNPROFESSIONAL_MESSAGE_WARNING: "از ارسال پیام‌های غیرحرفه‌ای و غیر استاندارد یا درخواست تغییر شرایط معامله خودداری کنید.",
                    DISPUTE_EVIDENCE_POLICY: "در صورت بروز اختلاف، فقط مدارک و اطلاعات ثبت‌شده در چت داخلی پلتفرم مبنای بررسی و تصمیم‌گیری خواهند بود.",
                },
                REPORT_VIOLATION: 'گزارش تخلف',
                CONVERSATION_BLOCKED: 'گفت و گو مسدود شده',
                THIS_CONVERSATION_HAS_BEEN_CLOSED_BY_AN_ADMIN: 'این مکالمه توسط ادمین بسته شده است.',
                REPORT_OF_RULE_VIOLATION: 'گزارش نقض قوانین',
                REPORT_OF_RULE_VIOLATION_TEXT: 'اگر هرگونه فعالیت مشکوکی را مشاهده کردید، خواهشمندیم که به سرعت کاربر مربوطه را گزارش دهید. این اقدام به ما کمک می‌کند تا بتوانیم به طور مؤثر و سریع اقدامات لازم را انجام دهیم و امنیت و سلامت محیط کاربری را حفظ کنیم. همکاری شما در این زمینه بسیار ارزشمند است.',
                CONFIRM: 'تایید',
                EDIT: 'ویرایش',
                ENTER_THE_DESCRIPTION: 'توضیحات را وارد کنید...',
                WE_ARE_REVIEWING_YOUR_REPORT: 'گزارش شما قبلاً دریافت شده و در حال حاضر در حال بررسی است',
                REPORT_OF_RULE_VIOLATION_WARN: 'گزارش نقض قوانین',
                REPORT_OF_RULE_VIOLATION_WARN_TEXT: 'رفتار یا محتوای شما با بخشی از قوانین و استانداردهای پلتفرم سازگار نبوده است. این گزارش می‌تواند به دلایلی مانند نقض دستورالعمل‌های ایمنی، ارتباطات نامناسب، یا فعالیت‌های غیرمجاز ثبت شده باشد. لطفاً قوانین را مرور کنید و در تعاملات بعدی از آن‌ها پیروی کنید تا از تکرار این وضعیت جلوگیری شود.',
                CONFIRM_AND_CONTINUE_CHAT: 'تایید و ادامه چت',
                REASON_REPORT: {
                    offPlatform: 'معامله خارج پلتفرم',
                    shareContact: 'اشتراک‌گذاری تماس',
                    abuse: 'به‌کاربردن زبان توهین‌آمیز',
                    illegal: 'انجام عمل کلاهبرداری',
                    spam: 'ارسال پیام هرزنامه',
                    threat: 'ایجاد تهدید یا اخاذی',
                },
                ALERTS: {
                    TITLE_SUCCESSFULL_REPORT: 'گزارش با موفقیت ارسال شد.',
                    DESCRIPTION_SUCCESSFULL_REPORT: 'از شما بابت اقدام‌تان سپاسگزاریم. متخصصان ما درحال بررسی گزارش شما هستند.',
                }
            }
        },
        ADV_BANNER: {
            ADV_BANNER_BANNER: 'پیشنهاد تی سی به شما'
        },
        CRYPTO_DEPOSIT: {
            DIALOG_ALERT: {
                TITLE_CHANGE_ADDRESS: 'تغییر آدرس‌های واریز تتر',
                BIG_DESCRIPTION_CHANGE_ADDRESS: 'آدرس‌های واریز تتر شما از 3 فوریه (15 بهمن) تغییر می‌کنند.',
                TEXT_ONE: 'از این تاریخ:',
                TEXT_TWO: 'فقط از آدرس‌های جدید در همین صفحه استفاده کنید.',
                TEXT_THREE: 'واریز به آدرس‌های قدیمی مسئولیت شخصی شما خواهد بود.',
                GOT_IT: 'متوجه شدم',
            },
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        CRYPTO_DEPOSIT: "دریافت (کیف پول)"
                    },
                    BODY: {
                        CRYPTO_DEPOSIT: "مبلغ <span class=\"fa-number-dir\">&rlm;{{0}}</span> درشبکه <span>{{1}}</span> با شناسه‌ی تراکنش <span>{{2}}</span> دریافت شد."
                    }
                }
            }
        },
        CRYPTO_WITHDRAW: {
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        CRYPTO_WITHDRAW: 'برداشت از کیف پول'
                    },
                    BODY: {
                        CRYPTO_WITHDRAW: 'مبلغ <span class=\"fa-number-dir\">&rlm;{{0}}</span> در شبکه <span>{{1}}</span> با شماره‌ی پیگیری <span>{{2}}</span> برداشت شد.'
                    }
                },
            }
        },
        APPLICATION_PWA: {
            TEXT: 'اپلیکیشن تاپ‌چنج',
            INSTALL: 'نصب',
            UPDATE_VERSION: 'یک نسخه جدید آماده است. برای دریافت آخرین تغییرات، همین حالا بروزرسانی کنید.',
            UPDATE: 'بروزرسانی',
            ALERTS_PAGE: {
                UPDATE: 'به‌روزرسانی',
                NEED_UPDATE_TEXT: 'برای بهبود تجربه شما، ویژگی‌های جدید و تغییراتی در عملکرد برنامه ایجاد کرده‌ایم. پیشنهاد می‌کنیم برنامه خود را به‌روزرسانی کنید.',
                FORCE_UPDATE_TEXT: 'برای حفظ امنیت حساب کاربری و دسترسی بدون وقفه به خدمات، لطفا برنامه خود را به آخرین نسخه به‌روزرسانی کنید. این کار فقط چند لحظه زمان می‌برد.',
                LATER: 'بعداً',
                SERVICE_DISABLED_TITLE: 'قطع خدمات',
                SERVICE_DISABLED_TEXT: 'فعالیت این نسخه از برنامه به پایان رسیده است و دیگر پشتیبانی نمی‌شود. از همراهی شما در این مدت صمیمانه سپاسگزاریم. اگر موجودی باقی‌مانده یا سوالی درباره حساب خود دارید، لطفاً فوراً با پشتیبانی تماس بگیرید.',
                EXIT_APP: 'خروج از برنامه',
                DEVICE_IS_ROOTED_TITLE: 'دسترسی به برنامه مسدود شد',
                DEVICE_IS_ROOTED_TEXT: 'به منظور حفظ امنیت حساب و دارایی‌های شما، اجرای TopChange بر روی دستگاه‌های دارای دسترسی Root امکان‌پذیر نیست.',
            },
            BIOMETRIC: {
                TITLE: 'TopChange',
                SUB_TITLE: 'برای ورود تایید هویت کنید',
                CANCEL: 'انصراف',
                SAVE_TITLE: "ذخیره رمز عبور",
                SAVE_DESC: "برای ورود سریع‌تر، رمز عبور خود را ذخیره کنید.",
                SAVE_CONFIRM: "ذخیره",
                SAVE_CANCEL: "نه، ممنون"
            },
            FILE_DOWNLOAD: {
                SUCCESS_IOS: "فایل در پوشه Documents ذخیره شد",
                SUCCESS_ANDROID: "فایل در پوشه Downloads ذخیره شد",
                ERROR: "خطا در دانلود فایل",
            },
        },
        DASHBOARD_NEW: {
            KYC_VERIFICATION: {
                TEXT: 'لطفاً برای دسترسی به خدمات تی‌سی و فعال‌سازی واریزها، خرید ارز دیجیتال و مجوزهای معامله، احراز هویت خود را تکمیل کنید.',
                AUTHENTICATION: 'احراز هویت',
                CONTINUE: 'ادامه',
                ALERT_KYC_TITLE: 'شما نمیتوانید از این قابلیت استفاده کنید',
                ALERT_KYC_TEXT: 'برای دسترسی به خدمات تی‌سی٬ ابتدا احراز هویت کنید.',
            },
            ACTIVE_REQUEST: {
                TITLE_ACTIVE_REQUEST: 'درخواست‌های فعال',
                VIEW: 'مشاهده',
                AMOUNT_AND_TYPE: 'نوع و مبلغ',
                CHANGE_STATUS_DATE: 'زمان تغییر وضعیت',
                YOU_HAVE_NO_ACTIVE_REQUESTS: 'شما درخواست فعالی ندارید.',
            },
            EXCHANGE_RATE: {
                TILTE_EXCHANGE_RATE: 'نرخ تبدیل',
                BUY: 'خرید:',
                SELL: 'فروش:',
                NOT_FOUND_SEARCH: ' نتیجه‌ای برای جستجوی شما پیدا نشد.<br /> لطفاً نام ارز دیگری را امتحان کنید.',
                SEARCH: 'اعمال'
            },
            DIALOG_MARATHON: {
                TITLE: 'ماراتن سود شروع شد!',
                DESC_ONE: 'با خرید یا فروش <span class="bold">تتر</span> توی <span class="en-number">P2P</span>، وارد رقابت شو و جایزه ببر!',
                DESC_TWO: 'فقط تا 27 خرداد فرصت داری!',
                COMPETITION_INFORMATION: 'اطلاعات مسابقه',
                BUY_ADS: 'خرید آگهی'
            }
        },
        KYC_AUTH_NEW: {
            MOBILE_PHONE: 'تلفن همراه',
            IDENTITY_INFORMATION: 'اطلاعات هویتی',
            COMMITMENT_LETTER: 'تایید تعهدنامه',
            AUTHENTICATION: 'احراز هویت',
            TEXT_STEPPER: 'لطفا مراحل زیر را برای تایید احراز هویت خود تکمیل کنید.',
            PHONE_STEP_DESC: 'لطفا تلفن همراهی که متعلق به خودتان است را وارد کنید.',
            COUNTRY: 'کشور',
            CONFIRM_CODE: 'تایید کد',
            CHANGE_NUMBER: 'تغییر شماره',
            DESCRIPTION_CONFIRM_PHONE_NUMBER_DIALOG: 'لطفاً کد ارسال‌شده به <strong class="dltr">{{value}}</strong> را وارد کنید.',
            YOUR_PROFILE_IS_INCOMPLETE: 'پروفایل شما تکمیل نیست',
            DESCRIPTION_KYC_ALERT_DIALOG: 'برای نمایش اطلاعات در پروفایل، لطفاً ابتدا احراز هویت را انجام دهید.',
            IDENTITY_INFO: {
                DESC_START_KYC: 'هنگامی که آماده بودید، روی «شروع» بزنید تا فرآیند آغاز شود.',
                TITLE_NOT_COMPLETE_KYC: 'اطلاعات هویتی تکمیل نشده',
                DESC_NOT_COMPLETE_KYC: 'کاربر گرامی شما هنوز فرایند احراز هویت خود را تکمیل نکرده اید، هنگامی که آماده بودید، روی «ادامه» بزنید تا فرآیند آغاز شود.',
                START: 'شروع',
                CONTINUE: 'ادامه',
                TITLE_PENDING_CHECK_KYC: 'در حال بررسی اطلاعات هویتی',
                DESC_PENDING_CHECK_KYC: ' کاربر گرامی مدارک شما با موفقیت بارگذاری شده و توسط کارشناسان درحال بررسی است، لطفا صبور باشید',
                LIST_INFO_FOR_KYC: {
                    TITLE_PERSONAL_INFO: 'اطلاعات شخصی',
                    DESC_PERSONAL_INFO: 'اطلاعات شخصی خود (نام و نام خانوادگی، شماره ملی، تاریخ تولد، جنسیت) را به زبان فارسی مطابق با مدرک ارسالی وارد کنید.',
                    TITLE_DOCUMENTS: 'مدارک هویتی',
                    DESC_DOCUMENTS: 'لطفاً یکی از موارد ( کارت ملی٬ گذرنامه٬ گواهینامه) را انتخاب و تصویر آن را آپلود کنید، لطفا از منقضی نبودن و یا سالم بودن آن قبل از ارسال عکسی با کیفیت اطمینان حاصل فرمایید.',
                    TITLE_FACE_VERIFICATION: 'تأیید چهره',
                    DESC_FACE_VERIFICATION: 'احراز هویت تصویری به سادگی با چرخاندن سر برای چند لحظه در مقابل دوربین انجام میشود.',
                },
                PHONE_NUMBER_INFO_EDIT: {
                    TILTE_IDENTITY_INFO_DOES_NOT_MATCH: 'اطلاعات هویتی با مالک شماره تلفن همخوانی ندارند',
                    DESC_IDENTITY_INFO_DOES_NOT_MATCH: 'کاربر گرامی مدارک ارسالی شما متعلق به مالک شماره تلفنی که وارد کردید نیست، لطفا پس از وارد کردن شماره تلفنی که متعلق به شماست دوباره تلاش کنید.',
                    DOCUMENTS: 'مدارک',
                    INFO_DOCUMENTS_UPLOADED: 'مدارکی که شما بارگذاری کرده‌اید به این صورت است:',
                    FULL_NAME: 'نام و نام خانوادگی',
                    DATE_OF_BIRTH: 'تاریخ تولد',
                    NATIONAL_CODE: 'کد ملی',
                    PENDING_REVIEW_PHONE_NUMBER: 'شماره شما در حال بررسی است لطفا صبور باشید',
                },
                REJECTED: {
                    TITLE: 'احراز هویت ناموفق',
                    MESSAGE_TEXT: 'کاربر گرامی٬ متاسفانه مشکلاتی در روند احراز هویت شما پیدا شده، لطفا برای ادامه با پشتیبانی تماس بگیرید.',
                    CONTACT_SUPPORT: 'تماس با پشتیبانی',
                },
            },
            COMMITMENT_CONFIRMATION: {
                CONFIRMATION_OF_THE_COMMITMENT_LETTER: 'تایید تعهدنامه',
                SUB_TEXT_CONFIRMATION_OF_THE_COMMITMENT_LETTER: 'برای تکمیل فرایند احراز هویت، لطفاً تعهدنامه را تأیید نمایید.',
                TEXT_CONFIRM_COMMITMENT_LETTER: ' اینجانب {{name}} با شماره ملی {{nationalIdentityNumber}} مدارک خود را جهت احراز هویت در سایت (TopChange) ارسال کرده‌ام و با آگاهی کامل موارد زیر را تأیید می‌کنم:',
                CONFIRM: 'تایید',
                ITEM_COMMITMENT_LETTER: {
                    TITLE_ONE: 'تأیید هویت شخصی',
                    DESC_ONE: 'ثبت‌نام و ارسال مدارک توسط شخص من انجام شده است و مدارک هویتی خود را در اختیار هیچ فرد دیگری قرار نداده‌ام.',
                    TITLE_TWO: 'مسئولیت استفاده از حساب کاربری',
                    DESC_TWO: 'متعهد می‌شوم که حساب کاربری خود را به‌صورت شخصی استفاده کنم و اطلاعات بانکی و هویتی خود را در اختیار هیچ فردی قرار ندهم. همچنین از دریافت پول نقد یا ارز دیجیتال به هر شکلی از سوی دیگران در ازای استفاده از حساب کاربری‌ام خودداری خواهم کرد.',
                    TITLE_THREE: 'پذیرش مسئولیت‌های قانونی',
                    DESC_THREE: 'در صورت بروز هرگونه استفاده غیرمجاز از حساب، از جمله دریافت سپرده‌های غیرقانونی، مسئولیت کامل آن را می‌پذیرم و در صورت بروز تخلف، مسئولیت قانونی و قضایی آن، از جمله مجازات‌های مقرر و جبران خسارت شاکی، بر عهده اینجانب است.',
                }
            },
            DIALOG_AUTH_SUCCESS: {
                TITLE: 'احراز هویت موفق',
                DESC: 'کاربر گرامی مراحل احراز هویت شما با موفقیت انجام شده است، و شما میتوانید از امکانات تاپچنج استفاده کنید.',
                PROFILE: 'پروفایل'
            }
        },
        DIALOG_CONTACT_SUPPORT: {
            TITLE: 'تماس با کارشناسان TopChange',
            DESC: 'کاربر گرامی، لطفا برای کسب اطلاعات بیشتر و یا با کارشناسان ما از یکی از روش های زیر در ارتباط باشید.',
        },
        NEW_PROFILE: {
            EMPTY_CONTENT: 'محتوایی برای نمایش وجود ندارد.',
            TABS: {
                SECURITY: 'امنیت',
                AUTH: 'احراز هویت',
                ACCOUNTS: 'حساب‌ها',
                POINTS: 'امتیاز‌ها',
                REQUESTS: 'درخواست‌ها',
            },
            SECTION_HEAD_PROFILE: {
                LAST_LOGIN: 'آخرین ورود:',
                TITLE_CONFIRM_TWO_FACTOR: 'تایید دو مرحله‌ای',
                TITLE_ANTI_PHISHNG: 'کد آنتی فیشینگ',
                TITLE_LOCAL_TIME: 'زمان محلی',
                DESC_LOCAL_TIME: 'لطفا زمان محلی که در حال استفاده از تی‌سی هستید را وارد کنید.',
                TITLE_DEFAULT_LANGUAGE: 'زبان پیش‌فرض',
                DESC_DEFAULT_LANGUAGE: 'لطفا زبان پیش‌فرض را انتخاب کنید، این زبان درفرستادن ایمیل، و اعلانات تی‌سی برای شما لحاظ میگردد.',
                ACTIVATED: 'فعال شده',
                NOT_ACTIVED: 'فعال نشده',
                CONFIRM: 'تایید',
                CANCEL: 'لغو',
            },
            SECURITY: {
                TITLE_ADVANCE_SETTING: 'تنظیمات امنیتی پیشرفته',
                TITLE_CONFIRM_TWO_FACTOR: 'تایید دو مرحله‌ای',
                DESC_CONFIRM_TWO_FACTOR: 'احراز هویت دو مرحله‌ای با استفاده از Google Authenticator.',
                ACTIVE_BTN: 'فعال کردن',
                DEACTIVE_BTN: 'غیرفعال کردن',
                EDIT_BTN: 'ویرایش',
                TITLE_ANTI_PHISHNG: 'کد آنتی فیشینگ',
                DESC_ANTI_PHISHNG: 'اطمینان حاصل کنید که ایمیل های اطلاع رسانی شما فقط از Topchange دریافت شده است.',
                DESC_2FA_DIALOG_DISABLE: 'کد ارسال‌شده به برنامه را برای غیرفعال‌سازی 2FA وارد کنید.',
                RECENT_HISTORY: {
                    SECURITY_HISTORY: 'تاریخچه امنیتی',
                    SECURITY_HISTORY_EMPTY: 'در حال حاضر تاریخچه امنیتی وجود ندارد.',
                    RECENT_LOGIN_HISTORY: 'ورودهای اخیر',
                    CHANGE_PASSWORD: 'تغییر رمز عبور',
                    IP: 'IP',
                    TYPE: 'نوع',
                    TIME: 'زمان',
                    ONLINE: 'آنلاین',
                    OFFLINE: 'آفلاین',
                    DEVICE_TYPE: 'نوع دستگاه',
                    STATUS: 'وضعیت',
                    SECURITY_RECENT_LOGINS_HISTORY_EMPTY: 'در حال حاضر تاریخچه ورودهای اخیر وجود ندارد.',
                    TYPES: {
                        Register: 'ثبت نام',
                        Login: 'ورود',
                        Login2FA: 'ورود با کد دو مرحله‌ای',
                        SendRegisterCode: 'ارسال کد ثبت نام',
                        VerifyRegisterCode: 'تایید کد ثبت نام',
                        ChangePassword: 'تغییر رمز عبور',
                    }
                },
                CHANGE_PASSWORD: {
                    TITLE_CHANGE_PASSWORD: 'تغییر رمز عبور',
                    DESC_DIALOG_CHANGE_PASS: ' رمز عبور فعلی را وارد کرده و یک رمز جدید تعیین کنید.',
                    CURRENT_PASSWORD: 'رمز عبور فعلی',
                    NEW_PASSWORD: 'رمز عبور جدید',
                    REPEAT_NEW_PASSWORD: 'تکرار رمز عبور جدید',
                    PASSWORDS_NOT_MATCH: 'رمز‌های عبور جدید همخوانی ندارند.',
                    FORGET_CURRENT_PASSWORD: 'فراموشی رمز عبور فعلی',
                    FORGET_PASS_DIALOG_DESC: 'لطفا برای بازیابی رمز عبور یکی از روش‌های زیر را انتخاب کنید.',
                    SEND_CODE_TO_EMAIL: 'ارسال کد به ایمیل',
                    FORGET_PASS_DESCRIPTIN_CONFIRM_CODE: 'کد ارسال‌شده به ایمیل {{email}} را برای بازیابی رمز عبور وارد کنید.',
                    DESC_DIALOG_FORGOT_PASS: 'لطفا یک رمز جدید تعیین کنید.'
                }
            },
            AUTH: {
                YOUR_INFORMATION: 'اطلاعات شما',
                EXPIRETION_DATE: 'تاریخ انقضا احراز هویت شما :',
                MOBILE_PHONE_NUMBER: 'شماره تلفن همراه',
                CHANGE_PHONE_NUMBER: 'تغییر شماره تلفن',
                PENDING_REVIEW_PHONE_NUMBER: 'شماره شما در حال بررسی است لطفا صبور باشید',
                PAGE_CHANGE_PHONE_NUMBER: {
                    DESC_ENTER_MOBILE_MATCH: 'لطفا تلفن همراهی که مالکیت آن با اطلاعات شما همخوانی دارد را وارد کنید.'
                }
            },
            TWO_FACTOR_AUTH: {
                SUCCESSFUL_OPERATION_DESC: 'فعال‌سازی تایید دو مرحله‌ای شما با موفقیت انجام شد.',
                SUCCESSFUL_OPERATION_DESC_EDIT: 'غیرفعال‌سازی تایید دو مرحله‌ای شما با موفقیت انجام شد.',
                DOWNLOAD_APP: {
                    DOWNLOAD_THE_APP: 'دانلود اپلیکیشن',
                    DESC_PAGE_DOWNLOAD_APP: 'با نصب یکی از برنامه‌های <span class="en-number">2FA</span>، امنیت حساب خود را افزایش دهید. این برنامه‌ها کدهای یک‌بار مصرف تولید می‌کنند تا از دسترسی غیرمجاز جلوگیری شود.',
                    GOOGLE_AUTH: 'Google Authenticator',
                    GOOGLE_AUTH_DESC: 'پیشنهاد ما٬ ساده، سریع و بدون نیاز به اینترنت.',
                    OTHER_PROGRAMS: 'سایر برنامه‌ها',
                    OTHER_PROGRAMS_DESC: 'متنوع، قابل‌اعتماد و مناسب نیازهای خاص.',
                    NEXT_STEP: 'مرحله بعد',
                    DIALOG: {
                        DOWNLOAD_APP: 'دانلود برنامه',
                        DOWNLOAD_APP_DESC: 'لطفا دوربین گوشی خود را بر روی QR کد بگیرید تا برنامه مورد نظر را دانلود کنید.',
                    }
                },
                BACKUP_KEY: {
                    SCAN_THE_CODE: 'اسکن کد',
                    SCAN_THE_QR_CODE_IN_THE_AUTH_APP: 'کد QR کد را در اپلیکیشن Authenticator اسکن نمایید.',
                    GENERATE_CODE: 'ایجاد کد',
                    DESC_EXPIRED_CODE: 'کد قبلی شما منقضی شده است٬ لطفا کد جدید ایجاد کنید.',
                    DESC_USE_CODE: 'اگر قادر به اسکن کد QR نیستید ، لطفاً این کد را به صورت دستی در برنامه وارد کنید.',
                    TITLE_SAVE_SECURITY_KEY: 'کلید امنیتی را ذخیره کنید!',
                    DESC_SAVE_SECURITY_KEY: 'در صورت حذف برنامه، فقط با این کلید می‌توانید حساب خود را بازیابی کنید.',
                },
            },
            ANTI_PHISHING: {
                DESCRIPTIN_CONFIRM_CODE: 'کد ارسال‌شده به ایمیل {{email}} را برای فعال‌سازی کد آنتی‌فیشینگ وارد کنید.',
                TITLE_EDIT: 'ویرایش کد آنتی‌فیشینگ',
                TITLE_ENABLE: 'فعال‌سازی کد آنتی‌فیشینگ',
                SUBTITLE_DESC: 'لطفاً عبارت آنتی‌فیشینگ دلخواه خود را وارد کنید.',
                INFO_ITEM_ONE_TITLE: 'کد آنتی‌فیشینگ چیست؟',
                INFO_ITEM_ONE_DESC: 'کدی است که خودتان انتخاب می‌کنید تا به کمک آن ایمیل‌های واقعی تاپ‌چنج را از ایمیل‌های جعلی تشخیص دهید.',
                INFO_ITEM_TWO_TITLE: 'این کد چطور از شما محافظت می‌کند؟',
                INFO_ITEM_TWO_DESC: 'در تمام ایمیل‌های رسمی تاپ‌چنج، این کد نمایش داده می‌شود. اگر ایمیلی کد شما را نداشت، احتمال جعلی بودن آن بالاست.',
                ANTI_PHISHING_PHARSE: 'عبارت آنتی فیشینگ',
                SUCCESSFUL_OPERATION_DESC: 'کد آنتی فیشینگ با موفقیت ثبت شد.',
                SUCCESSFUL_OPERATION_DESC_EDIT: 'کد آنتی فیشینگ با موفقیت تغییر یافت.',
                VALIDATE: {
                    INVALID_CHAR: 'عدد و حروف',
                    INVALID_LENGTH: 'بین 4 تا 15 حرف',
                },
            },
            ACCOUNTS: {
                ACCOUNTS: 'حساب‌ها',
                BANK: 'بانکی',
                E_MONEY: 'پول الکترونیک',
                SEARCH_NOT_FOUND: 'موردی یافت نشد',
                CREATE_ACCOUNT: 'ایجاد حساب',

                DEACTIVE_DIALOG: {
                    DESCRIPTION: 'آیا از غیر‌فعال‌کردن حساب خود اطمینان دارید؟',
                    DEACTIVE_BTN: 'غیر‌فعال کردن',
                    DEACTIVE_ALERT_TEXT: 'غیر‌فعال سازی حساب شما با موفقیت انجام شد.',
                    ACTIVE_ALERT_TEXT: 'فعال سازی حساب شما با موفقیت انجام شد.',
                },
                BANK_DATA: {
                    IBAN_NUMBER: 'شماره شبا:',
                    YOU_DO_NOT_HAVE_A_REGISTRED_BANK_CARD: 'شما کارت بانکی ثبت شده‌ای ندارید.',
                    CRUD: {
                        CREATE_NEW_BANK_ACCOUNT: 'ساخت حساب بانکی جدید',
                        ALERT_CARD_FOR_USER: 'لطفا در وارد کردن شماره کارت دقت فرمایید، این شماره باید به نام خودتان باشد.',
                        HINT_IBAN_NUMBER: 'لطفا در وارد کردن شماره شبا دقت فرمایید، زیرا پس از ثبت قابل ویرایش نیست.',
                        BANK_ACCOUNT: 'حساب بانکی',
                        INVALID_BANK_ACCOUNT: 'حساب بانکی نامعتبر',
                        INVALID_BANK_ACCOUNT_DESC: 'در حساب بانکی ثبت شده شما مغایراتی وجود داشت، لطفا پس از اطمینان دوباره تلاش کنید.',
                        APPLY_CHANGES: 'اعمال تغییرات',
                        THE_IBAN_NUMBER_CANNOT_BE_EDITED: 'شماره شبا قابل ویرایش نیست.',
                    }
                },
                ACCOUNT_HISTORY: {
                    TITLE: 'تاریخچه حساب',
                    HISTORY_DESCRIPTION: 'در این قسمت میتوانید تاریخچه واریز و برداشت از حساب خود را مشاهده کنید.',
                    EMPTY_TRANSACTION: 'شما تا به حال تراکنشی نداشته‌اید.',
                    MOUNTH: 'ماه',
                    AMOUNT_IN_RIAL: 'مبلغ به ریال',
                    AMOUNT_IN_DOLLAR: 'مبلغ به تی‌سی‌دی',
                    WITHDRAWAL: 'برداشت',
                    DEPOSIT: 'واریز',
                },
                E_MONEY_DATA: {
                    YOU_DO_NOT_HAVE_A_REGISTRED_ACCOUNT: 'شما حساب پول الکترونیک ثبت شده‌ای ندارید.',
                    CREATE_NEW_ACCOUNT: 'ساخت حساب الکترونیک جدید',
                    ACCOUNT_OWNERS_NAME: 'نام صاحب حساب',
                    ELECTRONIC_ACCOUNT: 'حساب الکترونیک',
                    DELETE_ACCOUNT: 'حذف حساب شما با موفقیت انجام شد.'
                }
            },
            POINT_TRANSACTIONS: {
                DEPOSIT_TO_WALLETS: 'برداشت امتیاز',
                MINIMUM_POINT_WITHDRAWN: 'حداقل امتیاز قابل برداشت <span>{{value}}</span> امتیاز است.',
                TRANSACTION_POINTS: 'تراکنش‌های امتیاز',
                SEARCH_TRACKING_NUMBER: 'جستجو شماره پیگیری',
                POINTS_WITHDRAWAL: 'برداشت امتیاز',
                PLEASE_SELECT_WALLET: 'لطفا یک کیف پول را جهت ادامه انتخاب کنید.',
                WITHDRAWAL_POINTS: 'امتیاز برداشتی',
                WITHDRAWAL_POINTS_MIN_DESC: 'امتیاز مورد نظر جهت برداشت را وارد نمایید. حداقل امتیاز قابل برداشت {{value}} است.',
                EVERY_VALUE_POINT: 'هر {{value}} امتیاز',
                AMOUNT_RECEIVED: 'مبلغ دریافتی:',
                CONFIRM_REQUEST: 'تایید درخواست',
                CONFIRM_REQUEST_DESC_DIALOG: 'جهت ثبت درخواست، صحت اطلاعات را بررسی و تائید نمایید.',
                WITHDRAWABLE_POINTS: 'امتیاز برداشتی',
                VALUE_OF_VALUE_POINT: 'ارزش {{value}} امتیاز',
                DEPOSIT: 'واریز',
                ACCEPT_POINT_WITHDRAW: 'صحت اطلاعات فوق را میپذیرم.',
                ALERT_SUCCESS_POINT: 'برداشت امتیاز با موفقیت انجام و مبلغ به کیف پول مورد نظر واریز شد.',
                MORE: 'ادامه …',
                VALIDATION: {
                    MINIMUM_POINT_WITHDRAWN: 'حداقل امتیاز قابل برداشت {{value}} امتیاز است.',
                    MAXIMUM_POINT_WITHDRAWN: 'حداکثر امتیاز قابل برداشت {{value}} امتیاز است.',
                }
            }
        },
        SHARED_COMPONENTS: {
            DIALOGS: {
                INACCESSIBILITY: 'عدم دسترسی',
                INACCESSIBILITY_DESC: 'در صورت عدم دسترسی به ایمیل لطفا با پشتیبانی تماس بگیرید.',
                VERIFY_EMAIL: 'تایید ایمیل',
                VERIFY_EMAIL_DESC: 'لطفا برای ادامه کد تایید را به <span>{{email}}</span> ارسال کنید.',
                CONFIRM_CODE: 'تایید کد',
                EMAIL_VERIFY_CODE_DESC: 'لطفاً کد ارسال‌شده به <span>{{email}}</span> را وارد کنید.',
                TWO_FACTOR_AUTH_VERIFY_CODE_DESC: 'کد درحال نمایش در برنامه <span class="en-number">2FA</span> را وارد کنید.',
                CHECK_SPAM_TEXT: 'لطفاً پوشه اسپم خود را نیز بررسی کنید.'
            },
            DATEPICKER: {
                DEFAULT_RANGES: 'بازه‌های پیش‌فرض',
                TODAY: 'امروز',
                YESTERDAY: 'دیروز',
                LAST_WEEK: 'هفت روز گذشته',
                THIS_WEEK: 'این هفته',
                LAST_MONTH: 'سی روز گذشته',
                THIS_MONTH: 'این ماه',
                LAST_30_DAYS: 'سی روز گذشته',
                PREVIOUS_QUARTER: 'فصل پیش',
                LAST_YEAR: 'سال پیش',
                THIS_YEAR: 'امسال',
                MONTH: 'ماه',
                DAY: 'روز',
                YEAR: 'سال',
                TO: 'تا',
                EXACT_DATE: 'تاریخ دقیق',
                HOUR: 'ساعت',
                MINUTE: 'دقیقه',
                SECOND: 'ثانیه',
                FROM: 'از',
                SELECT_DATES: 'انتخاب تاریخ'
            }
        },
        CHAT: {
            P2P: {
                USER: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: 'پیام جدید در چت <span class="en-number">P2P</span>'
                        },
                        BODY: {
                            MESSAGE: 'سفارش <span>{{2}}</span>'
                        }
                    }
                }
            }
        },
        SOCIAL_MEDIA: {
            TELEGRAM: 'تلگرام',
            CHANNEL_LINK_TELEGRAM: 'کانال تلگرامی تاپ چنج',
            DESC_TELEGRAM: 'برای دریافت آخرین اخبار، اطلاعیه‌های مهم و ارتباط مستقیم با تیم پشتیبانی، به کانال رسمی ما بپیوندید.',
            APARAT: 'آپارات',
            DESC_APARAT: 'ویدیوهای آموزشی، معرفی محصولات و مستندات تصویری فعالیت‌های شرکت را در کانال آپارات ما تماشا کنید.',
            CHANNEL_LINK_APARAT: 'کانال آپارات تاپ چنج',
        },
    }
}
